import React, { useState, useEffect, useContext, useRef, useCallback, useMemo } from 'react';
import axios from 'axios';
import api from '../../api';
import Swal from 'sweetalert2';
import { AuthContext } from '../../components/AuthContext';
import Select from 'react-select';
import { FaTimes, FaEdit, FaPrint, FaEye, FaSync, FaArrowDown, FaFileDownload, FaWhatsapp } from 'react-icons/fa';
import MasterSelection from '../../components/MasterSelection';
import VisitorVisitSelector from '../../components/VisitorVisitSelector';
import ItemSelectionModal from '../../components/ItemSelectionModal';
import { toast } from 'react-toastify';

const QuotationNewManagement = () => {
  const { user } = useContext(AuthContext);
  const [isDarkMode, setIsDarkMode] = useState(() => localStorage.getItem('darkMode') === 'true');
  const addCommas = (num) => {
  if (num === undefined || num === null) return "0.00";
  return parseFloat(num).toLocaleString('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

// Helper function to check if a value is empty or just whitespace
const isEmpty = (value) => {
  return !value || value === '' || (typeof value === 'string' && value.trim() === '');
};

  // Add global style to ensure dropdowns are properly displayed and custom scrollbar
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      .react-select__menu-portal {
        z-index: 99999 !important;
      }
      .react-select__menu {
        z-index: 99999 !important;
      }
      .select__menu-portal {
        z-index: 99999 !important;
      }
      .select__menu {
        z-index: 99999 !important;
      }
      
      /* Custom Scrollbar Styles */
      .custom-scrollbar::-webkit-scrollbar {
        width: 6px;
      }
      
      .custom-scrollbar::-webkit-scrollbar-track {
        background: rgba(243, 244, 246, 0.5);
        border-radius: 10px;
      }
      
      .custom-scrollbar::-webkit-scrollbar-thumb {
        background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
        border-radius: 10px;
        transition: all 0.3s ease;
      }
      
      .custom-scrollbar::-webkit-scrollbar-thumb:hover {
        background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
      }
      
      /* Firefox scrollbar */
      .custom-scrollbar {
        scrollbar-width: thin;
        scrollbar-color: #6366f1 rgba(243, 244, 246, 0.5);
      }
      
      /* Enhanced animations */
      @keyframes shimmer {
        0% {
          background-position: -1000px 0;
        }
        100% {
          background-position: 1000px 0;
        }
      }
      
      .shimmer {
        background: linear-gradient(
          90deg,
          transparent,
          rgba(255, 255, 255, 0.4),
          transparent
        );
        background-size: 1000px 100%;
        animation: shimmer 2s infinite;
      }
      
      /* Enhanced card hover effects */
      .quotation-card {
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      }
      
      .quotation-card:hover {
        transform: translateY(-4px);
        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
      }
      
      /* Gradient animations */
      @keyframes gradientShift {
        0% {
          background-position: 0% 50%;
        }
        50% {
          background-position: 100% 50%;
        }
        100% {
          background-position: 0% 50%;
        }
      }
      
      .gradient-animate {
        background-size: 200% 200%;
        animation: gradientShift 3s ease infinite;
      }
      
      /* Filter section animations */
      .filter-section {
        transition: all 0.3s ease;
      }
      
      .filter-section.expanded {
        max-height: 1000px;
        opacity: 1;
      }
      
      .filter-section.collapsed {
        max-height: 0;
        opacity: 0;
        overflow: hidden;
      }
      
      /* Status badge animations */
      .status-badge {
        transition: all 0.2s ease;
        position: relative;
        overflow: hidden;
      }
      
      .status-badge::before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);
        transition: left 0.5s;
      }
      
      .status-badge:hover::before {
        left: 100%;
      }
      
      /* Loading skeleton improvements */
      .skeleton {
        background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
        background-size: 200% 100%;
        animation: loading 1.5s infinite;
      }
      
      @keyframes loading {
        0% {
          background-position: 200% 0;
        }
        100% {
          background-position: -200% 0;
        }
      }
      
      /* Smooth transitions for view mode changes */
      .view-transition {
        transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
      }
      
      /* Interactive elements */
      .interactive-btn {
        transition: all 0.2s ease;
        transform: scale(1);
      }
      
      /* Enhanced tablet/touch support */
      .react-select__option {
        cursor: pointer !important;
        touch-action: manipulation !important;
        -webkit-tap-highlight-color: transparent !important;
      }
      .react-select__option:active {
        transform: scale(0.98);
      }
      .react-select__control {
        touch-action: manipulation !important;
        -webkit-tap-highlight-color: transparent !important;
      }
      
      @media (hover: none) and (pointer: coarse) {
        button, .react-select__option, .react-select__control {
          min-height: 44px !important;
          touch-action: manipulation !important;
          -webkit-tap-highlight-color: transparent !important;
        }
        button:active {
          transform: scale(0.95) !important;
          transition: transform 0.1s ease !important;
        }
        .react-select__option:active {
          background-color: #3b82f6 !important;
          color: white !important;
        }
        .react-select__control:active {
          border-color: #3b82f6 !important;
        }
      }
      
      /* Improved touch targets for small screens */
      @media (max-width: 768px) {
        button {
          min-height: 48px !important;
          min-width: 48px !important;
          padding: 12px 16px !important;
        }
        .react-select__control {
          min-height: 48px !important;
        }
        .react-select__option {
          min-height: 48px !important;
          padding: 12px 16px !important;
        }
        .react-select__value-container {
          padding: 8px 12px !important;
        }
      }
      
      .interactive-btn:hover {
        transform: scale(1.05);
      }
      
      .interactive-btn:active {
        transform: scale(0.98);
      }
      
      /* Custom focus styles */
      .custom-focus:focus {
        outline: none;
        ring: 2px;
        ring-color: #3b82f6;
        ring-offset: 2px;
        ring-offset-color: #ffffff;
      }
    `;
    document.head.appendChild(style);
    
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  // Sync dark mode with localStorage
  useEffect(() => {
    const interval = setInterval(() => {
      const savedMode = localStorage.getItem('darkMode');
      setIsDarkMode(savedMode === 'true');
    }, 500);
    return () => clearInterval(interval);
  }, []);

  // Sync cross-tab clipboard
  useEffect(() => {
    const handleStorage = (e) => {
      if (e.key === 'quotation_clipboard_item') {
        try { setCopiedItem(e.newValue ? JSON.parse(e.newValue) : null); } catch {}
      }
      if (e.key === 'quotation_clipboard_section') {
        try { setCopiedSection(e.newValue ? JSON.parse(e.newValue) : null); } catch {}
      }
    };
    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, []);

  // Inject dark mode CSS for inputs, textareas, labels, and gray text inside the page wrapper
  useEffect(() => {
    const styleId = 'quotation-dark-mode-css';
    let el = document.getElementById(styleId);
    if (isDarkMode) {
      if (!el) {
        el = document.createElement('style');
        el.id = styleId;
        document.head.appendChild(el);
      }
      el.textContent = `
        .quotation-dark-page input:not([type=checkbox]):not([type=radio]) {
          background-color: #374151 !important; border-color: #4b5563 !important; color: #f3f4f6 !important;
        }
        .quotation-dark-page input:not([type=checkbox]):not([type=radio])::placeholder { color: #9ca3af !important; }
        .quotation-dark-page input:not([type=checkbox]):not([type=radio]):focus {
          border-color: #60a5fa !important; box-shadow: 0 0 0 2px rgba(96,165,250,0.2) !important; background-color: #374151 !important;
        }
        .quotation-dark-page textarea {
          background-color: #374151 !important; border-color: #4b5563 !important; color: #f3f4f6 !important;
        }
        .quotation-dark-page textarea::placeholder { color: #9ca3af !important; }
        .quotation-dark-page textarea:focus { border-color: #60a5fa !important; box-shadow: 0 0 0 2px rgba(96,165,250,0.2) !important; }
        .quotation-dark-page label { color: #d1d5db !important; }
        .quotation-dark-page select { background-color: #374151 !important; border-color: #4b5563 !important; color: #f3f4f6 !important; }
        .quotation-dark-page .border-gray-200 { border-color: #374151 !important; }
        .quotation-dark-page .border-gray-300 { border-color: #4b5563 !important; }
        .quotation-dark-page .border-t.border-gray-200\\/50 { border-color: rgba(75,85,99,0.5) !important; }
        .quotation-dark-page .text-xs.text-gray-600, .quotation-dark-page .text-xs.text-gray-500 { color: #9ca3af !important; }
        .quotation-dark-page .text-xs.font-semibold.text-gray-600 { color: #d1d5db !important; }
        .quotation-dark-page .text-xs.font-semibold.text-gray-700 { color: #d1d5db !important; }
        .quotation-dark-page .text-sm.text-gray-500 { color: #6b7280 !important; }
        .quotation-dark-page .text-sm.text-gray-600 { color: #9ca3af !important; }
        .quotation-dark-page .text-sm.font-semibold.text-gray-700 { color: #d1d5db !important; }
        .quotation-dark-page .text-sm.font-medium.text-gray-700 { color: #d1d5db !important; }
        .quotation-dark-page .text-lg.font-semibold.text-gray-700 { color: #d1d5db !important; }
        .quotation-dark-page .text-xs.text-gray-700 { color: #d1d5db !important; }
        .quotation-dark-page button.bg-gray-200 { background-color: #374151 !important; color: #d1d5db !important; }
        .quotation-dark-page button.hover\\:bg-gray-300:hover { background-color: #4b5563 !important; }
        .quotation-dark-page .bg-gray-50:not(.quotation-skip-dark) { background-color: #1f2937 !important; }
        .quotation-dark-page .bg-gray-100 { background-color: #1f2937 !important; }
        .quotation-dark-page .text-gray-800 { color: #e5e7eb !important; }
        .quotation-dark-page .text-gray-700:not(.bg-clip-text) { color: #d1d5db !important; }
        .quotation-dark-page .text-amber-800 { color: #fde68a !important; }
        .quotation-dark-page .text-amber-700 { color: #fcd34d !important; }
        .quotation-dark-page .bg-amber-200\/60 { background-color: rgba(120,53,15,0.4) !important; color: #fde68a !important; }
        .quotation-dark-page .border-t { border-top-color: #374151 !important; }
        .quotation-dark-page .border-b { border-bottom-color: #374151 !important; }
        /* ── Item row display boxes ── */
        .quotation-dark-page [class*="bg-gray-50/80"], .quotation-dark-page [class*="bg-gray-50\\/80"] { background-color: #374151 !important; color: #d1d5db !important; }
        .quotation-dark-page [class*="bg-blue-50/80"], .quotation-dark-page [class*="bg-blue-50\\/80"] { background-color: rgba(30,58,138,0.25) !important; }
        .quotation-dark-page [class*="bg-orange-50/80"], .quotation-dark-page [class*="bg-orange-50\\/80"] { background-color: rgba(124,45,18,0.3) !important; }
        .quotation-dark-page [class*="bg-green-50/80"], .quotation-dark-page [class*="bg-green-50\\/80"] { background-color: rgba(6,78,59,0.25) !important; }
        .quotation-dark-page [class*="bg-gray-100/80"], .quotation-dark-page [class*="bg-gray-100\\/80"] { background-color: #374151 !important; }
        .quotation-dark-page [class*="bg-white/70"], .quotation-dark-page [class*="bg-white\\/70"] { background-color: rgba(55,65,81,0.9) !important; border-color: #4b5563 !important; }
        .quotation-dark-page [class*="bg-white/80"], .quotation-dark-page [class*="bg-white\\/80"] { background-color: rgba(55,65,81,0.9) !important; border-color: #4b5563 !important; }
        .quotation-dark-page [class*="bg-white/90"], .quotation-dark-page [class*="bg-white\\/90"] { background-color: #374151 !important; border-color: #4b5563 !important; color: #f3f4f6 !important; }
        .quotation-dark-page [class*="from-purple-50"] { background: rgba(88,28,135,0.2) !important; }
        .quotation-dark-page [class*="from-pink-50"] { background: rgba(131,24,67,0.15) !important; }
        .quotation-dark-page .text-blue-700:not(.bg-clip-text) { color: #60a5fa !important; }
        .quotation-dark-page .text-purple-700:not(.bg-clip-text) { color: #c084fc !important; }
        .quotation-dark-page .text-purple-600:not(.quotation-skip-dark) { color: #c084fc !important; }
        .quotation-dark-page .text-indigo-600:not(.quotation-skip-dark) { color: #a5b4fc !important; }
        .quotation-dark-page .text-indigo-400 { color: #a5b4fc !important; }
        .quotation-dark-page .text-purple-300 { color: #d8b4fe !important; }
        .quotation-dark-page .text-green-800 { color: #4ade80 !important; }
        .quotation-dark-page .text-gray-500 { color: #9ca3af !important; }
        /* ── Validation messages ── */
        .quotation-dark-page .text-red-500 { color: #f87171 !important; }
        .quotation-dark-page .text-blue-600 { color: #60a5fa !important; }
        .quotation-dark-page .text-orange-600 { color: #fb923c !important; }
        .quotation-dark-page .text-green-600:not(.quotation-skip-dark) { color: #4ade80 !important; }
        .quotation-dark-page .border-red-300 { border-color: #991b1b !important; }
        .quotation-dark-page .bg-red-50\/80, .quotation-dark-page [class*="bg-red-50/80"], .quotation-dark-page [class*="bg-red-50\\/80"] { background-color: rgba(127,29,29,0.2) !important; }
        .quotation-dark-page .border-orange-300 { border-color: #9a3412 !important; }
        .quotation-dark-page .border-green-300 { border-color: #166534 !important; }
        .quotation-dark-page .bg-gray-200\/70, .quotation-dark-page [class*="bg-gray-200/70"] { background-color: rgba(55,65,81,0.7) !important; }
        /* ── Modal panels ── */
        .quotation-dark-page .qm-modal { background: #1f2937 !important; color: #f3f4f6 !important; }
        .quotation-dark-page .qm-modal .bg-white { background-color: #1f2937 !important; }
        .quotation-dark-page .qm-modal .sticky { background-color: #1f2937 !important; border-color: #374151 !important; }
        .quotation-dark-page .qm-modal .bg-green-50 { background-color: rgba(6,78,59,0.2) !important; }
        .quotation-dark-page .qm-modal .bg-orange-50 { background-color: rgba(124,45,18,0.2) !important; }
        .quotation-dark-page .qm-modal .bg-red-50 { background-color: rgba(127,29,29,0.2) !important; }
        .quotation-dark-page .qm-modal .bg-red-100 { background-color: rgba(127,29,29,0.25) !important; }
        .quotation-dark-page .qm-modal .bg-purple-50 { background-color: rgba(88,28,135,0.2) !important; }
        .quotation-dark-page .qm-modal .bg-blue-50 { background-color: rgba(30,58,138,0.15) !important; }
        .quotation-dark-page .qm-modal .bg-indigo-100 { background-color: rgba(55,48,163,0.3) !important; }
        .quotation-dark-page .qm-modal .bg-blue-100 { background-color: rgba(30,58,138,0.3) !important; }
        .quotation-dark-page .qm-modal .bg-purple-100 { background-color: rgba(88,28,135,0.3) !important; }
        .quotation-dark-page .qm-modal .bg-yellow-50 { background-color: rgba(113,63,18,0.2) !important; }
        .quotation-dark-page .qm-modal .bg-gray-300 { background-color: #4b5563 !important; color: #d1d5db !important; }
        .quotation-dark-page .qm-modal [class*="from-white"] { background: #374151 !important; }
        .quotation-dark-page .qm-modal [class*="from-blue-50"] { background: rgba(30,64,175,0.15) !important; }
        .quotation-dark-page .qm-modal [class*="from-green-50"] { background: rgba(6,78,59,0.15) !important; }
        .quotation-dark-page .qm-modal [class*="from-orange-50"] { background: rgba(124,45,18,0.15) !important; }
        .quotation-dark-page .qm-modal [class*="from-gray-100"] { background: #374151 !important; color: #d1d5db !important; border-color: #4b5563 !important; }
        .quotation-dark-page .qm-modal .border-gray-200 { border-color: #374151 !important; }
        .quotation-dark-page .qm-modal .border-gray-300 { border-color: #4b5563 !important; }
        .quotation-dark-page .qm-modal .border-blue-200 { border-color: #1e40af !important; }
        .quotation-dark-page .qm-modal .border-green-200 { border-color: #166534 !important; }
        .quotation-dark-page .qm-modal .border-orange-200 { border-color: #9a3412 !important; }
        .quotation-dark-page .qm-modal .border-purple-200 { border-color: #6b21a8 !important; }
        .quotation-dark-page .qm-modal .text-gray-900 { color: #f9fafb !important; }
        .quotation-dark-page .qm-modal .text-blue-700 { color: #60a5fa !important; }
        .quotation-dark-page .qm-modal .text-blue-800 { color: #93c5fd !important; }
        .quotation-dark-page .qm-modal .text-blue-900 { color: #bfdbfe !important; }
        .quotation-dark-page .qm-modal .text-indigo-800 { color: #a5b4fc !important; }
        .quotation-dark-page .qm-modal .text-green-700 { color: #4ade80 !important; }
        .quotation-dark-page .qm-modal .text-orange-700 { color: #fb923c !important; }
        .quotation-dark-page .qm-modal .text-red-700 { color: #f87171 !important; }
        .quotation-dark-page .qm-modal .text-red-600 { color: #f87171 !important; }
        .quotation-dark-page .qm-modal .text-purple-700 { color: #c084fc !important; }
        .quotation-dark-page .qm-modal .text-purple-800 { color: #d8b4fe !important; }
        .quotation-dark-page .qm-modal .text-yellow-800 { color: #fde68a !important; }
        .quotation-dark-page .qm-modal .hover\\:bg-blue-50\\/50:hover { background-color: rgba(30,58,138,0.12) !important; }
        .quotation-dark-page .qm-modal .hover\\:bg-gray-100:hover { background-color: #374151 !important; }
        .quotation-dark-page .qm-modal .hover\\:bg-gray-300:hover { background-color: #4b5563 !important; }
        /* ── Quotation list cards ── */
        .quotation-dark-page .quotation-card { background-color: #1f2937 !important; border-color: #374151 !important; color: #e5e7eb !important; }
        .quotation-dark-page .quotation-card .text-xl.font-bold.text-gray-800 { color: #f3f4f6 !important; }
        .quotation-dark-page .quotation-card .text-lg.font-bold.text-gray-800 { color: #f3f4f6 !important; }
        .quotation-dark-page .quotation-card .text-gray-600 { color: #9ca3af !important; }
        .quotation-dark-page .quotation-card .text-gray-700 { color: #d1d5db !important; }
        .quotation-dark-page .quotation-card .font-medium { color: #e5e7eb; }
        .quotation-dark-page .quotation-card .bg-gray-50 { background-color: #374151 !important; }
        .quotation-dark-page .quotation-card .bg-gray-100 { background-color: #374151 !important; color: #d1d5db !important; }
        .quotation-dark-page .quotation-card .text-lg.font-semibold.text-gray-800 { color: #e5e7eb !important; }
        .quotation-dark-page .quotation-card [class*="from-green-50"] { background: rgba(6,78,59,0.25) !important; }
        .quotation-dark-page .quotation-card [class*="to-emerald-50"] { background: rgba(6,78,59,0.25) !important; }
        .quotation-dark-page .quotation-card .text-green-600 { color: #4ade80 !important; }
        .quotation-dark-page .quotation-card .bg-green-100 { background-color: rgba(6,78,59,0.3) !important; }
        .quotation-dark-page .quotation-card .text-green-700 { color: #4ade80 !important; }
        .quotation-dark-page .quotation-card .bg-yellow-100 { background-color: rgba(113,63,18,0.3) !important; }
        .quotation-dark-page .quotation-card .text-yellow-700 { color: #fde68a !important; }
        .quotation-dark-page .quotation-card .bg-blue-50 { background-color: rgba(30,58,138,0.2) !important; }
        .quotation-dark-page .quotation-card .text-blue-700 { color: #60a5fa !important; }
        .quotation-dark-page .quotation-card .bg-indigo-50 { background-color: rgba(55,48,163,0.2) !important; }
        .quotation-dark-page .quotation-card .text-indigo-700 { color: #a5b4fc !important; }
        .quotation-dark-page .quotation-card .border-gray-100 { border-color: #374151 !important; }
        .quotation-dark-page .quotation-card .bg-orange-50 { background-color: rgba(124,45,18,0.2) !important; }
        .quotation-dark-page .quotation-card .border-orange-200 { border-color: rgba(124,45,18,0.4) !important; }
        .quotation-dark-page .quotation-card .text-orange-700 { color: #fb923c !important; }
        .quotation-dark-page .quotation-card .text-orange-500 { color: #f97316 !important; }
        .quotation-dark-page .quotation-card .text-sm.text-gray-500 { color: #6b7280 !important; }
        .quotation-dark-page .quotation-card .text-sm.text-gray-600 { color: #9ca3af !important; }
        .quotation-dark-page .quotation-card .text-xs.text-gray-500 { color: #9ca3af !important; }
        .quotation-dark-page .quotation-card .hover\\:bg-blue-50:hover { background-color: rgba(30,58,138,0.2) !important; }
        .quotation-dark-page .quotation-card .hover\\:bg-green-50:hover { background-color: rgba(6,78,59,0.2) !important; }
        .quotation-dark-page .quotation-card .hover\\:bg-purple-50:hover { background-color: rgba(88,28,135,0.2) !important; }
        .quotation-dark-page .quotation-card .hover\\:bg-indigo-50:hover { background-color: rgba(55,48,163,0.2) !important; }
        .quotation-dark-page .quotation-card .hover\\:bg-indigo-100:hover { background-color: rgba(55,48,163,0.3) !important; }
        /* ── Skeleton loader ── */
        .quotation-dark-page .animate-pulse { background-color: #1f2937 !important; border-color: #374151 !important; }
        .quotation-dark-page .animate-pulse .bg-gray-300 { background-color: #374151 !important; }
        /* ── Empty state ── */
        .quotation-dark-page .text-gray-900 { color: #f3f4f6 !important; }
        .quotation-dark-page .text-gray-400 { color: #6b7280 !important; }
        /* ── Pagination ── */
        .quotation-dark-page .bg-gray-200 { background-color: #374151 !important; color: #d1d5db !important; }
        .quotation-dark-page .hover\\:bg-gray-300:hover { background-color: #4b5563 !important; }
        /* ── Filter section ── */
        .quotation-dark-page .bg-green-600 { background-color: #059669 !important; }
        .quotation-dark-page .border-gray-300 { border-color: #4b5563 !important; }
        .quotation-dark-page .bg-white:not(.quotation-skip-dark) { background-color: #1f2937 !important; }
        .quotation-dark-page option { background-color: #1f2937 !important; color: #e5e7eb !important; }
        /* ── Status badges ── */
        .quotation-dark-page .status-badge.bg-green-100 { background-color: rgba(6,78,59,0.35) !important; }
        .quotation-dark-page .status-badge.bg-red-100 { background-color: rgba(127,29,29,0.35) !important; }
        .quotation-dark-page .status-badge.bg-yellow-100 { background-color: rgba(113,63,18,0.35) !important; }
        .quotation-dark-page .text-green-800 { color: #4ade80 !important; }
        .quotation-dark-page .text-red-800 { color: #fca5a5 !important; }
        .quotation-dark-page .text-yellow-800 { color: #fde68a !important; }
        /* ── Sort controls ── */
        .quotation-dark-page .border-t.border-gray-200 { border-top-color: #374151 !important; }
        /* ── Quick stats in list tab ── */
        .quotation-dark-page .text-yellow-600 { color: #fbbf24 !important; }
        .quotation-dark-page .text-red-600:not(.quotation-skip-dark) { color: #f87171 !important; }
      `;
    } else {
      if (el) el.remove();
    }
  }, [isDarkMode]);

  const [employees, setEmployees] = useState([]);
  const [references, setReferences] = useState([]);
  const [loading, setLoading] = useState(false);
  
  const selectRef = useRef(null);
  const offerTypeSelectRef = useRef(null);
  const sectionNameRefs = useRef([]);
  const unitSelectRefs = useRef([]);
  const quantityInputRefs = useRef([]);

  const [quotationPage, setQuotationPage] = useState(0);
  const [quotationLimit] = useState(10);
  const [totalQuotations, setTotalQuotations] = useState(0);
  const [quotations, setQuotations] = useState([]);
  const quotationTotalPages = Math.ceil(totalQuotations / quotationLimit);

  // Available units for items
  const availableUnits = [
    'pcs', 'box', 'bag', 'pkt', 'pair', 'roll', 'set', 'bkt', 
    'mtr', 'sh', 'can', 'kg', 'ltr', 'bundles', 'bottle', 
    'drums', 'sq.ft', 'sq.mtr', 'fts', 'nos', 'rft'
  ];

  const [offerType, setOfferType] = useState([]);
  const [modalVisibleForOfferType, setModalVisibleForOfferType] = useState(false);
  const [modalVisible, setModalVisible] = useState({ open: false, func: null });
  const [showRecipientModal, setShowRecipientModal] = useState(false);

  const [edit, setEdit] = useState(false);
  const [selectedQuotationId, setSelectedQuotationId] = useState(null);
  const [statusDialog, setStatusDialog] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState('');
  const [priceChanges, setPriceChanges] = useState({ open: false, changes: [] });
  const [tabValue, setTabValue] = useState(0);

  // Clipboard state for copy/paste items and sections (localStorage enables cross-tab paste)
  const [copiedItem, setCopiedItem] = useState(() => {
    try { const s = localStorage.getItem('quotation_clipboard_item'); return s ? JSON.parse(s) : null; } catch { return null; }
  });
  const [copiedSection, setCopiedSection] = useState(() => {
    try { const s = localStorage.getItem('quotation_clipboard_section'); return s ? JSON.parse(s) : null; } catch { return null; }
  });

  // Transfer item modal state
  const [transferItemModal, setTransferItemModal] = useState({ open: false, sectionIndex: null, itemIndex: null });

  // New state for enhanced features
  const [versionsDialog, setVersionsDialog] = useState({ open: false, quotation: null });
  const [remindersDialog, setRemindersDialog] = useState({ open: false, quotation: null });
  const [reminders, setReminders] = useState([]);
  const [reFollowUpDialog, setReFollowUpDialog] = useState({ open: false, reminder: null });
  const [reFollowUpData, setReFollowUpData] = useState({
    followUpDate: '',
    priority: 'MEDIUM',
    notes: ''
  });
  
  // Version management states
  const [selectedVersions, setSelectedVersions] = useState([]);
  const [versionManagementMode, setVersionManagementMode] = useState(false);
  const [sizeInfo, setSizeInfo] = useState(null);
  const [sizeWarningDialog, setSizeWarningDialog] = useState({ open: false, quotation: null });

  // State for item selection modal navigation
  const [lastSelectedItemPosition, setLastSelectedItemPosition] = useState(null);

  const [filters, setFilters] = useState({
    startDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000), // 7 days ago
    endDate: new Date(), // Today
    status: '',
    salesmanId: '',
    createdById: '',
    recipientType: '',
    searchTerm: '',
    amountRange: { min: '', max: '' },
    sortBy: 'createdAt',
    sortOrder: 'desc',
    viewMode: 'grid' // 'grid' or 'list'
  });

  const [form, setForm] = useState({
    recipient: null,
    recipientType: 'Customer',
    visitor: null,
    visits: [],
    salesmen: [],
    siteAddress: '',
    sections: [
      {
        name: '',
        items: [
          {
            item: '',
            unit: 'pcs',
            quantity: 1,
            listedPrice: 0,
            offerType: '',
            discount: 0,
            offerPrice: 0,
            offerPriceTotal: 0,
            narration: '',
          },
        ],
        subTotal: 0,
      },
    ],
    specialDiscount: 0, // Removed from UI but kept for backward compatibility
    subTotal: 0,
    totalAmount: 0,
    createdBy: user?.user?._id,
    createdAt: new Date(),
    updatedAt: new Date(),
    cartage: 0,
    labour: 0,
    packingAndForwarding: 0,
    roundOff: 0,
    pricingType: 'Item-wise',
    reference: null,
    remarks: '',
    recommendations: [],
    brandDiscounts: {}, // Store brand-wise discounts
  });

  // State for offer type selection
  const [selectedOfferTypeValue, setSelectedOfferTypeValue] = useState(null);

  // Add these state variables after the existing state declarations
const [brandDiscountModal, setBrandDiscountModal] = useState(false);
const [brandDiscounts, setBrandDiscounts] = useState({});
const [brandSummary, setBrandSummary] = useState([]);
// ...existing code...

// Add these missing functions after the existing functions:

// Calculate total amount for the quotation
const calculateTotalAmount = (formData) => {
  const newForm = formData || { ...form };
  
  // Calculate subtotal from all sections
  const subTotal = newForm.sections.reduce((acc, section) => {
    const sectionSubTotal = section.items.reduce((itemAcc, item) => {
      return itemAcc + (item.offerPriceTotal || 0);
    }, 0);
    section.subTotal = sectionSubTotal;
    return acc + sectionSubTotal;
  }, 0);
  
  // Calculate total amount including additional chargesa
  const totalAmount = subTotal + 
    (newForm.cartage || 0) + 
    (newForm.labour || 0) + 
    (newForm.packingAndForwarding || 0) + 
    (newForm.roundOff || 0) - 
    (newForm.specialDiscount || 0);
  
  newForm.subTotal = subTotal;
  newForm.totalAmount = totalAmount;
  
  if (formData) {
    return formData;
  } else {
    setForm(newForm);
    return newForm;
  }
};

// ...existing code...

// Add these functions after the existing functions:

// Fetch employees for salesman selection
const fetchEmployees = useCallback(async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/employees/company2/${user?.user?.company?._id || user?.user?.company}`,);
    
    // Filter only salesmen
    setEmployees(response.data.employees);
  } catch (error) {
    console.error('Error fetching employees:', error);
    Swal.fire('Error', 'Failed to fetch employees', 'error');
  }
}, [user?.user?.company]);

// Fetch references for reference selection
const fetchReferences = useCallback(async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/references/all?userCompanyId=${user?.user?.company?._id || user?.user?.company}`
    );
    setReferences(response.data);
  } catch (error) {
    console.error('Error fetching references:', error);
    Swal.fire('Error', 'Failed to fetch references', 'error');
  }
}, [user?.user?.company]);

// Add useEffect to fetch initial data
useEffect(() => {
  fetchEmployees();
  fetchReferences();
}, [fetchEmployees, fetchReferences]);

// ...existing code...

// Handle offer type selection with auto-selection for single options
const handleOfferTypeSelection = async (sectionIndex, itemIndex, item) => {
  if (!isEmpty(item.item)) {
    let supportedOfferTypes = item.item.brand?.supportedOfferTypes;
    if (!supportedOfferTypes?.length && item.item.brand?.offerTypes?.length) {
      supportedOfferTypes = item.item.brand.offerTypes
        .filter((ot) => ot.active !== false)
        .map((ot) => ot.key);
    }
    
    // If brand data is incomplete (e.g., loaded from saved quotation with limited populate),
    // fetch fresh item data with full brand info
    if (!supportedOfferTypes && item.item.brand) {
      try {
        const brandId = typeof item.item.brand === 'object' ? item.item.brand._id : item.item.brand;
        const token = localStorage.getItem('token');
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/brands/${brandId}`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (response.data?.supportedOfferTypes) {
          supportedOfferTypes = response.data.supportedOfferTypes;
          // Update the item's brand data in-place so subsequent clicks don't need to re-fetch
          if (typeof item.item.brand === 'object') {
            item.item.brand.supportedOfferTypes = supportedOfferTypes;
          } else {
            item.item.brand = response.data;
          }
        }
      } catch (error) {
        console.error('Error fetching brand offer types:', error);
      }
    }
    
    if (supportedOfferTypes && supportedOfferTypes.length > 0) {
      // If there's only one offer type, auto-select it without showing modal
      if (supportedOfferTypes.length === 1) {
        const singleOfferType = supportedOfferTypes[0];
        console.log('Auto-selecting single offer type:', singleOfferType);
        
        // Handle the item change directly
        handleItemChange(sectionIndex, itemIndex, 'offerType', singleOfferType);
        
        // Set position for focus management
        setTimeout(() => {
          console.log('Setting position for offer type selection:', { sectionIndex, itemIndex, type: 'offerType' });
          setLastSelectedItemPosition({ sectionIndex, itemIndex, type: 'offerType' });
        }, 50);
      } else {
        // Multiple offer types, show the modal for selection
        console.log('Opening offer type modal for item:', item.item);
        openOfferTypeModal((selectedOfferType) => {
          console.log('Selected offer type:', selectedOfferType);
          console.log('About to call handleItemChange with:', { sectionIndex, itemIndex, field: 'offerType', value: selectedOfferType });
          
          // Handle the item change first
          handleItemChange(sectionIndex, itemIndex, 'offerType', selectedOfferType);
          
          // Set position for focus management after a brief delay to ensure state updates
          setTimeout(() => {
            console.log('Setting position for offer type selection:', { sectionIndex, itemIndex, type: 'offerType' });
            setLastSelectedItemPosition({ sectionIndex, itemIndex, type: 'offerType' });
          }, 50);
        }, item.item);
      }
    } else {
      Swal.fire({
        title: 'No Offer Types Available',
        text: 'This item\'s brand does not have any offer types configured.',
        icon: 'warning',
        confirmButtonColor: '#3b82f6'
      });
    }
  }
};

// Handle brand discount change
const handleBrandDiscountChange = (brandId, discountPercentage) => {
  const newBrandDiscounts = {
    ...brandDiscounts,
    [brandId]: discountPercentage
  };
  
  setBrandDiscounts(newBrandDiscounts);
  
  // Update form: apply brand discount to every matching item so the per-row
  // discount/offerPrice/offerPriceTotal and section subtotals stay in sync
  // with the brand summary card. Otherwise the screen totals diverge from
  // what the backend will save.
  setForm(prev => {
    const next = { ...prev, brandDiscounts: newBrandDiscounts };
    if (prev.pricingType === 'Brand-wise') {
      const round2 = (n) => Math.round((Number(n) || 0) * 100) / 100;
      next.sections = prev.sections.map(section => {
        const items = section.items.map(item => {
          const itemBrandId = item.item && typeof item.item === 'object'
            ? (item.item.brand?._id || item.item.brand)
            : null;
          if (!itemBrandId || String(itemBrandId) !== String(brandId)) return item;
          const listed = Number(item.listedPrice) || 0;
          const qty = Number(item.quantity) || 0;
          const disc = Math.max(0, Math.min(100, Number(discountPercentage) || 0));
          const offerPrice = round2(listed * (1 - disc / 100));
          return {
            ...item,
            discount: disc,
            offerPrice,
            offerPriceTotal: round2(offerPrice * qty)
          };
        });
        const subTotal = round2(items.reduce((s, it) => s + (Number(it.offerPriceTotal) || 0), 0));
        return { ...section, items, subTotal };
      });
      // Recompute grand total too
      const sub = round2(next.sections.reduce((s, sec) => s + (sec.subTotal || 0), 0));
      next.subTotal = sub;
      next.totalAmount = round2(
        sub +
          (Number(next.cartage) || 0) +
          (Number(next.labour) || 0) +
          (Number(next.packingAndForwarding) || 0) +
          (Number(next.roundOff) || 0) -
          (Number(next.specialDiscount) || 0)
      );
    }
    return next;
  });
  
  // Recalculate brand summary
  calculateBrandSummary();
};

// Handle item change (for item selection, quantity, unit, etc.)
const handleItemChange = (sectionIndex, itemIndex, field, value) => {
  const newForm = { ...form };
  const item = newForm.sections[sectionIndex].items[itemIndex];
  
  if (field === 'item') {
    // Handle item selection
    if (typeof value === 'object' && value !== null) {
      item.item = value;
      item.listedPrice = value.offerType?.[item.offerType] || 0;
      
      // Recalculate offer price and total
      const discount = item.discount || 0;
      item.offerPrice = item.listedPrice * (1 - discount / 100);
      item.offerPriceTotal = item.offerPrice * item.quantity;
      
      // Update form state first
      setForm(newForm);
      calculateTotalAmount(newForm);
      
      // Auto-open offer type modal after item selection
      setTimeout(() => {
        if (!value.brand) return;
        const brandOfferTypes = value.brand.supportedOfferTypes?.length
          ? value.brand.supportedOfferTypes
          : (value.brand.offerTypes || [])
              .filter((ot) => ot.active !== false)
              .map((ot) => ot.key);
        if (brandOfferTypes.length > 0) {
          // If there's only one offer type, auto-select it without showing modal
          if (brandOfferTypes.length === 1) {
            const singleOfferType = brandOfferTypes[0];
            console.log('Auto-selecting single offer type:', singleOfferType);
            handleItemChange(sectionIndex, itemIndex, 'offerType', singleOfferType);
            setTimeout(() => setLastSelectedItemPosition({ sectionIndex, itemIndex, type: 'offerType' }), 50);
          } else {
            // Multiple offer types, show the modal for selection
            openOfferTypeModal((selectedOfferType) => {
              handleItemChange(sectionIndex, itemIndex, 'offerType', selectedOfferType);
              setTimeout(() => setLastSelectedItemPosition({ sectionIndex, itemIndex, type: 'offerType' }), 50);
            }, value);
          }
        }
      }, 100);
    }
  } else if (field === 'quantity') {
    item.quantity = Math.max(1, parseFloat(value) || 1);
    item.offerPriceTotal = item.offerPrice * item.quantity;
  } else if (field === 'unit') {
    item.unit = value;
  } else if (field === 'offerType') {
    item.offerType = value;
    if (item.item && typeof item.item === 'object') {
      const priceForType = item.item.offerType?.[value];
      const numericPrice = Number(priceForType);
      if (!isFinite(numericPrice) || numericPrice <= 0) {
        // Don't silently zero the row — alert the user
        Swal.fire({
          title: 'No price configured',
          text: `Offer type "${value}" has no price set on this item. Please choose a different offer type or update the item master.`,
          icon: 'warning',
          confirmButtonColor: '#f59e0b'
        });
        item.listedPrice = 0;
      } else {
        item.listedPrice = numericPrice;
      }
      const round2 = (n) => Math.round((Number(n) || 0) * 100) / 100;
      const discount = Math.max(0, Math.min(100, Number(item.discount) || 0));
      item.offerPrice = round2(item.listedPrice * (1 - discount / 100));
      item.offerPriceTotal = round2(item.offerPrice * (Number(item.quantity) || 0));
    }
    
    // Update form state first
    setForm(newForm);
    calculateTotalAmount(newForm);
    
    // Force brand summary recalculation for brand-wise pricing
    if (form.pricingType === 'Brand-wise') {
      setTimeout(() => {
        calculateBrandSummary();
      }, 100);
    }
    
    return; // Early return to avoid duplicate setForm calls
  } else if (field === 'discount') {
    item.discount = Math.max(0, Math.min(100, parseFloat(value) || 0));
    item.offerPrice = item.listedPrice * (1 - item.discount / 100);
    item.offerPriceTotal = item.offerPrice * item.quantity;
  } else {
    item[field] = value;
  }
  
  // Recalculate section subtotal
  newForm.sections[sectionIndex].subTotal = newForm.sections[sectionIndex].items.reduce(
    (acc, item) => acc + (item.offerPriceTotal || 0), 0
  );
  
  setForm(newForm);
  calculateTotalAmount(newForm);
  
  // Force brand summary recalculation for brand-wise pricing
  if (form.pricingType === 'Brand-wise') {
    setTimeout(() => {
      calculateBrandSummary();
    }, 100);
  }
};

// Get validation class for form fields
const getValidationClass = (field, value) => {
  if (isEmpty(value)) {
    return 'border-red-300 focus:border-red-500 focus:ring-red-500';
  }
  return 'border-gray-300 focus:border-blue-500 focus:ring-blue-500';
};

// Custom select styles for react-select (dark-mode aware)
const customSelectStyles = useMemo(() => ({
  control: (provided, state) => ({
    ...provided,
    minHeight: '42px',
    border: state.isFocused ? `2px solid ${isDarkMode ? '#60a5fa' : '#3b82f6'}` : `1px solid ${isDarkMode ? '#4b5563' : '#d1d5db'}`,
    borderRadius: '0.5rem',
    boxShadow: state.isFocused ? `0 0 0 1px ${isDarkMode ? '#60a5fa' : '#3b82f6'}` : 'none',
    '&:hover': { borderColor: isDarkMode ? '#60a5fa' : '#3b82f6' },
    backgroundColor: isDarkMode ? '#374151' : 'white',
    fontSize: '14px',
  }),
  valueContainer: (provided) => ({ ...provided, padding: '4px 12px' }),
  input: (provided) => ({ ...provided, margin: '0px', color: isDarkMode ? '#f3f4f6' : '#374151' }),
  indicatorSeparator: (provided) => ({ ...provided, display: 'none' }),
  indicatorsContainer: (provided) => ({ ...provided, padding: '4px' }),
  dropdownIndicator: (provided) => ({ ...provided, color: isDarkMode ? '#9ca3af' : '#6b7280' }),
  clearIndicator: (provided) => ({ ...provided, color: isDarkMode ? '#9ca3af' : '#6b7280' }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
    borderRadius: '0.5rem',
    border: `1px solid ${isDarkMode ? '#374151' : '#e5e7eb'}`,
    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.3), 0 4px 6px -2px rgba(0, 0, 0, 0.15)',
    backgroundColor: isDarkMode ? '#1f2937' : 'white',
  }),
  menuList: (provided) => ({ ...provided, maxHeight: '200px', padding: '4px', backgroundColor: isDarkMode ? '#1f2937' : 'white' }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#3b82f6' : state.isFocused ? (isDarkMode ? '#374151' : '#eff6ff') : (isDarkMode ? '#1f2937' : 'transparent'),
    color: state.isSelected ? 'white' : isDarkMode ? '#d1d5db' : '#374151',
    padding: '8px 12px',
    borderRadius: '0.375rem',
    margin: '1px 0',
    cursor: 'pointer',
    fontSize: '14px',
  }),
  placeholder: (provided) => ({ ...provided, color: isDarkMode ? '#6b7280' : '#9ca3af', fontSize: '14px' }),
  singleValue: (provided) => ({ ...provided, color: isDarkMode ? '#f3f4f6' : '#374151', fontSize: '14px' }),
  multiValue: (provided) => ({ ...provided, backgroundColor: isDarkMode ? '#374151' : '#e5e7eb' }),
  multiValueLabel: (provided) => ({ ...provided, color: isDarkMode ? '#f3f4f6' : '#374151' }),
  multiValueRemove: (provided) => ({ ...provided, color: isDarkMode ? '#9ca3af' : '#6b7280', '&:hover': { backgroundColor: isDarkMode ? '#4b5563' : '#d1d5db', color: isDarkMode ? 'white' : '#374151' } }),
  noOptionsMessage: (provided) => ({ ...provided, padding: '8px 12px', color: isDarkMode ? '#9ca3af' : '#6b7280', fontSize: '14px', backgroundColor: isDarkMode ? '#1f2937' : 'white' }),
  loadingMessage: (provided) => ({ ...provided, padding: '8px 12px', color: isDarkMode ? '#9ca3af' : '#6b7280', fontSize: '14px', backgroundColor: isDarkMode ? '#1f2937' : 'white' }),
}), [isDarkMode]);

// ...existing code...

  // Handle filter changes
  const handleFilterChange = (field, value) => {
    setFilters(prev => ({ ...prev, [field]: value }));
  };

  // Reset all filters
  const resetFilters = () => {
    setFilters({
      startDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
      endDate: new Date(),
      status: '',
      salesmanId: '',
      createdById: '',
      recipientType: '',
      searchTerm: '',
      amountRange: { min: '', max: '' },
      sortBy: 'createdAt',
      sortOrder: 'desc',
      viewMode: 'grid'
    });
    setQuotationPage(0);
  };

  // Get filtered quotations count
  const getFilteredCount = () => {
    return quotations.length;
  };

  const listStats = useMemo(() => {
    const total = quotations.length;
    const totalAmount = quotations.reduce((sum, q) => sum + (Number(q.totalAmount) || 0), 0);
    const avgAmount = total > 0 ? totalAmount / total : 0;
    const completed = quotations.filter(q => q.status === 'APPROVED' || q.status === 'COMPLETED').length;
    const partial = quotations.filter(q => q.status === 'PARTIAL-COMPLETE' || q.status === 'PARTIAL').length;
    const pending = quotations.filter(q => q.status === 'PENDING').length;
    const rejected = quotations.filter(q => q.status === 'REJECTED' || q.status === 'CANCELLED').length;
    return { total, totalAmount, avgAmount, completed, partial, pending, rejected };
  }, [quotations]);

  // Format date for display
  const formatDate = (date) => {
    return new Date(date).toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  // Format time for display
  const formatTime = (date) => {
    return new Date(date).toLocaleTimeString('en-IN', {
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  // Active filters summary chips (for quick glance & one-tap removal)
  const activeFilters = useMemo(() => {
    const empName = (id) => employees.find(e => e._id === id)?.name || id;
    const list = [];
    if (filters.searchTerm) list.push({ key: 'searchTerm', label: `Search: ${filters.searchTerm}` });
    if (filters.status) list.push({ key: 'status', label: `Status: ${filters.status}` });
    if (filters.recipientType) list.push({ key: 'recipientType', label: `Type: ${filters.recipientType}` });
    if (filters.salesmanId) list.push({ key: 'salesmanId', label: `Salesperson: ${empName(filters.salesmanId)}` });
    if (filters.createdById) list.push({ key: 'createdById', label: `Created By: ${empName(filters.createdById)}` });
    if (filters.startDate) list.push({ key: 'startDate', label: `From: ${formatDate(filters.startDate)}` });
    if (filters.endDate) list.push({ key: 'endDate', label: `To: ${formatDate(filters.endDate)}` });
    if (filters.amountRange.min) list.push({ key: 'amountMin', label: `Min: ₹${filters.amountRange.min}` });
    if (filters.amountRange.max) list.push({ key: 'amountMax', label: `Max: ₹${filters.amountRange.max}` });
    return list;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters, employees]);

  // Remove a single active filter by its key
  const removeFilter = (key) => {
    if (key === 'startDate' || key === 'endDate') {
      handleFilterChange(key, null);
    } else if (key === 'amountMin') {
      handleFilterChange('amountRange', { ...filters.amountRange, min: '' });
    } else if (key === 'amountMax') {
      handleFilterChange('amountRange', { ...filters.amountRange, max: '' });
    } else {
      handleFilterChange(key, '');
    }
  };

  // Handle recipient selection
  const handleRecipientSelect = (recipient, recipientType) => {
    // Determine the site address based on recipient type and available addresses
    let siteAddress = '';
    if (recipientType === 'Customer') {
      // For customers, prefer delivery address, fallback to site address
      siteAddress = recipient.deliveryAddress || recipient.siteAddress || '';
    } else if (recipientType === 'Dealer') {
      // For dealers, use the address field
      siteAddress = recipient.address || '';
    }

    let label;
    if (recipientType === 'Customer') {
      label = `${recipient.name} (Ph: ${recipient.phone}, ID: ${recipient.customerCode}${recipient.station?.name ? `, Station: ${recipient.station.name}` : ''})`;
    } else if (recipientType === 'Reference') {
      const meta = [];
      if (recipient.phoneNumber) meta.push(`Ph: ${recipient.phoneNumber}`);
      if (recipient.id) meta.push(`ID: ${recipient.id}`);
      if (recipient.station?.name) meta.push(`Station: ${recipient.station.name}`);
      label = meta.length ? `${recipient.name} (${meta.join(', ')})` : recipient.name;
    } else {
      label = recipient.businessName;
    }

    setForm(prev => ({
      ...prev,
      recipientType: recipientType,
      recipient: { value: recipient._id, label },
      siteAddress: siteAddress
    }));
    
    setShowRecipientModal(false);
  };

// ...existing code...

// Update the openItemModal function
const openItemModal = (func) => {
  setModalVisible({ open: true, func });
};

// Add this function to calculate brand summary
const calculateBrandSummary = useCallback(() => {
  console.log('calculateBrandSummary called, form.sections:', form.sections.length);
  const brandMap = new Map();
  
  // Use current form state
  const currentForm = form;
  
  currentForm.sections.forEach((section, sectionIndex) => {
    section.items.forEach((item, itemIndex) => {
      console.log(`Section ${sectionIndex}, Item ${itemIndex}:`, {
        hasItem: !!item.item,
        itemType: typeof item.item,
        hasBrand: item.item && typeof item.item === 'object' && item.item.brand,
        brandName: item.item && typeof item.item === 'object' && item.item.brand ? item.item.brand.name : 'No brand'
      });
      
      if (item.item && typeof item.item === 'object' && item.item.brand) {
        const brandId = item.item.brand._id;
        const brandName = item.item.brand.name;
        
        if (!brandMap.has(brandId)) {
          brandMap.set(brandId, {
            brandId,
            brandName,
            items: [],
            totalValue: 0,
            discountPercentage: brandDiscounts[brandId] || 0,
            discountAmount: 0
          });
        }
        
        const brand = brandMap.get(brandId);
        const itemTotal = item.offerPriceTotal || 0;
        const originalTotal = item.listedPrice * item.quantity;
        
        brand.items.push({
          name: item.item.skuDescription || item.item.skuCode,
          quantity: item.quantity,
          originalPrice: item.listedPrice,
          discountedPrice: item.offerPrice,
          total: itemTotal
        });
        
        brand.totalValue += itemTotal;
        brand.discountAmount += (originalTotal - itemTotal);
      }
    });
  });
  
  const brandSummaryArray = Array.from(brandMap.values());
  console.log('Brand summary calculated:', brandSummaryArray);
  setBrandSummary(brandSummaryArray);
  
  return brandSummaryArray;
}, [form, brandDiscounts]);
useEffect(() => {
  if (form.pricingType === 'Brand-wise') {
    calculateBrandSummary();
  }
}, [form.sections, form.pricingType, calculateBrandSummary, brandDiscounts]);

  // Apply an edited item master to every quotation row that references it.
  const applyUpdatedItem = (updatedItem) => {
    if (!updatedItem?._id) return;
    const round2 = (n) => Math.round((Number(n) || 0) * 100) / 100;
    let clearedOfferType = false;

    const sections = form.sections.map(section => {
      const items = section.items.map(row => {
        const rowId = row.item && typeof row.item === 'object' ? row.item._id : row.item;
        if (String(rowId) !== String(updatedItem._id)) return row;

        if (!row.offerType) return { ...row, item: updatedItem };

        const priceForType = updatedItem.offerType?.[row.offerType];
        const listedPrice = Number(priceForType);
        if (!Number.isFinite(listedPrice) || listedPrice <= 0) {
          clearedOfferType = true;
          return {
            ...row,
            item: updatedItem,
            offerType: '',
            listedPrice: 0,
            offerPrice: 0,
            offerPriceTotal: 0,
          };
        }

        const discount = Math.max(0, Math.min(100, Number(row.discount) || 0));
        const offerPrice = round2(listedPrice * (1 - discount / 100));
        return {
          ...row,
          item: updatedItem,
          listedPrice,
          offerPrice,
          offerPriceTotal: round2(offerPrice * (Number(row.quantity) || 0)),
        };
      });
      return {
        ...section,
        items,
        subTotal: round2(items.reduce((s, it) => s + (Number(it.offerPriceTotal) || 0), 0)),
      };
    });

    const subTotal = round2(sections.reduce((s, sec) => s + (Number(sec.subTotal) || 0), 0));
    const next = {
      ...form,
      sections,
      subTotal,
      totalAmount: round2(
        subTotal +
        (Number(form.cartage) || 0) +
        (Number(form.labour) || 0) +
        (Number(form.packingAndForwarding) || 0) +
        (Number(form.roundOff) || 0) -
        (Number(form.specialDiscount) || 0)
      ),
    };
    setForm(next);

    if (clearedOfferType) {
      toast.warn('An edited offer price no longer exists for one or more rows. Please re-select the offer type.');
    }
  };

  // Form validation
  const validate = () => {
    if (!form.recipient || !form.recipient.value) {
      Swal.fire('Error', 'Please select a recipient', 'error');
      return false;
    }
    if (!form.salesmen || form.salesmen.length === 0) {
      Swal.fire('Error', 'Please select at least one salesperson', 'error');
      return false;
    }
    
    for (let i = 0; i < form.sections.length; i++) {
      const section = form.sections[i];
      if (!section.name.trim()) {
        Swal.fire('Error', `Please enter a name for section ${i + 1}`, 'error');
        return false;
      }
      for (let j = 0; j < section.items.length; j++) {
        const item = section.items[j];
        
        // Enhanced validation with specific error messages
        if (isEmpty(item.item)) {
          Swal.fire({
            title: 'Item Required',
            text: `Please select an item for section ${i + 1}, item ${j + 1}`,
            icon: 'warning',
            confirmButtonColor: '#3b82f6'
          });
          return false;
        }
        
        if (isEmpty(item.offerType)) {
          Swal.fire({
            title: 'Offer Type Required',
            text: `Please select an offer type for section ${i + 1}, item ${j + 1}`,
            icon: 'warning',
            confirmButtonColor: '#3b82f6'
          });
          return false;
        }
        
        if (item.quantity <= 0) {
          Swal.fire({
            title: 'Invalid Quantity',
            text: `Please enter a valid quantity for section ${i + 1}, item ${j + 1}`,
            icon: 'warning',
            confirmButtonColor: '#3b82f6'
          });
          return false;
        }
      }
    }
    return true;
  };

  // Check if form is ready for submission
  const isFormReady = () => {
    if (!form.recipient || !form.recipient.value || !form.salesmen || form.salesmen.length === 0) {
      return false;
    }
    
    for (let section of form.sections) {
      if (!section.name.trim()) return false;
      for (let item of section.items) {
        if (isEmpty(item.item) || isEmpty(item.offerType) || item.quantity <= 0) {
          return false;
        }
      }
    }
    return true;
  };

  // Reset form
  const resetForm = () => {
    setForm({
      recipient: null,
      recipientType: 'Customer',
      visitor: null,
      visits: [],
      salesmen: [],
      siteAddress: '',
      sections: [
        {
          name: '',
          items: [
            {
              item: '',
              unit: 'pcs',
              quantity: 1,
              listedPrice: 0,
              offerType: '',
              discount: 0,
              offerPrice: 0,
              offerPriceTotal: 0,
              narration: '',
            },
          ],
          subTotal: 0,
        },
      ],
      specialDiscount: 0,
      subTotal: 0,
      totalAmount: 0,
      createdBy: user?.user?._id,
      createdAt: new Date(),
      updatedAt: new Date(),
      cartage: 0,
      labour: 0,
      packingAndForwarding: 0,
      roundOff: 0,
      pricingType: 'Item-wise',
      reference: null,
      remarks: '',
      recommendations: [],
      brandDiscounts: {}, // Store brand-wise discounts
    });
    
    setEdit(false);
    setSelectedQuotationId(null);
    setTabValue(0);
    setBrandSummary([]);
    setBrandDiscounts({});
  };

  // Fetch quotations list with debounce to prevent excessive API calls
  const fetchQuotations = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/quotation-new/${user.user._id}`,
        {
          params: {
            page: quotationPage,
            limit: quotationLimit,
            startDate: filters.startDate ? filters.startDate.toISOString() : undefined,
            endDate: filters.endDate ? filters.endDate.toISOString() : undefined,
            status: filters.status,
            salesmanId: filters.salesmanId,
            createdById: filters.createdById,
            recipientType: filters.recipientType,
            searchTerm: filters.searchTerm,
            minAmount: filters.amountRange.min,
            maxAmount: filters.amountRange.max,
            sortBy: filters.sortBy,
            sortOrder: filters.sortOrder,
          },
        }
      );

      setQuotations(response.data.quotations || []);
      setTotalQuotations(response.data.total || 0);
    } catch (error) {
      console.error("Error fetching quotations:", error);
      Swal.fire("Error", "Failed to fetch quotations", "error");
    } finally {
      setLoading(false);
    }
  }, [
    quotationPage, 
    quotationLimit, 
    filters.startDate, 
    filters.endDate, 
    filters.status,
    filters.salesmanId,
    filters.createdById,
    filters.recipientType,
    filters.searchTerm,
    filters.amountRange.min,
    filters.amountRange.max,
    filters.sortBy,
    filters.sortOrder,
    user.user._id
  ]);

  // Excel Export functionality
  const exportAllQuotationsToExcel = async () => {
    try {
      setLoading(true);
      
      // Fetch all quotations for export (without pagination)
      const params = {
        page: 0,
        limit: 10000, // Large limit to get all quotations
        startDate: filters.startDate ? filters.startDate.toISOString() : undefined,
        endDate: filters.endDate ? filters.endDate.toISOString() : undefined,
        status: filters.status,
        salesmanId: filters.salesmanId,
        createdById: filters.createdById,
        recipientType: filters.recipientType,
        searchTerm: filters.searchTerm,
        minAmount: filters.amountRange.min,
        maxAmount: filters.amountRange.max,
        sortBy: filters.sortBy,
        sortOrder: filters.sortOrder,
      };
      
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/quotation-new/${user.user._id}`,
        { params }
      );
      
      if (response.data.quotations && response.data.quotations.length > 0) {
        const ExcelJS = require('exceljs');
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Quotation New');
        
        // Add headers
        worksheet.addRow([
          'Quotation ID',
          'Status',
          'Recipient Name',
          'Recipient Type',
          'Sales Team',
          'Total Amount',
          'Special Discount',
          'Valid Till',
          'Reminder Status',
          'Created Date',
          'Site Address',
          'Reference',
          'Pricing Type',
          'Remarks',
          'Version Count'
        ]);
        
        // Style headers
        worksheet.getRow(1).font = { bold: true };
        worksheet.getRow(1).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFE6E6FA' }
        };
        
        // Add data rows
        for (const quotation of response.data.quotations) {
          // Fetch reminder status for each quotation
          let reminderStatus = 'No Reminders';
          try {
            const statusResponse = await axios.get(
              `${process.env.REACT_APP_API_BASE_URL}/quotation-new/status/${quotation._id}`
            );
            if (statusResponse.data.success) {
              const stats = statusResponse.data.statistics.reminderStats;
              reminderStatus = `${stats.completed}/${stats.total} Completed`;
              if (stats.partialComplete > 0) {
                reminderStatus += `, ${stats.partialComplete} Partial`;
              }
              if (stats.pending > 0) {
                reminderStatus += `, ${stats.pending} Pending`;
              }
            }
          } catch (error) {
            console.log('Could not fetch reminder status for quotation:', quotation._id);
          }
          
          worksheet.addRow([
            quotation.id || '',
            quotation.status || 'PENDING',
            quotation.recipient?.name || quotation.recipient?.businessName || '',
            quotation.recipientType || '',
            quotation.salesmen?.map(s => s.name).join(', ') || '',
            quotation.totalAmount || 0,
            quotation.specialDiscount || 0,
            quotation.validTill ? new Date(quotation.validTill).toLocaleDateString() : '',
            reminderStatus,
            quotation.createdAt ? new Date(quotation.createdAt).toLocaleDateString() : '',
            quotation.siteAddress || '',
            quotation.reference?.name || '',
            quotation.pricingType || 'Item-wise',
            quotation.remarks || '',
            quotation.versions?.length || 0
          ]);
        }
        
        // Auto-size columns
        worksheet.columns.forEach(column => {
          column.width = 15;
        });
        
        // Generate filename with current date
        const currentDate = new Date().toISOString().slice(0, 10);
        const filename = `QuotationNew_${currentDate}.xlsx`;
        
        // Save file
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        link.click();
        window.URL.revokeObjectURL(url);
        
        toast.success(`Excel file "${filename}" downloaded successfully!`);
      } else {
        toast.warning('No quotations found to export');
      }
    } catch (error) {
      console.error('Export error:', error);
      toast.error('Failed to export quotations to Excel');
    } finally {
      setLoading(false);
    }
  };

  // Check for price changes and create version if needed
  const checkAndCreateVersion = async (quotationId) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/quotation-new/auto-version/${quotationId}`,
        {
          createdBy: user.user._id,
          reason: "Automatic version created due to item price changes"
        }
      );
      
      if (response.data.hasChanges) {
        Swal.fire({
          icon: 'info',
          title: 'Price Update Detected',
          text: `A new version (v${response.data.versionNumber}) has been created due to price changes in the items.`,
          confirmButtonText: 'OK'
        });
        
        // Refresh the quotation data
        fetchQuotations();
      }
      
      return response.data;
    } catch (error) {
      console.error('Error checking price changes:', error);
      return { hasChanges: false };
    }
  };

  // Function to get reminder status for a quotation
  const [quotationStatuses, setQuotationStatuses] = useState({});
  
  const fetchQuotationStatus = async (quotationId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/quotation-new/status/${quotationId}`
      );
      if (response.data.success) {
        return response.data.statistics.reminderStats;
      }
    } catch (error) {
      console.log('Could not fetch reminder status for quotation:', quotationId);
    }
    return null;
  };

  // Load reminder statuses for visible quotations
  useEffect(() => {
    const loadStatuses = async () => {
      const newStatuses = {};
      for (const quotation of quotations) {
        const status = await fetchQuotationStatus(quotation._id);
        if (status) {
          newStatuses[quotation._id] = status;
        }
      }
      setQuotationStatuses(newStatuses);
    };
    
    if (quotations.length > 0) {
      loadStatuses();
    }
  }, [quotations]);

  // Enhanced price change checking
  const handlePriceChangeCheck = async (quotationId) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/quotation-new/check-item-changes`,
        { quotationId }
      );
      
      if (response.data.hasChanges) {
        const changes = response.data.changedItems;
        
        const result = await Swal.fire({
          title: 'Price Changes Detected',
          html: `
            <div class="text-left">
              <p class="mb-3">The following items have price changes:</p>
              <ul class="list-disc pl-5 space-y-1">
                ${changes.map(change => `
                  <li>
                    <strong>${change.item.skuDescription || change.item.skuCode}</strong><br>
                    <span class="text-sm text-gray-600">
                      Section: ${change.section}<br>
                      Old Price: ₹${addCommas(change.oldPrice)} → New Price: ₹${addCommas(change.newPrice)}
                    </span>
                  </li>
                `).join('')}
              </ul>
              <p class="mt-3 text-sm text-gray-600">Would you like to create a new version with updated prices?</p>
            </div>
          `,
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: 'Create New Version',
          cancelButtonText: 'Keep Current Prices',
          customClass: {
            popup: 'text-left'
          }
        });
        
        if (result.isConfirmed) {
          await checkAndCreateVersion(quotationId);
        }
      } else {
        Swal.fire({
          icon: 'info',
          title: 'No Price Changes',
          text: 'All item prices are up to date.',
          timer: 2000,
          showConfirmButton: false
        });
      }
    } catch (error) {
      console.error('Error checking price changes:', error);
      Swal.fire('Error', 'Failed to check price changes', 'error');
    }
  };

  // Auto-version function for price changes
  const createAutoVersion = async (quotationId, reason = "Price changes detected") => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/quotation-new/auto-version/${quotationId}`,
        { 
          reason,
          createdBy: user?.user?._id 
        }
      );
      
      if (response.data.hasChanges) {
        Swal.fire({
          title: 'Version Created',
          text: `A new version (v${response.data.versionNumber}) has been created due to price changes.`,
          icon: 'info',
          timer: 3000,
          timerProgressBar: true
        });
        
        // Create reminder for price change
        await createPriceChangeReminder(quotationId, response.data.versionNumber);
      }
      
      return response.data;
    } catch (error) {
      console.error('Error creating auto-version:', error);
      return { hasChanges: false, error: error.message };
    }
  };

  // Create reminder for price changes
  const createPriceChangeReminder = async (quotationId, versionNumber) => {
    try {
      const quotationData = quotations.find(q => q._id === quotationId);
      if (!quotationData) return;

      const reminderData = {
        title: `Price Update - Quotation ${quotationData.quotationNumber || quotationId}`,
        message: `Price changes detected and new version (v${versionNumber}) created for quotation. Please review and inform the customer if necessary.`,
        datatype: 'QuotationNew',
        dataid: quotationId,
        priority: 'HIGH',
        category: 'QUOTATION_NEW',
        assignedTo: form.salesmen || [],
        createdBy: user?.user?._id,
        date: new Date(Date.now() + 24 * 60 * 60 * 1000), // Due in 24 hours
        status: 'PENDING'
      };

      await api.post(`${process.env.REACT_APP_API_BASE_URL}/reminders`, reminderData);
      
      console.log('Price change reminder created successfully');
    } catch (error) {
      console.error('Error creating price change reminder:', error);
    }
  };

  // Enhanced save/update function with auto-versioning
  const saveQuotationWithVersioning = async () => {
    if (!validate()) return;

    try {
      setLoading(true);
      
      if (edit) {
        // Check for price changes before updating
        const autoVersionResult = await createAutoVersion(selectedQuotationId, "Manual update with price verification");
        
        // Continue with regular update
        const response = await axios.put(
          `${process.env.REACT_APP_API_BASE_URL}/quotation-new/${selectedQuotationId}`,
          { ...form, updatedBy: user?.user?._id }
        );
        
        Swal.fire('Success', 'Quotation updated successfully', 'success');
        
        if (autoVersionResult.hasChanges) {
          // Additional notification for version creation
          setTimeout(() => {
            Swal.fire({
              title: 'Price Changes Detected',
              text: 'A new version has been created due to price changes. Reminders have been sent to relevant team members.',
              icon: 'info',
              confirmButtonText: 'Understood'
            });
          }, 1500);
        }
      } else {
        // Create new quotation
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/quotation-new`,
          form
        );
        
        Swal.fire('Success', 'Quotation created successfully', 'success');
      }
      
      resetForm();
      fetchQuotations();
    } catch (error) {
      console.error('Error saving quotation:', error);
      
      // Check if it's a BSON size error
      if (error.response?.status === 413 && error.response?.data?.bsonSizeError) {
        const errorData = error.response.data;
        Swal.fire({
          title: 'Document Size Limit Exceeded',
          html: `
            <div class="text-left">
              <p class="mb-2">The quotation document has exceeded MongoDB's 16MB size limit.</p>
              <p class="mb-2"><strong>Current size:</strong> ${errorData.documentSize.mb} MB</p>
              <p class="mb-2"><strong>Versions:</strong> ${errorData.versionsCount}</p>
              <p class="mb-2 text-blue-600">${errorData.suggestion}</p>
            </div>
          `,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Manage Versions',
          cancelButtonText: 'Close',
          confirmButtonColor: '#3085d6'
        }).then((result) => {
          if (result.isConfirmed) {
            // Find the quotation and open version management
            const quotation = quotations.find(q => q._id === selectedQuotationId);
            if (quotation) {
              handleViewVersions(quotation);
              setVersionManagementMode(true);
            }
          }
        });
      } else {
        Swal.fire('Error', error.response?.data?.error || 'Failed to save quotation', 'error');
      }
    } finally {
      setLoading(false);
    }
  };
  const addSection = () => {
    const newForm = { ...form };
    newForm.sections.push({
      name: '',
      items: [
        {
          item: '',
          unit: 'pcs',
          quantity: 1,
          listedPrice: 0,
          offerType: '',
          discount: 0,
          offerPrice: 0,
          offerPriceTotal: 0,
          narration: '',
        }
      ],
      subTotal: 0
    });
    
    setForm(newForm);
    
    // Focus on the newly added section's name field
    setTimeout(() => {
      if (sectionNameRefs.current[newForm.sections.length - 1]) {
        sectionNameRefs.current[newForm.sections.length - 1].focus();
      }
    }, 100);
  };

  // Delete section
  const deleteSection = (sectionIndex) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to recover this section!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        const newForm = { ...form };
        newForm.sections.splice(sectionIndex, 1);
        
        // If there are no sections left, add an empty one
        if (newForm.sections.length === 0) {
          newForm.sections.push({
            name: '',
            items: [
              {
                item: '',
                unit: 'pcs',
                quantity: 1,
                listedPrice: 0,
                offerType: '',
                discount: 0,
                offerPrice: 0,
                offerPriceTotal: 0,
              }
            ],
            subTotal: 0
          });
        }
        
        setForm(newForm);
        calculateTotalAmount(newForm);
      }
    });
  };

  // Replicate section
  const replicateSection = (sectionIndex) => {
    const newForm = { ...form };
    const sectionCopy = JSON.parse(JSON.stringify(newForm.sections[sectionIndex]));
    newForm.sections.splice(sectionIndex + 1, 0, sectionCopy);
    setForm(newForm);
    calculateTotalAmount(newForm);
  };

  const replicateItem = (sectionIndex, itemIndex) => {
    const newForm = { ...form };
    const itemCopy = JSON.parse(JSON.stringify(newForm.sections[sectionIndex].items[itemIndex]));
    newForm.sections[sectionIndex].items.splice(itemIndex + 1, 0, itemCopy);
    setForm(newForm);
    calculateTotalAmount(newForm);
  };

  // Copy item to clipboard (persisted to localStorage for cross-tab paste)
  const copyItem = (sectionIndex, itemIndex) => {
    const itemCopy = JSON.parse(JSON.stringify(form.sections[sectionIndex].items[itemIndex]));
    const payload = { item: itemCopy, timestamp: Date.now() };
    setCopiedItem(payload);
    try { localStorage.setItem('quotation_clipboard_item', JSON.stringify(payload)); } catch {}
    toast.success('Item copied to clipboard');
  };

  // Paste copied item to the end of a section's item list
  const pasteItem = (sectionIndex) => {
    if (!copiedItem) return;
    const newForm = { ...form };
    const itemCopy = JSON.parse(JSON.stringify(copiedItem.item));
    newForm.sections[sectionIndex].items.push(itemCopy);
    setForm(newForm);
    calculateTotalAmount(newForm);
    setCopiedItem(null);
    try { localStorage.removeItem('quotation_clipboard_item'); } catch {}
    toast.success('Item pasted');
  };

  // Copy entire section to clipboard (persisted to localStorage for cross-tab paste)
  const copySection = (sectionIndex) => {
    const sectionCopy = JSON.parse(JSON.stringify(form.sections[sectionIndex]));
    const payload = { section: sectionCopy, timestamp: Date.now() };
    setCopiedSection(payload);
    try { localStorage.setItem('quotation_clipboard_section', JSON.stringify(payload)); } catch {}
    toast.success('Section copied to clipboard');
  };

  // Paste copied section at the end of the sections list
  const pasteSection = () => {
    if (!copiedSection) return;
    const newForm = { ...form };
    const sectionCopy = JSON.parse(JSON.stringify(copiedSection.section));
    newForm.sections.push(sectionCopy);
    setForm(newForm);
    calculateTotalAmount(newForm);
    setCopiedSection(null);
    try { localStorage.removeItem('quotation_clipboard_section'); } catch {}
    toast.success('Section pasted');
  };

  // Add item to a section and auto-open item selection modal
  const addItem = (sectionIndex) => {
    const newForm = { ...form };
    const newItemIndex = newForm.sections[sectionIndex].items.length;
    newForm.sections[sectionIndex].items.push({
      item: '',
      unit: 'pcs',
      quantity: 1,
      listedPrice: 0,
      offerType: '',
      discount: 0,
      offerPrice: 0,
      offerPriceTotal: 0,
      narration: '',
    });
    setForm(newForm);
    // Auto-open item selection modal for the new item
    setTimeout(() => {
      openItemModal((selectedItem) => {
        handleItemChange(sectionIndex, newItemIndex, 'item', selectedItem);
      });
    }, 100);
  };

  // Transfer item from one section to another
  const transferItem = (fromSectionIndex, itemIndex, toSectionIndex) => {
    if (fromSectionIndex === toSectionIndex) return;
    const newForm = { ...form };
    const [item] = newForm.sections[fromSectionIndex].items.splice(itemIndex, 1);
    newForm.sections[toSectionIndex].items.push(item);
    // If source section is now empty, add a blank item
    if (newForm.sections[fromSectionIndex].items.length === 0) {
      newForm.sections[fromSectionIndex].items.push({
        item: '', unit: 'pcs', quantity: 1, listedPrice: 0, offerType: '', discount: 0, offerPrice: 0, offerPriceTotal: 0, narration: '',
      });
    }
    setForm(newForm);
    calculateTotalAmount(newForm);
    setTransferItemModal({ open: false, sectionIndex: null, itemIndex: null });
    toast.success(`Item transferred to Section ${toSectionIndex + 1}`);
  };

  // Delete item from a section
  const deleteItem = (sectionIndex, itemIndex) => {
    const newForm = { ...form };
    newForm.sections[sectionIndex].items.splice(itemIndex, 1);
    
    // If there are no items left in the section, add an empty one
    if (newForm.sections[sectionIndex].items.length === 0) {
      newForm.sections[sectionIndex].items.push({
        item: '',
        unit: 'pcs',
        quantity: 1,
        listedPrice: 0,
        offerType: '',
        discount: 0,
        offerPrice: 0,
        offerPriceTotal: 0,
        narration: '',
      });
    }
    
    // Recalculate section subtotal
    newForm.sections[sectionIndex].subTotal = newForm.sections[sectionIndex].items.reduce(
      (acc, item) => acc + (item.offerPriceTotal || 0), 0
    );
    
    setForm(newForm);
    calculateTotalAmount(newForm);
  };

  // Move section up
  const moveSectionUp = (sectionIndex) => {
    if (sectionIndex === 0) return;
    
    const newForm = { ...form };
    const temp = newForm.sections[sectionIndex - 1];
    newForm.sections[sectionIndex - 1] = newForm.sections[sectionIndex];
    newForm.sections[sectionIndex] = temp;
    
    setForm(newForm);
  };

  // Move section down
  const moveSectionDown = (sectionIndex) => {
    const newForm = { ...form };
    if (sectionIndex === newForm.sections.length - 1) return;
    
    const temp = newForm.sections[sectionIndex + 1];
    newForm.sections[sectionIndex + 1] = newForm.sections[sectionIndex];
    newForm.sections[sectionIndex] = temp;
    
    setForm(newForm);
  };

  // Move item up
  const moveItemUp = (sectionIndex, itemIndex) => {
    if (itemIndex === 0) return;
    
    const newForm = { ...form };
    const items = newForm.sections[sectionIndex].items;
    const temp = items[itemIndex - 1];
    items[itemIndex - 1] = items[itemIndex];
    items[itemIndex] = temp;
    
    setForm(newForm);
  };

  // Move item down
  const moveItemDown = (sectionIndex, itemIndex) => {
    const newForm = { ...form };
    const items = newForm.sections[sectionIndex].items;
    if (itemIndex === items.length - 1) return;
    
    const temp = items[itemIndex + 1];
    items[itemIndex + 1] = items[itemIndex];
    items[itemIndex] = temp;
    
    setForm(newForm);
  };
  // Handle status change
  const handleStatusChange = (quotation) => {
    setSelectedQuotationId(quotation._id);
    setSelectedStatus(quotation.status);
    setStatusDialog(true);
  };

  // Handle view quotation
  const handleViewQuotation = async (quotation) => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/quotation-new/data/${quotation._id}`
      );
      
      if (response.data) {
        const data = response.data;
        
        // Calculate totals and summary
        const totalItems = data.sections?.reduce((acc, section) => acc + (section.items?.length || 0), 0) || 0;
        const totalSections = data.sections?.length || 0;
        const hasDiscount = data.specialDiscount > 0;
        const hasAdditionalCharges = (data.cartage + data.labour + data.packingAndForwarding) > 0;
        
        // Generate sections HTML
        const sectionsHtml = data.sections?.map((section, sectionIndex) => `
          <div class="border border-gray-200 rounded-lg p-3 mb-3 bg-gray-50">
            <div class="flex justify-between items-center mb-2">
              <h4 class="font-semibold text-gray-800">${section.name || `Section ${sectionIndex + 1}`}</h4>
              <span class="text-sm text-gray-600">${section.items?.length || 0} items</span>
            </div>
            <div class="space-y-2">
              ${section.items?.map((item, itemIndex) => `
                <div class="bg-white p-2 rounded border-l-4 border-blue-200">
                  <div class="flex justify-between items-start">
                    <div class="flex-1">
                      <div class="font-medium text-gray-800">
                        ${item.item?.skuDescription || 'Unknown Item'} 
                        ${item.customName ? `<span class="text-gray-600">(${item.customName})</span>` : ''}
                      </div>
                      ${item.item?.skuCode ? `<div class="text-xs text-gray-500">SKU: ${item.item.skuCode}</div>` : ''}
                      ${item.item?.brand?.name ? `<div class="text-xs text-gray-500">Brand: ${item.item.brand.name}</div>` : ''}
                      ${item.narration ? `<div class="text-xs text-gray-600 mt-1">${item.narration}</div>` : ''}
                    </div>
                    <div class="text-right ml-3">
                      <div class="text-sm">
                        <span class="font-semibold">${item.quantity} ${item.unit}</span>
                      </div>
                      <div class="text-xs text-gray-600">
                        ₹${addCommas(item.listedPrice)} each
                      </div>
                      ${item.discount > 0 ? `
                        <div class="text-xs text-green-600">
                          ${item.discount}% off
                        </div>
                      ` : ''}
                      <div class="text-sm font-semibold text-blue-600">
                        ₹${addCommas(item.offerPriceTotal)}
                      </div>
                    </div>
                  </div>
                </div>
              `).join('') || '<div class="text-gray-500 text-sm">No items in this section</div>'}
            </div>
            <div class="mt-3 pt-2 border-t border-gray-200">
              <div class="flex justify-between items-center">
                <span class="font-medium text-gray-700">Section Total:</span>
                <span class="font-bold text-gray-800">₹${addCommas(section.subTotal)}</span>
              </div>
            </div>
          </div>
        `).join('') || '<div class="text-gray-500">No sections found</div>';
        
        // Generate pricing breakdown
        const pricingBreakdown = `
          <div class="bg-blue-50 p-4 rounded-lg">
            <h4 class="font-semibold text-gray-800 mb-3">Pricing Breakdown</h4>
            <div class="space-y-2">
              <div class="flex justify-between">
                <span>Subtotal:</span>
                <span>₹${addCommas(data.subTotal)}</span>
              </div>
              ${hasDiscount ? `
                <div class="flex justify-between text-red-600">
                  <span>Special Discount:</span>
                  <span>-₹${addCommas(data.specialDiscount)}</span>
                </div>
              ` : ''}
              ${data.cartage > 0 ? `
                <div class="flex justify-between">
                  <span>Cartage:</span>
                  <span>₹${addCommas(data.cartage)}</span>
                </div>
              ` : ''}
              ${data.labour > 0 ? `
                <div class="flex justify-between">
                  <span>Labour:</span>
                  <span>₹${addCommas(data.labour)}</span>
                </div>
              ` : ''}
              ${data.packingAndForwarding > 0 ? `
                <div class="flex justify-between">
                  <span>Packing & Forwarding:</span>
                  <span>₹${addCommas(data.packingAndForwarding)}</span>
                </div>
              ` : ''}
              ${data.roundOff !== 0 ? `
                <div class="flex justify-between">
                  <span>Round Off:</span>
                  <span>${data.roundOff >= 0 ? '+' : ''}₹${addCommas(data.roundOff)}</span>
                </div>
              ` : ''}
              <div class="border-t border-gray-300 pt-2 mt-2">
                <div class="flex justify-between font-bold text-lg">
                  <span>Total Amount:</span>
                  <span class="text-green-600">₹${addCommas(data.totalAmount)}</span>
                </div>
              </div>
            </div>
          </div>
        `;
        
        // Show comprehensive quotation details
        Swal.fire({
          title: `
            <div class="flex items-center justify-center space-x-3">
              <span class="text-2xl">📋</span>
              <div>
                <div class="text-xl font-bold">${data.id}</div>
                <div class="text-sm text-gray-600">${data.recipientType} Quotation</div>
              </div>
            </div>
          `,
          html: `
            <div class="text-left max-h-96 overflow-y-auto custom-scrollbar">
              <!-- Header Information -->
              <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6 p-4 bg-gray-50 rounded-lg">
                <div>
                  <div class="mb-3">
                    <strong class="text-gray-700">📝 Recipient:</strong><br>
                    <span class="text-gray-900">${data.recipient?.name || data.recipient?.businessName || 'Unknown'}</span>
                    ${data.recipient?.station?.name ? `<br><small class="text-gray-600">📍 ${data.recipient.station.name}</small>` : ''}
                  </div>
                  
                  <div class="mb-3">
                    <strong class="text-gray-700">📊 Status:</strong><br>
                    <span class="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold ${
                      data.status === 'APPROVED' ? 'bg-green-100 text-green-800' :
                      data.status === 'PENDING' ? 'bg-yellow-100 text-yellow-800' :
                      'bg-red-100 text-red-800'
                    }">
                      ${data.status === 'APPROVED' ? '✅' : data.status === 'PENDING' ? '⏳' : '❌'} ${data.status}
                    </span>
                  </div>
                  
                  ${data.pricingType ? `
                    <div class="mb-3">
                      <strong class="text-gray-700">💰 Pricing Type:</strong><br>
                      <span class="text-gray-900">${data.pricingType}</span>
                    </div>
                  ` : ''}
                </div>
                
                <div>
                  <div class="mb-3">
                    <strong class="text-gray-700">📅 Created:</strong><br>
                    <span class="text-gray-900">${formatDate(data.createdAt)} at ${formatTime(data.createdAt)}</span>
                  </div>
                  
                  ${data.updatedAt !== data.createdAt ? `
                    <div class="mb-3">
                      <strong class="text-gray-700">🔄 Last Updated:</strong><br>
                      <span class="text-gray-900">${formatDate(data.updatedAt)} at ${formatTime(data.updatedAt)}</span>
                    </div>
                  ` : ''}
                  
                  ${data.validTill ? `
                    <div class="mb-3">
                      <strong class="text-gray-700">⏰ Valid Till:</strong><br>
                      <span class="text-gray-900">${formatDate(data.validTill)}</span>
                    </div>
                  ` : ''}
                </div>
              </div>

              <!-- Quick Stats -->
              <div class="grid grid-cols-3 gap-4 mb-6">
                <div class="text-center p-3 bg-blue-50 rounded-lg">
                  <div class="text-2xl font-bold text-blue-600">${totalSections}</div>
                  <div class="text-sm text-gray-600">Sections</div>
                </div>
                <div class="text-center p-3 bg-green-50 rounded-lg">
                  <div class="text-2xl font-bold text-green-600">${totalItems}</div>
                  <div class="text-sm text-gray-600">Items</div>
                </div>
                <div class="text-center p-3 bg-purple-50 rounded-lg">
                  <div class="text-lg font-bold text-purple-600">${data.versions?.length || 1}</div>
                  <div class="text-sm text-gray-600">Versions</div>
                </div>
              </div>

              <!-- Salesperson Information -->
              ${data.salesmen?.length > 0 ? `
                <div class="mb-6 p-4 bg-indigo-50 rounded-lg">
                  <strong class="text-gray-700">👨‍💼 Salesperson:</strong><br>
                  <div class="mt-2">
                    ${data.salesmen.map(s => `
                      <span class="inline-flex items-center px-2 py-1 bg-indigo-100 text-indigo-800 text-xs rounded-full mr-2 mb-1">
                        👤 ${s.name}
                      </span>
                    `).join('')}
                  </div>
                </div>
              ` : ''}

              <!-- Reference Information -->
              ${data.reference?.name ? `
                <div class="mb-6 p-4 bg-yellow-50 rounded-lg">
                  <strong class="text-gray-700">🔗 Reference:</strong><br>
                  <span class="text-gray-900">${data.reference.name}</span>
                  ${data.reference.description ? `<br><small class="text-gray-600">${data.reference.description}</small>` : ''}
                </div>
              ` : ''}

              <!-- Sections and Items -->
              <div class="mb-6">
                <h4 class="font-semibold text-gray-800 mb-3 flex items-center">
                  <span class="mr-2">📦</span> Sections & Items
                </h4>
                ${sectionsHtml}
              </div>

              <!-- Pricing Breakdown -->
              ${pricingBreakdown}

              <!-- Remarks -->
              ${data.remarks ? `
                <div class="mt-6 p-4 bg-gray-50 rounded-lg">
                  <strong class="text-gray-700">💭 Remarks:</strong><br>
                  <div class="mt-2 text-gray-900 whitespace-pre-wrap">${data.remarks}</div>
                </div>
              ` : ''}

              <!-- Additional Information -->
              ${data.versions?.length > 1 ? `
                <div class="mt-6 p-4 bg-orange-50 rounded-lg">
                  <strong class="text-gray-700">📋 Version Information:</strong><br>
                  <div class="mt-2">
                    <span class="text-gray-900">Current version: ${data.versions.length}</span>
                    ${data.versions.length > 5 ? '<br><small class="text-orange-600">⚠️ Multiple versions detected</small>' : ''}
                  </div>
                </div>
              ` : ''}
            </div>
          `,
          width: '900px',
          showCloseButton: true,
          showConfirmButton: false,
          showCancelButton: true,
          cancelButtonText: '📝 Edit Quotation',
          cancelButtonColor: '#3b82f6',
          customClass: {
            popup: 'text-sm',
            htmlContainer: 'quotation-view-modal'
          },
          didOpen: () => {
            // Add custom styles for better scrolling
            const style = document.createElement('style');
            style.textContent = `
              .quotation-view-modal {
                max-height: 70vh !important;
                overflow-y: auto !important;
              }
            `;
            document.head.appendChild(style);
          }
        }).then((result) => {
          if (result.dismiss === Swal.DismissReason.cancel) {
            // User clicked "Edit Quotation"
            openEditQuotation(quotation);
          }
        });
      }
    } catch (error) {
      console.error("Error fetching quotation details:", error);
      Swal.fire("Error", "Failed to fetch quotation details", "error");
    } finally {
      setLoading(false);
    }
  };

  // Open edit quotation
  const openEditQuotation = async (quotation) => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/quotation-new/data/${quotation._id}`
      );
      
      if (response.data) {
        const data = response.data;
        
        // Format recipient data properly for the new structure
        let formattedRecipient = null;
        if (data.recipient) {
          const recipientType = data.recipientType || 'Customer';
          const r = data.recipient;
          let label;
          if (recipientType === 'Customer') {
            label = `${r.name} (Ph: ${r.phone}, ID: ${r.customerCode}${r.station?.name ? `, Station: ${r.station.name}` : ''})`;
          } else if (recipientType === 'Reference') {
            const meta = [];
            if (r.phoneNumber) meta.push(`Ph: ${r.phoneNumber}`);
            if (r.id) meta.push(`ID: ${r.id}`);
            if (r.station?.name) meta.push(`Station: ${r.station.name}`);
            label = meta.length ? `${r.name} (${meta.join(', ')})` : r.name;
          } else {
            label = r.businessName;
          }
          formattedRecipient = { value: r._id, label };
        }
        
        // Format reference data if present
        let formattedReference = null;
        if (data.reference) {
          // If reference is already populated (object), use it directly
          if (typeof data.reference === 'object' && data.reference._id) {
            formattedReference = {
              value: data.reference._id,
              label: data.reference.name || data.reference.label,
              type: data.reference.type,
              phone: data.reference.phone,
              _id: data.reference._id
            };
          } else {
            // If reference is just an ID, find it in the references array
            const referenceData = references.find(ref => ref._id === data.reference);
            if (referenceData) {
              formattedReference = {
                value: data.reference,
                label: referenceData.name || referenceData.label,
                type: referenceData.type,
                phone: referenceData.phone,
                _id: data.reference
              };
            }
          }
        }

        setForm({
          ...data,
          salesmen: data.salesmen || [],
          recipient: formattedRecipient,
          recipientType: data.recipientType || 'Customer',
          pricingType: data.pricingType || 'Item-wise',
          reference: formattedReference,
        });
        setEdit(true);
        setSelectedQuotationId(data._id);
        setTabValue(0); // Switch to form tab
      }
    } catch (error) {
      console.error('Error fetching quotation details:', error);
      Swal.fire('Error', 'Failed to load quotation details', 'error');
    } finally {
      setLoading(false);
    }
  };

  // Handle submit quotation
  const handleSubmitQuotation = async () => {
    if (!validate()) return;

    try {
      setLoading(true);
      
      const quotationData = {
        ...form,
        recipient: form.recipient?.value || form.recipient, // Extract ID from the object structure
        reference: form.reference?.value || form.reference, // Extract ID from the reference object
        validTill: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000), // 7 days from now
        printType: "medium"
      };

      if (edit) {
        // Check for price changes before updating
        const autoVersionResult = await createAutoVersion(selectedQuotationId, "Manual update with price verification");
        
        // Continue with regular update
        await axios.put(
          `${process.env.REACT_APP_API_BASE_URL}/quotation-new/${selectedQuotationId}`,
          quotationData
        );
        
        Swal.fire('Success', 'Quotation updated successfully', 'success');
        
        if (autoVersionResult.hasChanges) {
          // Additional notification for version creation
          setTimeout(() => {
            Swal.fire({
              title: 'Price Changes Detected',
              text: 'A new version has been created due to price changes. Reminders have been sent to relevant team members.',
              icon: 'info',
              confirmButtonText: 'Understood'
            });
          }, 1500);
        }
      } else {
        await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/quotation-new`,
          quotationData
        );
        Swal.fire('Success', 'Quotation created successfully', 'success');
      }

      resetForm();
      fetchQuotations();
    } catch (error) {
      console.error('Error saving quotation:', error);
      Swal.fire('Error', 'Failed to save quotation', 'error');
    } finally {
      setLoading(false);
    }
  };

  // Pagination handler
  const handleQuotationPageChange = (value) => {
    setQuotationPage(value - 1);
  };

  // Initial data fetching
  useEffect(() => {
    fetchQuotations();
  }, [fetchQuotations]);

  // Check price changes for all pending quotations
  const checkPriceChangesForAllQuotations = async () => {
    try {
      const pendingQuotations = quotations.filter(q => q.status === 'PENDING');
      
      for (const quotation of pendingQuotations) {
        await createAutoVersion(quotation._id, "Periodic price verification");
      }
      
      console.log('Periodic price check completed');
    } catch (error) {
      console.error('Error in periodic price check:', error);
    }
  };

  // Set up periodic price checking (every 30 minutes)
  useEffect(() => {
    if (quotations.length > 0) {
      const interval = setInterval(checkPriceChangesForAllQuotations, 30 * 60 * 1000);
      return () => clearInterval(interval);
    }
  }, [quotations]);

  // Get status color class
  const getStatusColorClass = (status) => {
    switch(status) {
      case 'APPROVED':
        return 'bg-green-100 text-green-800';
      case 'REJECTED':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-yellow-100 text-yellow-800';
    }
  };

  // Handle print quotation
  const handlePrintQuotation = async (quotation) => {
    try {
      // Open QuotationNewReview component instead of direct PDF URL
      const printUrl = `/print-quotation-new/${quotation._id}`;
      window.open(printUrl, '_blank');
    } catch (error) {
      console.error('Error printing quotation:', error);
      Swal.fire('Error', 'Failed to print quotation', 'error');
    }
  };

  // Handle print specific version
  const handlePrintVersion = async (quotationId, versionNumber) => {
    try {
      // Open QuotationNewReview component for specific version
      const printUrl = `/print-quotation-new/${quotationId}/${versionNumber}`;
      window.open(printUrl, '_blank');
    } catch (error) {
      console.error('Error printing version:', error);
      Swal.fire('Error', 'Failed to print version', 'error');
    }
  };

  // Handle send quotation via WhatsApp
  const handleWhatsAppSend = async (quotation) => {
    try {
      // Check if the automation is active
      const checkRes = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/whatsapp-automations/check-automation/quotation-send`
      );
      
      if (!checkRes.data.data.isActive) {
        return Swal.fire('Not Enabled', 'Quotation send via WhatsApp is not enabled. Please ask your Company Head to enable it in WhatsApp Automations.', 'warning');
      }
      if (!checkRes.data.data.isConnected) {
        const reconnectResult = await Swal.fire({
          icon: 'warning',
          title: 'WhatsApp Not Connected',
          text: 'WhatsApp is not connected. Would you like to try reconnecting?',
          showCancelButton: true,
          confirmButtonText: 'Try Reconnect',
          confirmButtonColor: '#25D366',
          cancelButtonText: 'Cancel'
        });
        if (!reconnectResult.isConfirmed) return;

        Swal.fire({ title: 'Reconnecting...', text: 'Attempting to restore WhatsApp connection...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });
        try {
          const reconnectRes = await axios.post(
            `${process.env.REACT_APP_API_BASE_URL}/whatsapp-automations/try-reconnect`,
            {},
            { withCredentials: true, headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
          );
          if (!reconnectRes.data.success) {
            return Swal.fire('Reconnect Failed', reconnectRes.data.message || 'Could not reconnect WhatsApp.', 'error');
          }
          Swal.close();
        } catch (reconnectErr) {
          return Swal.fire('Reconnect Failed', reconnectErr.response?.data?.message || 'Could not reconnect WhatsApp. Please ask your Company Head to connect.', 'error');
        }
      }

      const recipientName = quotation.recipient?.name || quotation.recipient?.businessName || 'Unknown';
      const recipientPhone = quotation.recipient?.phone || quotation.recipient?.phoneNumber || '';

      const { value: formValues } = await Swal.fire({
        title: 'Send Quotation via WhatsApp',
        html: `
          <div style="text-align: left; font-size: 14px;">
            <p style="margin-bottom: 12px;"><strong>Recipient:</strong> ${recipientName}</p>
            <p style="margin-bottom: 12px;"><strong>Quotation:</strong> ${quotation.id || ''}</p>
            <p style="margin-bottom: 12px;"><strong>Amount:</strong> ₹${quotation.totalAmount?.toLocaleString('en-IN') || '0'}</p>
            <label style="display: block; margin-bottom: 4px; font-weight: 600;">Phone Number:</label>
            <input id="swal-phone" class="swal2-input" placeholder="Enter phone number" value="${recipientPhone}" style="margin: 0 0 8px 0; width: 100%; box-sizing: border-box;">
          </div>
        `,
        showCancelButton: true,
        confirmButtonText: 'Send via WhatsApp',
        confirmButtonColor: '#25D366',
        cancelButtonText: 'Cancel',
        preConfirm: () => {
          const phone = document.getElementById('swal-phone').value.trim();
          if (!phone) {
            Swal.showValidationMessage('Phone number is required');
            return false;
          }
          return { phone };
        }
      });

      if (!formValues) return;

      Swal.fire({ title: 'Sending...', text: 'Generating PDF and queuing message...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/whatsapp-automations/send-quotation`,
        {
          quotationId: quotation._id,
          phone: formValues.phone,
          recipientName,
          recipientType: quotation.recipientType,
          recipientId: quotation.recipient?._id
        }
      );

      if (response.data.success) {
        Swal.fire('Queued!', response.data.message, 'success');
      } else {
        throw new Error(response.data.message);
      }
    } catch (error) {
      console.error('WhatsApp send error:', error);
      Swal.fire('Error', error.response?.data?.message || error.message || 'Failed to send quotation', 'error');
    }
  };


  // Open offer type modal
  const openOfferTypeModal = async (func, item) => {
    try {
      const itemData = item;
      let offerTypes = itemData?.brand?.supportedOfferTypes;
      if (!offerTypes?.length) {
        offerTypes = (itemData?.brand?.offerTypes || [])
          .filter((ot) => ot.active !== false)
          .map((ot) => ot.key);
      }
      if (offerTypes?.length) {
        setOfferType(offerTypes);
        setSelectedOfferTypeValue(null); // Reset selection
        setModalVisibleForOfferType({ open: true, func });
      } else {
        Swal.fire({
          title: 'No Offer Types Available',
          text: 'This item does not have any offer types configured.',
          icon: 'warning',
          confirmButtonColor: '#3b82f6'
        });
      }
    } catch (error) {
      console.error('Error fetching offer types:', error);
      Swal.fire({
        title: 'Error',
        text: 'Failed to load offer types. Please try again.',
        icon: 'error',
        confirmButtonColor: '#3b82f6'
      });
    }
  };

  // Handle viewing all versions of a quotation
  const handleViewVersions = async (quotation) => {
    try {
      // Fetch size information when opening versions dialog
      const sizeResponse = await fetch(process.env.REACT_APP_API_BASE_URL + `/quotation-new/size-info/${quotation._id}`, {
        headers: { 'Authorization': `Bearer ${user.token}` }
      });
      
      if (sizeResponse.ok) {
        const sizeData = await sizeResponse.json();
        setSizeInfo(sizeData);
      }
    } catch (error) {
      console.error('Error fetching size info:', error);
    }
    
    setVersionsDialog({ open: true, quotation });
    setSelectedVersions([]);
    setVersionManagementMode(false);
  };

  // Get quotation size information
  const fetchSizeInfo = async (quotationId) => {
    try {
      const response = await fetch( process.env.REACT_APP_API_BASE_URL + `/quotation-new/size-info/${quotationId}`, {
        headers: { 'Authorization': `Bearer ${user.token}` }
      });
      
      if (response.ok) {
        const data = await response.json();
        setSizeInfo(data);
        return data;
      }
    } catch (error) {
      console.error('Error fetching size info:', error);
    }
    return null;
  };

  // Handle version selection for deletion
  const handleVersionSelection = (versionNumber) => {
    setSelectedVersions(prev => {
      if (prev.includes(versionNumber)) {
        return prev.filter(v => v !== versionNumber);
      } else {
        return [...prev, versionNumber];
      }
    });
  };

  // Delete selected versions
  const deleteSelectedVersions = async () => {
    if (selectedVersions.length === 0) {
      Swal.fire('Warning', 'Please select versions to delete', 'warning');
      return;
    }

    const result = await Swal.fire({
      title: 'Confirm Deletion',
      text: `Are you sure you want to delete ${selectedVersions.length} selected version(s)? This action cannot be undone.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete them!',
      cancelButtonText: 'Cancel'
    });

    if (!result.isConfirmed) {
      return;
    }

    try {
      const response = await fetch(process.env.REACT_APP_API_BASE_URL + `/quotation-new/versions/${versionsDialog.quotation._id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${user.token}`
        },
        body: JSON.stringify({ versionNumbers: selectedVersions })
      });

      const data = await response.json();

      if (response.ok) {
        Swal.fire('Success', data.message, 'success');
        
        // Refresh the quotation data
        await fetchQuotations();
        
        // Update size info
        await fetchSizeInfo(versionsDialog.quotation._id);
        
        // Reset selection
        setSelectedVersions([]);
        setVersionManagementMode(false);
        
        // Close dialog if no versions left (shouldn't happen due to backend validation)
        if (data.remainingVersions === 0) {
          setVersionsDialog({ open: false, quotation: null });
        }
      } else {
        Swal.fire('Error', data.error || 'Failed to delete versions', 'error');
      }
    } catch (error) {
      console.error('Error deleting versions:', error);
      Swal.fire('Error', 'Failed to delete versions', 'error');
    }
  };

  // Handle BSON size error
  const handleBSONSizeError = (quotation) => {
    setSizeWarningDialog({ open: true, quotation });
  };

  // Handle viewing reminders for a quotation
  const handleViewReminders = async (quotation) => {
    try {
      const response = await api.get(
        `${process.env.REACT_APP_API_BASE_URL}/reminders/quotation/${quotation._id}`
      );
      setReminders(response.data || []);
      setRemindersDialog({ open: true, quotation });
    } catch (error) {
      console.error('Error fetching reminders:', error);
      Swal.fire('Error', 'Failed to load reminders', 'error');
    }
  };

  // Handle creating a new follow-up reminder
  const handleReFollowUp = (reminder) => {
    setReFollowUpDialog({ open: true, reminder });
  };

  // Submit re-follow-up reminder
  const submitReFollowUp = async (reminderData) => {
    try {
      const reminder = reFollowUpDialog.reminder;
      const notes = reminderData.notes || '';

      // Complete the current reminder (saves notes as remarks)
      await api.put(
        `${process.env.REACT_APP_API_BASE_URL}/reminders/status/${reminder._id}`,
        {
          status: 'COMPLETED',
          remarks: notes,
          completedAt: new Date()
        }
      );

      // Create a new follow-up reminder
      const newReminderData = {
        datatype: 'QuotationNew',
        dataid: reminder.dataid?._id || reminder.dataid || reFollowUpDialog.quotation?._id,
        category: 'QUOTATION_NEW',
        message: `Re-follow-up reminder for quotation. Previous reminder completed${notes ? ` with notes: ${notes}` : ''}.`,
        date: reminderData.followUpDate || new Date(),
        status: 'PENDING',
        priority: reminderData.priority || 'MEDIUM',
        assignedTo: reminder.assignedTo || [],
        createdBy: user?.user?._id,
        remarks: notes
      };

      await api.post(`${process.env.REACT_APP_API_BASE_URL}/reminders`, newReminderData);

      Swal.fire('Success', 'Follow-up reminder created successfully', 'success');
      setReFollowUpDialog({ open: false, reminder: null });
      setReFollowUpData({ followUpDate: '', priority: 'MEDIUM', notes: '' });
      
      // Refresh reminders if dialog is open
      if (remindersDialog.open) {
        handleViewReminders(remindersDialog.quotation);
      }
    } catch (error) {
      console.error('Error creating follow-up reminder:', error);
      Swal.fire('Error', 'Failed to create follow-up reminder', 'error');
    }
  };

  // Update reminder status
  const updateReminderStatus = async (reminderId, status, version) => {
    try {
      const updateData = {
        status,
        completedAt: status === 'COMPLETED' ? new Date() : null
      };

      if (status === 'COMPLETED' && version) {
        updateData.completedVersion = version;
      }

      await api.put(
        `${process.env.REACT_APP_API_BASE_URL}/reminders/${reminderId}`,
        updateData
      );

      Swal.fire('Success', 'Reminder status updated successfully', 'success');
      
      // Refresh reminders
      if (remindersDialog.open) {
        handleViewReminders(remindersDialog.quotation);
      }
    } catch (error) {
      console.error('Error updating reminder status:', error);
      Swal.fire('Error', 'Failed to update reminder status', 'error');
    }
  };

  // Focus the offer type select only when the modal opens. Re-focusing on every
  // value change re-opens the menu (openMenuOnFocus), which covers the Select
  // button and makes it impossible to confirm with the mouse.
  useEffect(() => {
    if (!modalVisibleForOfferType.open) return undefined;
    const timer = setTimeout(() => {
      if (offerTypeSelectRef.current) {
        offerTypeSelectRef.current.focus();
      }
    }, 150);
    return () => clearTimeout(timer);
  }, [modalVisibleForOfferType.open]);

  // Keyboard navigation for offer type modal
  useEffect(() => {
    if (modalVisibleForOfferType.open) {
      const handleKeyDown = (event) => {
        if (event.key === 'Escape') {
          setModalVisibleForOfferType({ open: false, func: null });
          setSelectedOfferTypeValue(null);
        } else if (event.key === 'Enter' && selectedOfferTypeValue) {
          modalVisibleForOfferType.func(selectedOfferTypeValue.value);
          setModalVisibleForOfferType({ open: false, func: null });
          setSelectedOfferTypeValue(null);
        }
      };

      document.addEventListener('keydown', handleKeyDown);
      return () => {
        document.removeEventListener('keydown', handleKeyDown);
      };
    }
    return undefined;
  }, [modalVisibleForOfferType, selectedOfferTypeValue]);

  // Focus on unit field after offer type selection
  useEffect(() => {
    if (lastSelectedItemPosition && !modalVisible.open && !modalVisibleForOfferType.open && lastSelectedItemPosition.type === 'offerType') {
      setTimeout(() => {
        const { sectionIndex, itemIndex } = lastSelectedItemPosition;
        const unitRefKey = `${sectionIndex}-${itemIndex}`;
        if (unitSelectRefs.current[unitRefKey]) {
          unitSelectRefs.current[unitRefKey].focus();
        }
        setLastSelectedItemPosition(null);
      }, 300);
    }
  }, [lastSelectedItemPosition, modalVisible.open, modalVisibleForOfferType.open]);

  // Ref to always access the latest handler functions without stale closures
  const shortcutRefs = useRef({});
  shortcutRefs.current = {
    addSection,
    addItem,
    handleSubmitQuotation,
    sections: form.sections,
    loading,
    modalVisibleForOfferType,
    setModalVisibleForOfferType,
    moveItemUp,
    moveItemDown,
    moveSectionUp,
    moveSectionDown,
  };

  // Global keyboard shortcuts
  useEffect(() => {
    const handler = (event) => {
      const { addSection, addItem, handleSubmitQuotation, sections, loading, modalVisibleForOfferType, setModalVisibleForOfferType, moveItemUp, moveItemDown, moveSectionUp, moveSectionDown } = shortcutRefs.current;
      const isInputActive = event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA' || event.target.tagName === 'SELECT' || event.target.isContentEditable;

      // Ctrl+S → Save / Create quotation
      if (event.ctrlKey && event.key === 's') {
        event.preventDefault();
        if (!loading) handleSubmitQuotation();
        return;
      }

      // Alt+N → Add new section
      if (event.altKey && event.key === 'n') {
        event.preventDefault();
        addSection();
        return;
      }

      // Alt+A → Add item to last section
      if (event.altKey && event.key === 'a') {
        event.preventDefault();
        if (sections.length > 0) addItem(sections.length - 1);
        return;
      }

      // Alt+ArrowUp/ArrowDown → Move focused item up/down within its section
      if (event.altKey && !event.shiftKey && (event.key === 'ArrowUp' || event.key === 'ArrowDown')) {
        event.preventDefault();
        // Find which item card is focused or contains the focused element
        const activeEl = document.activeElement;
        const itemCard = activeEl?.closest('[data-item-pos]');
        if (itemCard) {
          const [si, ii] = itemCard.dataset.itemPos.split('-').map(Number);
          if (event.key === 'ArrowUp') moveItemUp(si, ii);
          else moveItemDown(si, ii);
        }
        return;
      }

      // Alt+Shift+ArrowUp/ArrowDown → Move focused section up/down
      if (event.altKey && event.shiftKey && (event.key === 'ArrowUp' || event.key === 'ArrowDown')) {
        event.preventDefault();
        const activeEl = document.activeElement;
        const sectionCard = activeEl?.closest('[data-section-idx]');
        if (sectionCard) {
          const si = Number(sectionCard.dataset.sectionIdx);
          if (event.key === 'ArrowUp') moveSectionUp(si);
          else moveSectionDown(si);
        }
        return;
      }

      // Escape → close open modals (only when not in an input)
      if (event.key === 'Escape' && !isInputActive) {
        if (modalVisibleForOfferType.open) {
          setModalVisibleForOfferType({ open: false, func: null });
        }
        return;
      }
    };

    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, []); // empty deps — always reads latest via shortcutRefs

  const BrandDiscountModal = () => (
  <div className={`fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50 transition-opacity duration-300 ${brandDiscountModal ? 'opacity-100 visible' : 'opacity-0 invisible'}`}>
    <div className={`qm-modal ${isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-gradient-to-br from-white via-blue-50/30 to-indigo-50/20 border-gray-200/60'} rounded-2xl shadow-2xl backdrop-blur-sm max-w-6xl w-full max-h-[90vh] overflow-hidden transform transition-all duration-300 ${brandDiscountModal ? 'scale-100 translate-y-0' : 'scale-95 translate-y-4'}`}>
      {/* Decorative Background Elements */}
      <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-blue-400/10 to-purple-400/10 rounded-full -translate-y-16 translate-x-16"></div>
      <div className="absolute bottom-0 left-0 w-24 h-24 bg-gradient-to-tr from-green-400/10 to-blue-400/10 rounded-full translate-y-12 -translate-x-12"></div>
      
      {/* Header */}
      <div className="relative bg-gradient-to-r from-blue-500 via-indigo-600 to-purple-600 p-6 border-b border-gray-200/50">
        <div className="flex justify-between items-center">
          <div className="flex items-center space-x-4">
            <div className="flex items-center justify-center w-12 h-12 bg-white/20 backdrop-blur-sm rounded-xl shadow-lg">
              <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
              </svg>
            </div>
            <div>
              <h2 className="text-2xl font-bold text-white">Brand-wise Discount Management</h2>
              <p className="text-blue-100 text-sm mt-1">Set custom discount percentages for each brand</p>
            </div>
          </div>
          <button
            onClick={() => setBrandDiscountModal(false)}
            className="group flex items-center justify-center w-10 h-10 bg-white/20 backdrop-blur-sm rounded-xl text-white hover:bg-white/30 transition-all duration-200 transform hover:scale-105"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
      
      {/* Content */}
      <div className="relative p-6 overflow-y-auto max-h-[calc(90vh-140px)]">
        <div className="space-y-6">
          {brandSummary.map((brand, index) => (
            <div key={brand.brandId} className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-white via-gray-50/50 to-blue-50/30 border border-gray-200/60 shadow-lg hover:shadow-xl transition-all duration-300 backdrop-blur-sm">
              {/* Brand Card Decorative Elements */}
              <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-br from-blue-400/10 to-purple-400/10 rounded-full -translate-y-10 translate-x-10"></div>
              <div className="absolute bottom-0 left-0 w-16 h-16 bg-gradient-to-tr from-green-400/10 to-blue-400/10 rounded-full translate-y-8 -translate-x-8"></div>
              
              <div className="relative p-6">
                {/* Brand Header */}
                <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-6 space-y-4 sm:space-y-0">
                  <div className="flex items-center space-x-4">
                    <div className="flex items-center justify-center w-12 h-12 bg-gradient-to-r from-blue-500 to-purple-600 rounded-xl shadow-md">
                      <span className="text-white font-bold text-lg">{index + 1}</span>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-800">{brand.brandName}</h3>
                      <p className="text-sm text-gray-600">{brand.items.length} items in this brand</p>
                    </div>
                  </div>
                  
                  <div className="flex items-center space-x-4 bg-white/80 backdrop-blur-sm rounded-xl p-4 shadow-md border border-gray-200/50">
                    <label className="text-sm font-semibold text-gray-700 flex items-center">
                      <svg className="w-4 h-4 mr-2 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                      </svg>
                      Discount %:
                    </label>
                    <div className="relative">
                      <input
                        type="number"
                        min="0"
                        max="100"
                        step="0.01"
                        value={brand.discountPercentage}
                        onChange={(e) => handleBrandDiscountChange(brand.brandId, parseFloat(e.target.value) || 0)}
                        className="w-24 px-3 py-2 border-2 border-gray-300 rounded-xl text-center font-bold text-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 bg-white/90 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md"
                        placeholder="0.00"
                      />
                      <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-sm font-medium">%</span>
                    </div>
                  </div>
                </div>
                
                {/* Brand Details Grid */}
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                  {/* Items List */}
                  <div className="lg:col-span-2">
                    <div className="flex items-center space-x-3 mb-4">
                      <div className="flex items-center justify-center w-8 h-8 bg-gradient-to-r from-green-500 to-emerald-600 rounded-lg shadow-md">
                        <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                        </svg>
                      </div>
                      <h4 className="text-lg font-bold text-gray-800">Items ({brand.items.length})</h4>
                    </div>
                    <div className="space-y-3 max-h-48 overflow-y-auto pr-2 custom-scrollbar">
                      {brand.items.map((item, itemIndex) => (
                        <div key={itemIndex} className="bg-gradient-to-r from-blue-50/80 via-white to-indigo-50/80 backdrop-blur-sm p-4 rounded-xl border border-gray-200/50 shadow-sm hover:shadow-md transition-all duration-200">
                          <div className="flex items-start justify-between">
                            <div className="flex-1">
                              <div className="font-semibold text-gray-800 mb-1">{item.name}</div>
                              <div className="grid grid-cols-2 gap-2 text-xs text-gray-600">
                                <span className="flex items-center">
                                  <svg className="w-3 h-3 mr-1 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 20l4-16m2 16l4-16M6 9h14M4 15h14" />
                                  </svg>
                                  Qty: {item.quantity}
                                </span>
                                <span className="flex items-center">
                                  <svg className="w-3 h-3 mr-1 text-yellow-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                                  </svg>
                                  Original: ₹{addCommas(item.originalPrice)}
                                </span>
                                <span className="flex items-center">
                                  <svg className="w-3 h-3 mr-1 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                                  </svg>
                                  Discounted: ₹{addCommas(item.discountedPrice)}
                                </span>
                                <span className="flex items-center font-medium">
                                  <svg className="w-3 h-3 mr-1 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                                  </svg>
                                  Total: ₹{addCommas(item.total)}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  
                  {/* Summary Card */}
                  <div className="space-y-4">
                    <div className="flex items-center space-x-3 mb-4">
                      <div className="flex items-center justify-center w-8 h-8 bg-gradient-to-r from-purple-500 to-pink-600 rounded-lg shadow-md">
                        <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                        </svg>
                      </div>
                      <h4 className="text-lg font-bold text-gray-800">Summary</h4>
                    </div>
                    
                    <div className="space-y-3">
                      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200/50 rounded-xl p-4 backdrop-blur-sm">
                        <div className="flex items-center justify-between">
                          <span className="text-sm font-medium text-gray-700 flex items-center">
                            <svg className="w-4 h-4 mr-2 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                            </svg>
                            Total Value
                          </span>
                          <span className="font-bold text-blue-700">₹{addCommas(brand.totalValue)}</span>
                        </div>
                      </div>
                      
                      <div className="bg-gradient-to-r from-orange-50 to-red-50 border border-orange-200/50 rounded-xl p-4 backdrop-blur-sm">
                        <div className="flex items-center justify-between">
                          <span className="text-sm font-medium text-gray-700 flex items-center">
                            <svg className="w-4 h-4 mr-2 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                            </svg>
                            Discount Amount
                          </span>
                          <span className="font-bold text-orange-700">₹{addCommas(brand.discountAmount)}</span>
                        </div>
                      </div>
                      
                      <div className="bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200/50 rounded-xl p-4 backdrop-blur-sm">
                        <div className="flex items-center justify-between">
                          <span className="text-sm font-medium text-gray-700 flex items-center">
                            <svg className="w-4 h-4 mr-2 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            Discount Percentage
                          </span>
                          <span className="font-bold text-green-700">{brand.discountPercentage}%</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
          
          {brandSummary.length === 0 && (
            <div className="text-center py-16">
              <div className="flex flex-col items-center space-y-4">
                <div className="flex items-center justify-center w-20 h-20 bg-gradient-to-r from-gray-100 to-gray-200 rounded-full">
                  <svg className="w-10 h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                  </svg>
                </div>
                <div className="text-center">
                  <h3 className="text-lg font-semibold text-gray-600 mb-2">No Brand Items Found</h3>
                  <p className="text-gray-500 max-w-md">Add items with brands to your quotation sections to manage brand-wise discounts.</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      
      {/* Footer */}
      <div className="relative bg-gradient-to-r from-gray-50 via-blue-50/30 to-indigo-50/20 border-t border-gray-200/50 p-6">
        <div className="flex justify-end">
          <button
            onClick={() => setBrandDiscountModal(false)}
            className="group relative inline-flex items-center justify-center px-8 py-3 bg-gradient-to-r from-blue-500 via-blue-600 to-indigo-600 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 overflow-hidden"
          >
            <div className="absolute inset-0 bg-gradient-to-r from-blue-400 to-indigo-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            <svg className="w-5 h-5 mr-2 relative z-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span className="relative z-10">Apply & Close</span>
            <div className="absolute top-0 left-0 w-full h-full bg-white/20 transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700"></div>
          </button>
        </div>
      </div>
    </div>
  </div>
);

  // Dark mode class helper — all structural containers reference this
  const dc = useMemo(() => ({
    page: isDarkMode
      ? 'min-h-screen bg-gray-900 py-4'
      : 'min-h-screen bg-gradient-to-br from-gray-50 via-blue-50/30 to-indigo-50/20 py-4',
    pageHeaderBorder: isDarkMode
      ? 'flex flex-col sm:flex-row sm:justify-between sm:items-center mb-8 pb-4 border-b border-gray-700 space-y-2 sm:space-y-0'
      : 'flex flex-col sm:flex-row sm:justify-between sm:items-center mb-8 pb-4 border-b border-gray-200/50 space-y-2 sm:space-y-0',
    headingText: isDarkMode
      ? 'text-xl sm:text-2xl font-bold text-gray-100 mb-2 sm:mb-0'
      : 'text-xl sm:text-2xl font-bold text-gray-800 mb-2 sm:mb-0',
    mainCard: isDarkMode
      ? 'relative overflow-hidden rounded-2xl bg-gray-800 shadow-xl border border-gray-700 backdrop-blur-sm'
      : 'relative overflow-hidden rounded-2xl bg-gradient-to-br from-white via-blue-50/30 to-indigo-50/20 shadow-xl border border-gray-200/60 backdrop-blur-sm',
    tabNav: isDarkMode
      ? 'relative flex flex-wrap border-b border-gray-700 bg-gray-800 backdrop-blur-sm rounded-t-2xl'
      : 'relative flex flex-wrap border-b border-gray-200/50 bg-gradient-to-r from-slate-50/80 via-blue-50/40 to-indigo-50/30 backdrop-blur-sm rounded-t-2xl',
    tabActive0: isDarkMode
      ? 'border-blue-400 text-blue-300 bg-gray-700'
      : 'border-blue-500 text-blue-700 bg-gradient-to-r from-blue-50/80 to-indigo-50/60',
    tabActive1: isDarkMode
      ? 'border-green-400 text-green-300 bg-gray-700'
      : 'border-green-500 text-green-700 bg-gradient-to-r from-green-50/80 to-emerald-50/60',
    tabInactive: isDarkMode
      ? 'border-transparent text-gray-400 hover:text-gray-200 hover:border-gray-500 hover:bg-gray-700/50'
      : 'border-transparent text-gray-600 hover:text-gray-800 hover:border-gray-300 hover:bg-gray-50/50',
    formCard: isDarkMode
      ? 'relative rounded-2xl bg-gray-800 border border-gray-700 shadow-lg backdrop-blur-sm p-6 mb-8'
      : 'relative rounded-2xl bg-gradient-to-br from-white via-blue-50/20 to-indigo-50/10 border border-gray-200/60 shadow-lg backdrop-blur-sm p-6 mb-8',
    sectionCard: isDarkMode
      ? 'relative overflow-hidden rounded-2xl bg-gray-800 border border-gray-600 shadow-lg hover:shadow-xl transition-all duration-300 backdrop-blur-sm'
      : 'relative overflow-hidden rounded-2xl bg-gradient-to-br from-white via-blue-50/30 to-purple-50/20 border border-gray-200/60 shadow-lg hover:shadow-xl transition-all duration-300 backdrop-blur-sm',
    sectionHeader: isDarkMode
      ? 'relative bg-gray-700 border-b border-gray-600 p-6'
      : 'relative bg-gradient-to-r from-slate-50 via-blue-50/50 to-purple-50/30 border-b border-gray-200/50 p-6',
    sectionNameInput: isDarkMode
      ? 'w-full p-3 border border-gray-600 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-400 bg-gray-700 text-white backdrop-blur-sm transition-all duration-200 shadow-sm placeholder-gray-400'
      : 'w-full p-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md',
    sectionControls: isDarkMode
      ? 'flex bg-gray-600 backdrop-blur-sm rounded-xl p-1 shadow-md border border-gray-500'
      : 'flex bg-white/80 backdrop-blur-sm rounded-xl p-1 shadow-md border border-gray-200/50',
    sectionMoveBtn: isDarkMode
      ? 'p-2 text-blue-400 hover:bg-gray-500 rounded-lg disabled:opacity-40 disabled:cursor-not-allowed transition-all duration-200 hover:scale-105'
      : 'p-2 text-blue-600 hover:bg-blue-50 rounded-lg disabled:opacity-40 disabled:cursor-not-allowed transition-all duration-200 hover:scale-105',
    sectionActionBtn: (color) => isDarkMode
      ? `p-2 text-${color}-400 hover:bg-gray-500 rounded-lg transition-all duration-200 hover:scale-105 bg-gray-600 backdrop-blur-sm shadow-md border border-gray-500`
      : `p-2 text-${color}-600 hover:bg-${color}-50 rounded-lg transition-all duration-200 hover:scale-105 bg-white/80 backdrop-blur-sm shadow-md border border-gray-200/50`,
    itemCard: isDarkMode
      ? 'relative group bg-gray-700/70 backdrop-blur-sm border border-gray-600 rounded-xl p-4 shadow-sm hover:shadow-md transition-all duration-300 hover:bg-gray-700'
      : 'relative group bg-white/70 backdrop-blur-sm border border-gray-200/60 rounded-xl p-4 shadow-sm hover:shadow-md transition-all duration-300 hover:bg-white/90',
    itemInfoPanel: isDarkMode
      ? 'mb-4 p-4 bg-gray-800/70 border border-gray-600/70 rounded-xl shadow-inner'
      : 'mb-4 p-4 bg-gradient-to-r from-blue-50 via-indigo-50 to-purple-50 border border-blue-200 rounded-xl',
    itemInfoHeading: isDarkMode
      ? 'text-sm font-bold text-gray-100 flex items-center'
      : 'text-sm font-bold text-gray-800 flex items-center',
    itemDetailBadge: isDarkMode
      ? 'bg-gray-900/40 backdrop-blur-sm p-2.5 rounded-lg border border-gray-700'
      : 'bg-white/70 backdrop-blur-sm p-2.5 rounded-lg border border-blue-100',
    itemDetailLabel: isDarkMode ? 'font-semibold text-gray-300' : 'font-semibold text-gray-600',
    itemDetailValue: isDarkMode ? 'text-gray-100' : 'text-gray-800',
    itemAccent: (key) => {
      const accent = {
        brand: isDarkMode ? 'text-purple-300' : 'text-purple-600',
        category: isDarkMode ? 'text-emerald-300' : 'text-green-600',
        series: isDarkMode ? 'text-indigo-300' : 'text-indigo-600',
        hsn: isDarkMode ? 'text-amber-300' : 'text-orange-600',
        gst: isDarkMode ? 'text-rose-300' : 'text-red-600',
      };
      return accent[key] || (isDarkMode ? 'text-gray-100' : 'text-gray-800');
    },
    itemControls: isDarkMode
      ? 'flex items-center bg-gray-600/80 backdrop-blur-sm rounded-xl p-1 shadow-sm border border-gray-500 space-x-1'
      : 'flex items-center bg-gray-50/80 backdrop-blur-sm rounded-xl p-1 shadow-sm border border-gray-200/50 space-x-1',
    itemDivider: isDarkMode ? 'w-px h-6 bg-gray-500' : 'w-px h-6 bg-gray-300',
    itemMoveBtn: isDarkMode
      ? 'p-2.5 text-blue-400 hover:bg-gray-500 rounded-lg disabled:opacity-40 disabled:cursor-not-allowed transition-all duration-200 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-300'
      : 'p-2.5 text-blue-600 hover:bg-blue-50 rounded-lg disabled:opacity-40 disabled:cursor-not-allowed transition-all duration-200 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-300',
    itemAddBtn: isDarkMode
      ? 'p-2.5 text-green-400 hover:bg-gray-500 rounded-lg transition-all duration-200 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-green-300'
      : 'p-2.5 text-green-600 hover:bg-green-50 rounded-lg transition-all duration-200 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-green-300',
    itemDeleteBtn: isDarkMode
      ? 'p-2.5 text-red-400 hover:bg-gray-500 rounded-lg transition-all duration-200 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-red-300'
      : 'p-2.5 text-red-600 hover:bg-red-50 rounded-lg transition-all duration-200 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-red-300',
    itemCopyBtn: isDarkMode
      ? 'p-2.5 text-violet-400 hover:bg-gray-500 rounded-lg transition-all duration-200 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-violet-300'
      : 'p-2.5 text-violet-600 hover:bg-violet-50 rounded-lg transition-all duration-200 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-violet-300',
    itemPasteBtn: isDarkMode
      ? 'p-2.5 text-teal-400 hover:bg-gray-500 rounded-lg transition-all duration-200 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-teal-300'
      : 'p-2.5 text-teal-600 hover:bg-teal-50 rounded-lg transition-all duration-200 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-teal-300',
    sectionSubTotal: isDarkMode
      ? 'mt-4 bg-gray-900/40 border border-gray-700 rounded-xl p-4 backdrop-blur-sm'
      : 'mt-4 bg-gradient-to-r from-blue-50 via-indigo-50/70 to-purple-50 border border-blue-200/60 rounded-xl p-4 backdrop-blur-sm',
    sectionSubTotalText: isDarkMode ? 'text-sm font-semibold text-gray-200' : 'text-sm font-semibold text-gray-700',
    chargesCard: isDarkMode
      ? 'mt-8 mb-10 relative overflow-hidden rounded-2xl bg-gray-800 border border-gray-700 shadow-lg backdrop-blur-sm'
      : 'mt-8 mb-10 relative overflow-hidden rounded-2xl bg-gradient-to-br from-slate-50 via-gray-50 to-blue-50/30 border border-gray-200/60 shadow-lg backdrop-blur-sm',
    chargesTitle: isDarkMode ? 'text-lg font-bold text-gray-200' : 'text-lg font-bold text-gray-800',
    recipientBtn: isDarkMode
      ? 'w-full p-3 border border-gray-600 rounded-xl text-left bg-gray-700 hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:border-indigo-400 transition-all duration-200 shadow-sm'
      : 'w-full p-3 border border-gray-300 rounded-xl text-left bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all duration-200 shadow-sm hover:shadow-md hover:border-indigo-300',
    recipientBtnText: (hasValue) => isDarkMode
      ? (hasValue ? 'text-gray-100' : 'text-gray-400')
      : (hasValue ? 'text-gray-900' : 'text-gray-500'),
    actionButtonsCard: isDarkMode
      ? 'mt-10 relative overflow-hidden rounded-2xl bg-gray-800 border border-gray-700 shadow-lg backdrop-blur-sm'
      : 'mt-10 relative overflow-hidden rounded-2xl bg-gradient-to-br from-white via-blue-50/40 to-indigo-50/30 border border-gray-200/60 shadow-lg backdrop-blur-sm',
    totalAmountLabel: isDarkMode ? 'text-sm font-medium text-gray-400 mb-1' : 'text-sm font-medium text-gray-600 mb-1',
    listTabCard: isDarkMode
      ? 'bg-gray-800 rounded-lg shadow-sm border border-gray-700 p-6 mb-6'
      : 'bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6',
    listTabHeading: isDarkMode ? 'text-2xl font-bold text-gray-100 mb-2' : 'text-2xl font-bold text-gray-800 mb-2',
    listTabSubtext: isDarkMode ? 'text-gray-400' : 'text-gray-600',
    filterBox: isDarkMode ? 'bg-gray-700 rounded-lg p-4 mb-4' : 'bg-gray-50 rounded-lg p-4 mb-4',
    filterHeading: isDarkMode ? 'text-lg font-semibold text-gray-200 mb-2 lg:mb-0' : 'text-lg font-semibold text-gray-700 mb-2 lg:mb-0',
    filterInput: isDarkMode
      ? 'w-full pl-10 pr-4 py-2 border border-gray-600 rounded-md bg-gray-700 text-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent placeholder-gray-500'
      : 'w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent',
    viewToggleBg: isDarkMode ? 'flex bg-gray-700 rounded-md border border-gray-600' : 'flex bg-white rounded-md border border-gray-300',
    viewToggleActive: 'px-3 py-1 text-sm rounded-l-md transition-colors bg-blue-500 text-white',
    viewToggleInactive: isDarkMode ? 'px-3 py-1 text-sm transition-colors bg-gray-700 text-gray-300 hover:bg-gray-600' : 'px-3 py-1 text-sm transition-colors bg-white text-gray-600 hover:bg-gray-50',
    validationCard: isDarkMode
      ? 'mb-10 relative overflow-hidden rounded-2xl bg-amber-950/20 border border-amber-800/40 shadow-lg backdrop-blur-sm'
      : 'mb-10 relative overflow-hidden rounded-2xl bg-gradient-to-br from-amber-50 via-orange-50/50 to-red-50/30 border border-amber-200/60 shadow-lg backdrop-blur-sm',
    validationCardInner: isDarkMode
      ? 'bg-gray-700/50 backdrop-blur-sm rounded-xl p-4 space-y-2 border border-amber-800/30'
      : 'bg-white/70 backdrop-blur-sm rounded-xl p-4 space-y-2 border border-amber-200/40',
    validationItem: isDarkMode
      ? 'flex items-start space-x-3 p-3 bg-amber-950/30 rounded-lg border border-amber-800/20'
      : 'flex items-start space-x-3 p-3 bg-gradient-to-r from-amber-50/80 to-orange-50/80 rounded-lg border border-amber-200/30',
    resetBtn: isDarkMode
      ? 'group relative inline-flex items-center justify-center px-8 py-4 bg-gray-700 hover:bg-gray-600 text-gray-200 font-semibold rounded-2xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 disabled:opacity-50 overflow-hidden'
      : 'group relative inline-flex items-center justify-center px-8 py-4 bg-gradient-to-r from-gray-100 via-gray-200 to-gray-100 hover:from-gray-200 hover:to-gray-300 text-gray-800 font-semibold rounded-2xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 disabled:opacity-50 overflow-hidden',
    totalAmountCard: isDarkMode
      ? 'relative bg-gray-700 border border-gray-600 rounded-2xl p-6 shadow-lg backdrop-blur-sm'
      : 'relative bg-gradient-to-r from-emerald-50 via-blue-50 to-indigo-50 border border-emerald-200/50 rounded-2xl p-6 shadow-lg backdrop-blur-sm',
    sectionSubTotalValueBox: isDarkMode
      ? 'bg-gray-800 px-4 py-2 rounded-lg shadow-sm border border-gray-700'
      : 'bg-white/90 backdrop-blur-sm px-4 py-2 rounded-lg shadow-sm border border-blue-200/60',
    sectionPasteItemBar: isDarkMode
      ? 'flex items-center justify-center gap-2 flex-1 py-3 px-4 rounded-xl border-2 border-dashed border-teal-700/60 text-teal-300 text-sm font-semibold hover:bg-teal-900/20 hover:border-teal-500 transition-all duration-200'
      : 'flex items-center justify-center gap-2 flex-1 py-3 px-4 rounded-xl border-2 border-dashed border-teal-300 text-teal-700 text-sm font-semibold hover:bg-teal-50 hover:border-teal-400 transition-all duration-200',
    sectionAddItemBar: isDarkMode
      ? 'flex items-center justify-center gap-2 flex-1 py-3 px-4 rounded-xl border-2 border-dashed border-blue-700/60 text-blue-300 text-sm font-semibold hover:bg-blue-900/20 hover:border-blue-500 transition-all duration-200'
      : 'flex items-center justify-center gap-2 flex-1 py-3 px-4 rounded-xl border-2 border-dashed border-blue-300 text-blue-700 text-sm font-semibold hover:bg-blue-50 hover:border-blue-400 transition-all duration-200',
    recIcon: isDarkMode ? 'w-4 h-4 mr-2 text-indigo-400' : 'w-4 h-4 mr-2 text-indigo-500',
    recHint: isDarkMode ? 'text-xs text-gray-400 mb-3 ml-6' : 'text-xs text-gray-500 mb-3 ml-6',
    recCard: isDarkMode
      ? 'p-3 border border-gray-600 rounded-xl bg-gray-700/70 backdrop-blur-sm shadow-sm'
      : 'p-3 border border-gray-200 rounded-xl bg-white/70 backdrop-blur-sm shadow-sm',
    recDetailsInput: isDarkMode
      ? 'flex-1 p-3 border border-gray-600 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:border-indigo-400 bg-gray-700 text-gray-100 placeholder-gray-500 transition-all duration-200'
      : 'flex-1 p-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white/90 transition-all duration-200',
    recInput: isDarkMode
      ? 'w-full p-2 border border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:border-indigo-400 bg-gray-700 text-gray-100 placeholder-gray-500'
      : 'w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white/90',
    recFieldLabel: isDarkMode ? 'block text-xs text-gray-400 mb-1' : 'block text-xs text-gray-500 mb-1',
    recDiscountValue: isDarkMode
      ? 'p-2 text-sm bg-gray-600/60 border border-gray-600 rounded-lg text-red-400'
      : 'p-2 text-sm bg-gray-50 rounded-lg text-red-600',
    recFinalValue: isDarkMode
      ? 'p-2 text-sm font-semibold bg-gray-600/60 border border-gray-600 rounded-lg text-green-400'
      : 'p-2 text-sm font-semibold bg-gray-50 rounded-lg text-green-700',
    recRemoveBtn: isDarkMode
      ? 'p-3 rounded-xl text-red-400 hover:text-red-300 hover:bg-red-900/30 transition-colors'
      : 'p-3 rounded-xl text-red-500 hover:text-red-700 hover:bg-red-50 transition-colors',
    recAddBtn: isDarkMode
      ? 'inline-flex items-center px-4 py-2 text-sm font-medium text-indigo-300 border border-indigo-600 rounded-xl hover:bg-indigo-900/30 transition-colors'
      : 'inline-flex items-center px-4 py-2 text-sm font-medium text-indigo-600 border border-indigo-300 rounded-xl hover:bg-indigo-50 transition-colors',
    recTotalBar: isDarkMode
      ? 'mt-3 p-3 rounded-xl bg-indigo-900/30 border border-indigo-700/40 flex flex-wrap justify-end gap-x-6 gap-y-1 text-sm text-gray-300'
      : 'mt-3 p-3 rounded-xl bg-indigo-50/70 border border-indigo-100 flex flex-wrap justify-end gap-x-6 gap-y-1 text-sm text-gray-700',
    recDiscountText: isDarkMode ? 'text-red-400' : 'text-red-600',
    recFinalText: isDarkMode ? 'text-green-400' : 'text-green-700',
  }), [isDarkMode]);

  return (
    <div className={`${dc.page} quotation-dark-page`}>
      <div className="p-4 sm:p-6 w-full mx-auto">
        <BrandDiscountModal />
      <div className={dc.pageHeaderBorder}>
        <div className="flex items-center justify-between gap-4">
          <div>
            <h2 className={dc.headingText}>Quotation Management</h2>
            <p className={`text-xs sm:text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
              Create, edit and track quotations
            </p>
          </div>
          {/* Keyboard Shortcuts Tooltip */}
          <div className="relative group">
            <button
              type="button"
              className={`px-3 py-2 text-sm rounded-lg transition-colors flex items-center gap-1.5 ${
                isDarkMode
                  ? 'bg-blue-900/40 text-blue-300 hover:bg-blue-900/60'
                  : 'bg-blue-100 text-blue-700 hover:bg-blue-200'
              }`}
              title="Keyboard shortcuts"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 9l4-4 4 4m0 6l-4 4-4-4" />
              </svg>
              Shortcuts
            </button>
            <div className={`absolute top-full right-0 mt-2 w-72 p-3 text-xs rounded-lg shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50 bg-gray-900 text-white`}>
              <div className="font-medium mb-2">⌨️ Keyboard Shortcuts</div>
              <div className="space-y-1.5">
                <div className="flex justify-between items-center">
                  <span>Save / Create Quotation:</span>
                  <span className="font-mono bg-gray-700 px-1.5 py-0.5 rounded text-xs">Ctrl+S</span>
                </div>
                <div className="flex justify-between items-center">
                  <span>Add New Section:</span>
                  <span className="font-mono bg-gray-700 px-1.5 py-0.5 rounded text-xs">Alt+N</span>
                </div>
                <div className="flex justify-between items-center">
                  <span>Add Item to Last Section:</span>
                  <span className="font-mono bg-gray-700 px-1.5 py-0.5 rounded text-xs">Alt+A</span>
                </div>
                <div className="flex justify-between items-center">
                  <span>Move Item Up/Down:</span>
                  <span className="font-mono bg-gray-700 px-1.5 py-0.5 rounded text-xs">Alt+↑↓</span>
                </div>
                <div className="flex justify-between items-center">
                  <span>Move Section Up/Down:</span>
                  <span className="font-mono bg-gray-700 px-1.5 py-0.5 rounded text-xs">Alt+Shift+↑↓</span>
                </div>
                <div className="flex justify-between items-center">
                  <span>Close Modal:</span>
                  <span className="font-mono bg-gray-700 px-1.5 py-0.5 rounded text-xs">Esc</span>
                </div>
              </div>
              {/* Arrow pointing up */}
              <div className="absolute bottom-full right-4 w-0 h-0 border-l-4 border-r-4 border-b-4 border-l-transparent border-r-transparent border-b-gray-900"></div>
            </div>
          </div>
        </div>
      </div>

      {loading && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
          <div className="w-16 h-16 border-4 border-t-blue-500 border-gray-200 rounded-full animate-spin"></div>
        </div>
      )}
      
      <div className={dc.mainCard}>
        {/* Decorative Background Elements */}
        <div className="absolute top-0 right-0 w-40 h-40 bg-gradient-to-br from-blue-400/5 to-indigo-400/5 rounded-full -translate-y-20 translate-x-20"></div>
        <div className="absolute bottom-0 left-0 w-32 h-32 bg-gradient-to-tr from-purple-400/5 to-blue-400/5 rounded-full translate-y-16 -translate-x-16"></div>
        
        {/* Stylish Tab Navigation */}
        <div className={dc.tabNav}>
          <button
            onClick={() => setTabValue(0)}
            className={`group relative px-6 py-4 font-semibold border-b-3 transition-all duration-300 text-sm sm:text-base overflow-hidden ${
              tabValue === 0
                ? dc.tabActive0
                : dc.tabInactive
            }`}
          >
            <div className="relative z-10 flex items-center space-x-2">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
              </svg>
              <span>{edit ? 'Edit Quotation' : 'Create Quotation'}</span>
            </div>
            {tabValue === 0 && (
              <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-blue-500 to-indigo-600 transform origin-left transition-transform duration-300"></div>
            )}
            <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-blue-400/10 to-indigo-400/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          </button>
          <button
            onClick={() => setTabValue(1)}
            className={`group relative px-6 py-4 font-semibold border-b-3 transition-all duration-300 text-sm sm:text-base overflow-hidden ${
              tabValue === 1
                ? dc.tabActive1
                : dc.tabInactive
            }`}
          >
            <div className="relative z-10 flex items-center space-x-2">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
              </svg>
              <span>Quotations List</span>
            </div>
            {tabValue === 1 && (
              <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-green-500 to-emerald-600 transform origin-left transition-transform duration-300"></div>
            )}
            <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-green-400/10 to-emerald-400/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          </button>

          {/* Current mode indicator */}
          <div className="ml-auto flex items-center pr-4 py-2">
            <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold border ${
              edit
                ? (isDarkMode ? 'bg-amber-500/15 text-amber-300 border-amber-500/30' : 'bg-amber-50 text-amber-700 border-amber-200')
                : (isDarkMode ? 'bg-blue-500/15 text-blue-300 border-blue-500/30' : 'bg-blue-50 text-blue-700 border-blue-200')
            }`}>
              <span className={`w-1.5 h-1.5 rounded-full ${edit ? 'bg-amber-500' : 'bg-blue-500'}`} />
              {edit ? 'Edit Mode' : 'Create Mode'}
            </span>
          </div>
        </div>

        {/* Tab Content */}
        <div className="relative p-8">
        {tabValue === 0 && (
          <div>
            <div className="mb-8">
              {/* Stylish Basic Form Fields */}
              <div className={dc.formCard}>
                {/* Decorative Background Elements */}
                <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-blue-400/5 to-indigo-400/5 rounded-full -translate-y-12 translate-x-12"></div>
                <div className="absolute bottom-0 left-0 w-20 h-20 bg-gradient-to-tr from-purple-400/5 to-blue-400/5 rounded-full translate-y-10 -translate-x-10"></div>
                
                <div className="relative grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center">
                      <svg className="w-4 h-4 mr-2 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                      </svg>
                      Recipient Type <span className="text-red-500 ml-0.5">*</span>
                    </label>
                    <Select
                      value={{ value: form.recipientType, label: form.recipientType }}
                      onChange={(selectedOption) => setForm({ ...form, recipientType: selectedOption.value, recipient: null })}
                      options={[
                        { value: 'Customer', label: 'Customer' },
                        { value: 'Dealer', label: 'Dealer' },
                        { value: 'Reference', label: 'Reference' }
                      ]}
                      className="react-select-container"
                      classNamePrefix="react-select"
                      placeholder="Select Recipient Type"
                      isSearchable={false}
                      styles={customSelectStyles}
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center">
                      <svg className="w-4 h-4 mr-2 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                      </svg>
                      {form.recipientType} <span className="text-red-500 ml-0.5">*</span>
                    </label>
                    <button
                      type="button"
                      onClick={() => setShowRecipientModal(true)}
                      className={dc.recipientBtn}
                    >
                      <div className="flex items-center justify-between gap-2">
                        <span className={`${dc.recipientBtnText(!!form.recipient)} truncate`}>
                          {form.recipient 
                            ? form.recipient.label 
                            : `Select ${form.recipientType}`
                          }
                        </span>
                        <svg className="w-5 h-5 text-gray-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                        </svg>
                      </div>
                    </button>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center">
                      <svg className="w-4 h-4 mr-2 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
                      </svg>
                      Salesperson <span className="text-red-500 ml-0.5">*</span>
                    </label>
                    <Select
                      isMulti
                      value={employees.filter(emp => form.salesmen.includes(emp._id)).map(emp => ({
                        value: emp._id,
                        label: emp.name
                      }))}
                      onChange={(selectedOptions) => {
                        const selectedIds = selectedOptions ? selectedOptions.map(option => option.value) : [];
                        setForm({ ...form, salesmen: selectedIds });
                      }}
                      options={employees.map(emp => ({
                        value: emp._id,
                        label: emp.name
                      }))}
                      placeholder="Select salesperson"
                      className="basic-multi-select"
                      classNamePrefix="select"
                      styles={customSelectStyles}
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                    />
                  </div>

                  {/* Pricing Type Field */}
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center">
                      <svg className="w-4 h-4 mr-2 text-indigo-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                      </svg>
                      Pricing Type <span className="text-red-500 ml-0.5">*</span>
                    </label>
                    <Select
                      value={form.pricingType ? { value: form.pricingType, label: form.pricingType } : null}
                      onChange={(selectedOption) => setForm({ ...form, pricingType: selectedOption?.value || 'Item-wise' })}
                      options={[
                        { value: 'Item-wise', label: 'Item-wise' },
                        { value: 'Brand-wise', label: 'Brand-wise' }
                      ]}
                      placeholder="Select pricing type..."
                      isSearchable={false}
                      styles={customSelectStyles}
                      className="w-full"
                      menuPortalTarget={document.body}
                      menuPosition={'fixed'}
                    />
                  </div>

                  {/* Reference Field */}
                  <div className="col-span-1 sm:col-span-2">
                    <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center">
                      <svg className="w-4 h-4 mr-2 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                      </svg>
                      Reference <span className={`ml-1 text-xs font-normal ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>(Optional)</span>
                    </label>
                    <Select
                      options={references.map(ref => ({ value: ref._id, label: ref.name }))}
                      value={form.reference}
                      onChange={(selectedOption) => setForm({ ...form, reference: selectedOption })}
                      placeholder="Select a reference..."
                      isClearable={true}
                      styles={customSelectStyles}
                      className="w-full"
                      menuPortalTarget={document.body}
                      menuPosition={'fixed'}
                    />
                  </div>
                </div>

                {/* Visitor & Visits - full-width so the visits list never breaks the grid */}
                <div className={`relative mt-6 rounded-xl border p-4 ${isDarkMode ? 'bg-gray-900/40 border-gray-700' : 'bg-cyan-50/50 border-cyan-200'}`}>
                  <VisitorVisitSelector
                    isDarkMode={isDarkMode}
                    companyId={user?.user?.company?._id || user?.user?.company}
                    visitor={form.visitor}
                    visits={form.visits}
                    onChange={(visitorId, visitIds) =>
                      setForm(prev => ({...prev, visitor: visitorId, visits: visitIds}))
                    }
                  />
                </div>
              </div>

              {/* Stylish Sections */}
              <div className="space-y-10 mb-10">
                {form.sections.map((section, sectionIndex) => (
                  <div key={sectionIndex} data-section-idx={sectionIndex} className={dc.sectionCard}>
                    {/* Decorative Background Elements */}
                    <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-blue-400/10 to-purple-400/10 rounded-full -translate-y-16 translate-x-16"></div>
                    <div className="absolute bottom-0 left-0 w-24 h-24 bg-gradient-to-tr from-green-400/10 to-blue-400/10 rounded-full translate-y-12 -translate-x-12"></div>
                    
                    {/* Section Header */}
                    <div className={dc.sectionHeader}>
                      <div className="flex flex-col lg:flex-row lg:items-end gap-4">
                        <div className="flex-1 min-w-0">
                          <div className="flex items-center flex-wrap gap-2 mb-2">
                            <div className="flex items-center justify-center w-9 h-9 bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg shadow-md flex-shrink-0">
                              <span className="text-white font-bold text-sm">{sectionIndex + 1}</span>
                            </div>
                            <label className="text-sm font-semibold text-gray-700">
                              Section Name <span className="text-red-500 ml-0.5">*</span>
                            </label>
                            <span className={`text-[11px] font-semibold px-2 py-0.5 rounded-full border ${isDarkMode ? 'bg-gray-800 text-gray-300 border-gray-600' : 'bg-white/80 text-gray-600 border-gray-200'}`}>
                              {section.items.length} {section.items.length === 1 ? 'item' : 'items'}
                            </span>
                          </div>
                          <input
                            type="text"
                            value={section.name}
                            onChange={(e) => {
                              const newSections = [...form.sections];
                              newSections[sectionIndex].name = e.target.value;
                              setForm({ ...form, sections: newSections });
                            }}
                            ref={(el) => (sectionNameRefs.current[sectionIndex] = el)}
                            placeholder={`e.g. Section ${sectionIndex + 1} name`}
                            className={dc.sectionNameInput}
                          />
                        </div>

                        {/* Section Controls */}
                        <div className="flex items-center gap-2 flex-wrap">
                          <div className={dc.sectionControls}>
                            <button
                              type="button"
                              onClick={() => moveSectionUp(sectionIndex)}
                              disabled={sectionIndex === 0}
                              className={dc.sectionMoveBtn}
                              title="Move Up"
                              aria-label="Move section up"
                            >
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
                              </svg>
                            </button>
                            <button
                              type="button"
                              onClick={() => moveSectionDown(sectionIndex)}
                              disabled={sectionIndex === form.sections.length - 1}
                              className={dc.sectionMoveBtn}
                              title="Move Down"
                              aria-label="Move section down"
                            >
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
                              </svg>
                            </button>
                          </div>

                          <div className="flex items-center gap-1">
                            <button
                              type="button"
                              onClick={() => replicateSection(sectionIndex)}
                              className={dc.sectionActionBtn('green')}
                              title="Replicate Section"
                              aria-label="Replicate section"
                            >
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                              </svg>
                            </button>
                            <button
                              type="button"
                              onClick={() => copySection(sectionIndex)}
                              className={dc.sectionActionBtn('violet')}
                              title="Copy Section"
                              aria-label="Copy section"
                            >
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                              </svg>
                            </button>
                            <button
                              type="button"
                              onClick={() => deleteSection(sectionIndex)}
                              className={dc.sectionActionBtn('red')}
                              title="Delete Section"
                              aria-label="Delete section"
                            >
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                              </svg>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Items in Section */}
                    <div className="p-6 space-y-6">
                      {section.items.map((item, itemIndex) => (
                        <div key={itemIndex} data-item-pos={`${sectionIndex}-${itemIndex}`} className={dc.itemCard}>
                          {/* Item Index Badge */}
                          <div className="absolute -top-2 -left-2 flex items-center justify-center w-6 h-6 bg-gradient-to-r from-blue-500 to-blue-600 text-white text-xs font-bold rounded-full shadow-md">
                            {itemIndex + 1}
                          </div>
                          
                          {/* Additional Item Information - Displayed after selection */}
                          {item.item && typeof item.item === 'object' && (
                            <div className={dc.itemInfoPanel}>
                              {/* Header: title + item name (prominent) + MRP pill */}
                              <div className="flex items-start gap-3 mb-3 pb-3 border-b border-dashed" style={{ borderColor: isDarkMode ? 'rgba(71,85,105,0.6)' : 'rgba(99,102,241,0.25)' }}>
                                <div className="flex-1 min-w-0">
                                  <div className="flex items-center gap-1.5 mb-1">
                                    <svg className={`w-4 h-4 ${isDarkMode ? 'text-blue-400' : 'text-blue-600'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                    <h4 className={dc.itemInfoHeading}>Item Details</h4>
                                  </div>
                                  <div className={`${isDarkMode ? 'text-gray-100' : 'text-gray-900'} text-sm sm:text-base font-bold leading-snug break-words`}>
                                    {item.item.skuDescription || item.item.skuCode}
                                  </div>
                                  <div className={`${isDarkMode ? 'text-gray-400' : 'text-gray-500'} text-xs font-medium mt-1`}>
                                    SKU: <span className="font-semibold">{item.item.skuCode}</span>
                                  </div>
                                </div>
                                {item.item.mrp != null && (
                                  <div className={`${isDarkMode ? 'bg-blue-500/15 border-blue-500/30 text-blue-100' : 'bg-blue-50 border-blue-200 text-blue-800'} border px-3 py-2 rounded-lg text-right flex-shrink-0 shadow-sm`}>
                                    <div className="text-[10px] uppercase tracking-wider opacity-75 font-semibold">MRP</div>
                                    <div className="text-sm font-bold">₹{addCommas(item.item.mrp)}</div>
                                  </div>
                                )}
                              </div>

                              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2 text-xs">
                                {/* Brand */}
                                {item.item.brand && (
                                  <div className={dc.itemDetailBadge}>
                                    <span className={dc.itemDetailLabel}>Brand:</span>
                                    <div className={`${dc.itemAccent('brand')} font-semibold mt-0.5`}>{item.item.brand.name}</div>
                                  </div>
                                )}
                                
                                {/* Category */}
                                {item.item.category && (
                                  <div className={dc.itemDetailBadge}>
                                    <span className={dc.itemDetailLabel}>Category:</span>
                                    <div className={`${dc.itemAccent('category')} font-semibold mt-0.5`}>{item.item.category.name}</div>
                                  </div>
                                )}
                                
                                {/* Series */}
                                {item.item.series && (
                                  <div className={dc.itemDetailBadge}>
                                    <span className={dc.itemDetailLabel}>Series:</span>
                                    <div className={`${dc.itemAccent('series')} font-semibold mt-0.5`}>{item.item.series}</div>
                                  </div>
                                )}
                                
                                {/* HSN Code */}
                                <div className={dc.itemDetailBadge}>
                                  <span className={dc.itemDetailLabel}>HSN Code:</span>
                                  <div className={`${dc.itemAccent('hsn')} font-semibold mt-0.5`}>{item.item.hsnCode}</div>
                                </div>
                                
                                {/* GST Rate */}
                                <div className={dc.itemDetailBadge}>
                                  <span className={dc.itemDetailLabel}>GST Rate:</span>
                                  <div className={`${dc.itemAccent('gst')} font-semibold mt-0.5`}>{item.item.gstRate}%</div>
                                </div>
                                
                                {/* Available Offer Types */}
                                {item.item.offerType && (
                                  <div className={`${dc.itemDetailBadge} col-span-full`}>
                                    <span className={`${dc.itemDetailLabel} block mb-2`}>Available Offer Prices:</span>
                                    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7 gap-2">
                                      {Object.entries(item.item.offerType).map(([offerKey, offerValue]) => (
                                        offerValue > 0 && (
                                          <div key={offerKey} className={isDarkMode ? 'bg-blue-500/10 border border-blue-500/30 px-2 py-1.5 rounded-lg text-center' : 'bg-gradient-to-r from-blue-100 to-indigo-100 px-2 py-1.5 rounded-lg text-center'}>
                                            <div className={`${isDarkMode ? 'text-blue-300' : 'text-blue-700'} font-bold text-xs uppercase`}>{offerKey}</div>
                                            <div className={isDarkMode ? 'text-blue-100 font-semibold' : 'text-blue-800 font-semibold'}>₹{addCommas(offerValue)}</div>
                                          </div>
                                        )
                                      ))}
                                    </div>
                                  </div>
                                )}
                                
                                {/* Additional Field Values */}
                                {item.item.additionalFieldValues && Object.keys(item.item.additionalFieldValues).length > 0 && (
                                  <div className={`${dc.itemDetailBadge} col-span-full`}>
                                    <span className={`${dc.itemDetailLabel} block mb-2`}>Additional Information:</span>
                                    <div className="flex flex-wrap gap-2">
                                      {Object.entries(item.item.additionalFieldValues).map(([fieldName, value]) => (
                                        value && (
                                          <div key={fieldName} className={isDarkMode ? 'bg-purple-500/10 border border-purple-500/20 text-purple-200 px-3 py-1 rounded-full text-xs font-medium' : 'bg-purple-100 text-purple-900 px-3 py-1 rounded-full text-xs font-medium'}>
                                            <span className="font-semibold">{fieldName}:</span> {value}
                                          </div>
                                        )
                                      ))}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                          
                          {/* Responsive Grid System - All inputs in systematic arrangement */}
                          <div className="grid grid-cols-12 gap-3 mb-3">
                            
                            {/* Item Selection - Takes 2 columns on larger screens */}
                            <div className="col-span-12 md:col-span-5">
                              <label className="block text-xs font-semibold text-gray-700 mb-2 flex items-center">
                                <svg className="w-3 h-3 mr-1 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                                </svg>
                                Item *
                              </label>
                              <div className="flex">
                                <input
                                  type="text"
                                  value={typeof item.item === 'object' ? item.item.skuCode : item.item}
                                  readOnly
                                  placeholder="Select item"
                                  className={`flex-1 min-w-0 px-3 py-2.5 text-sm border rounded-l-xl bg-white/90 backdrop-blur-sm transition-all duration-200 shadow-sm ${
                                    isEmpty(item.item) ? 'border-red-300 bg-red-50/80' : 'border-gray-300 hover:border-blue-300'
                                  }`}
                                />
                                <button
                                  type="button"
                                  onClick={() => openItemModal((selectedItem) => {
                                    console.log('Selected item:', selectedItem);
                                    handleItemChange(sectionIndex, itemIndex, 'item', selectedItem);
                                    // Don't set focus position for item selection, only for offer type
                                  })}
                                  className={`px-4 py-2.5 text-white rounded-r-xl hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 transition-all duration-200 text-sm font-bold transform hover:scale-105 border-2 ${
                                    isEmpty(item.item) 
                                      ? 'bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 animate-pulse border-red-700 focus:ring-red-300' 
                                      : 'bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 border-blue-700 focus:ring-blue-300'
                                  }`}
                                  title={isEmpty(item.item) ? 'Select item (required)' : 'Change item'}
                                >
                                  {isEmpty(item.item) ? 'Select' : 'Change'}
                                </button>
                              </div>
                              {isEmpty(item.item) && (
                                <p className="text-red-500 text-xs mt-1 flex items-center">
                                  <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.664-.833-2.464 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z" />
                                  </svg>
                                  Required
                                </p>
                              )}
                            </div>

                            {/* Unit Selection */}
                            <div className="col-span-6 md:col-span-2">
                              <label className="block text-xs font-semibold text-gray-700 mb-2 flex items-center">
                                <svg className="w-3 h-3 mr-1 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zM21 5a2 2 0 00-2-2h-4a2 2 0 00-2 2v12a4 4 0 004 4h4a2 2 0 002-2V5z" />
                                </svg>
                                Unit
                              </label>
                              <Select
                                ref={(el) => {
                                  const unitRefKey = `${sectionIndex}-${itemIndex}`;
                                  if (el) {
                                    unitSelectRefs.current[unitRefKey] = el;
                                    console.log('Setting unit ref for key:', unitRefKey, el);
                                  }
                                }}
                                value={{ value: item.unit, label: item.unit.toUpperCase() }}
                                onChange={(selectedOption) => handleItemChange(sectionIndex, itemIndex, 'unit', selectedOption.value)}
                                options={availableUnits.map(unit => ({
                                  value: unit,
                                  label: unit.toUpperCase()
                                }))}
                                className="react-select-container"
                                classNamePrefix="react-select"
                                placeholder="Unit"
                                isSearchable={true}
                                openMenuOnFocus={true}
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                styles={{
                                  ...customSelectStyles,
                                  control: (provided, state) => ({
                                    ...provided,
                                    minHeight: '42px',
                                    fontSize: '13px',
                                    borderRadius: '12px',
                                    backgroundColor: isDarkMode ? '#374151' : 'rgba(255, 255, 255, 0.9)',
                                    border: state.isFocused ? `2px solid ${isDarkMode ? '#a78bfa' : '#a855f7'}` : `1px solid ${isDarkMode ? '#4b5563' : '#d1d5db'}`,
                                    backdropFilter: 'blur(4px)',
                                    transition: 'all 0.2s',
                                    boxShadow: state.isFocused ? `0 0 0 1px ${isDarkMode ? '#a78bfa' : '#a855f7'}` : '0 1px 3px rgba(0, 0, 0, 0.1)',
                                    position: 'relative',
                                    zIndex: 1,
                                  }),
                                  menu: (provided) => ({
                                    ...provided,
                                    zIndex: 99999,
                                    backgroundColor: isDarkMode ? '#1f2937' : 'white',
                                    border: `1px solid ${isDarkMode ? '#374151' : '#e5e7eb'}`,
                                  }),
                                  menuPortal: (provided) => ({
                                    ...provided,
                                    zIndex: 99999
                                  }),
                                  singleValue: (provided) => ({
                                    ...provided,
                                    textTransform: 'uppercase',
                                    fontWeight: '600',
                                    fontSize: '12px',
                                    color: isDarkMode ? '#f3f4f6' : '#374151',
                                  }),
                                  option: (provided, state) => ({
                                    ...provided,
                                    textTransform: 'uppercase',
                                    fontSize: '12px',
                                    backgroundColor: state.isSelected ? '#7c3aed' : state.isFocused ? (isDarkMode ? '#374151' : '#f3e8ff') : (isDarkMode ? '#1f2937' : 'white'),
                                    color: state.isSelected ? 'white' : (isDarkMode ? '#d1d5db' : '#374151'),
                                  }),
                                  input: (provided) => ({
                                    ...provided,
                                    color: isDarkMode ? '#f3f4f6' : '#374151',
                                  }),
                                  dropdownIndicator: (provided) => ({
                                    ...provided,
                                    color: isDarkMode ? '#9ca3af' : '#6b7280',
                                  }),
                                }}
                              />
                            </div>

                            {/* Quantity */}
                            <div className="col-span-6 md:col-span-2">
                              <label className="block text-xs font-semibold text-gray-700 mb-2 flex items-center">
                                <svg className="w-3 h-3 mr-1 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 20l4-16m2 16l4-16M6 9h14M4 15h14" />
                                </svg>
                                Qty *
                              </label>
                              <input
                                type="number"
                                min="1"
                                value={item.quantity}
                                ref={(el) => {
                                  if (!quantityInputRefs.current[sectionIndex]) {
                                    quantityInputRefs.current[sectionIndex] = [];
                                  }
                                  quantityInputRefs.current[sectionIndex][itemIndex] = el;
                                }}
                                onChange={(e) => handleItemChange(sectionIndex, itemIndex, 'quantity', parseInt(e.target.value) || 1)}
                                className="w-full px-3 py-2.5 text-sm font-semibold text-center border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500 bg-white/90 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md hover:border-green-300"
                              />
                            </div>

                            {/* Listed Price - Display only */}
                            <div className="col-span-12 md:col-span-3">
                              <label className="block text-xs font-semibold text-gray-700 mb-2 flex items-center">
                                <svg className="w-3 h-3 mr-1 text-yellow-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                                </svg>
                                Price
                              </label>
                              <div className={`w-full rounded-xl border px-3 py-2.5 text-sm font-semibold shadow-sm ${isDarkMode ? 'bg-gray-900/40 border-gray-700 text-gray-200' : 'bg-gray-50 border-gray-200 text-gray-700'}`}>
                                ₹{addCommas(item.listedPrice || 0)}
                              </div>
                            </div>

                            {/* Offer Type Selection */}
                            <div className="col-span-12 md:col-span-3">
                              <label className="block text-xs font-semibold text-gray-700 mb-2 flex items-center">
                                <svg className="w-3 h-3 mr-1 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                                </svg>
                                Offer Type <span className="text-red-500 ml-0.5">*</span>
                              </label>
                              <button
                                type="button"
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  handleOfferTypeSelection(sectionIndex, itemIndex, item);
                                }}
                                disabled={isEmpty(item.item)}
                                className={`w-full flex items-center justify-between gap-2 rounded-xl border px-3 py-2.5 text-sm font-semibold transition-all duration-200 shadow-sm focus:outline-none focus:ring-2 ${
                                  isEmpty(item.item)
                                    ? (isDarkMode ? 'bg-gray-800/60 border-gray-700 text-gray-500 cursor-not-allowed' : 'bg-gray-100 border-gray-200 text-gray-400 cursor-not-allowed')
                                    : isEmpty(item.offerType)
                                      ? (isDarkMode ? 'bg-orange-500/10 border-orange-500/40 text-orange-200 hover:border-orange-400 focus:ring-orange-400/40' : 'bg-orange-50 border-orange-300 text-orange-700 hover:border-orange-400 focus:ring-orange-300')
                                      : (isDarkMode ? 'bg-emerald-500/10 border-emerald-500/40 text-emerald-200 hover:border-emerald-400 focus:ring-emerald-400/40' : 'bg-green-50 border-green-300 text-green-800 hover:border-green-400 focus:ring-green-300')
                                }`}
                                title={isEmpty(item.item) ? 'Please select an item first' : 'Select offer type'}
                              >
                                <span className="flex items-center gap-2 min-w-0">
                                  {isEmpty(item.item) ? (
                                    <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                  ) : isEmpty(item.offerType) ? (
                                    <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.664-.833-2.464 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z" />
                                    </svg>
                                  ) : (
                                    <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                  )}
                                  <span className="truncate">
                                    {isEmpty(item.item) ? 'Select item first' : (isEmpty(item.offerType) ? 'Select offer type' : String(item.offerType).toUpperCase())}
                                  </span>
                                </span>
                                <svg className="w-4 h-4 flex-shrink-0 opacity-70" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                </svg>
                              </button>
                              {!isEmpty(item.item) && isEmpty(item.offerType) && (
                                <p className={`text-[11px] mt-1 flex items-center ${isDarkMode ? 'text-orange-300' : 'text-orange-600'}`}>
                                  The offer type is required before saving
                                </p>
                              )}
                            </div>

                            {/* Discount */}
                            <div className="col-span-12 md:col-span-2">
                              <label className="block text-xs font-semibold text-gray-700 mb-2 flex items-center">
                                <svg className="w-3 h-3 mr-1 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                                </svg>
                                Disc (%)
                              </label>
                              {form.pricingType === 'Brand-wise' ? (
  <div className="relative">
    <input
      type="number"
      value={item.discount || 0}
      disabled
      className={`w-full px-3 py-2.5 text-sm border rounded-xl ${isDarkMode ? 'border-gray-600 bg-gray-700 text-gray-300' : 'border-gray-300 bg-gray-100'} cursor-not-allowed`}
      placeholder="Brand discount"
    />
    <div className="absolute inset-y-0 right-0 pr-2 flex items-center">
      <span className="text-xs text-gray-500">Brand</span>
    </div>
  </div>
) : (
  <input
    type="number"
    min="0"
    max="100"
    step="0.01"
    value={item.discount || 0}
    onChange={(e) => handleItemChange(sectionIndex, itemIndex, 'discount', parseFloat(e.target.value) || 0)}
    className={`w-full px-3 py-2.5 text-sm border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-red-500 bg-white/90 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md hover:border-red-300 ${getValidationClass(sectionIndex, itemIndex, 'discount')}`}
    placeholder="Discount %"
  />
)}
                            </div>

                            {/* Offer Price - Display only */}
                            <div className="col-span-12 md:col-span-3">
                              <label className="block text-xs font-semibold text-gray-700 mb-2 flex items-center">
                                <svg className="w-3 h-3 mr-1 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                                </svg>
                                Offer Price
                              </label>
                              <div className={`w-full rounded-xl border px-3 py-2.5 text-sm font-semibold shadow-sm ${isDarkMode ? 'bg-blue-500/10 border-blue-500/30 text-blue-200' : 'bg-blue-50 border-blue-200 text-blue-700'}`}>
                                ₹{addCommas(item.offerPrice || 0)}
                              </div>
                            </div>

                            {/* Total - Display only */}
                            <div className="col-span-12 md:col-span-4">
                              <label className="block text-xs font-semibold text-gray-700 mb-2 flex items-center">
                                <svg className="w-3 h-3 mr-1 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                                </svg>
                                Total
                              </label>
                              <div className={`w-full rounded-xl border px-3 py-2.5 text-sm font-bold shadow-sm ${isDarkMode ? 'bg-indigo-500/15 border-indigo-500/30 text-indigo-200' : 'bg-gradient-to-r from-purple-50 to-pink-50 border-purple-200 text-purple-700'}`}>
                                ₹{addCommas(item.offerPriceTotal || 0)}
                              </div>
                            </div>

                            {/* Narration */}
                            <div className="col-span-12">
                              <label className="block text-xs font-semibold text-gray-700 mb-2 flex items-center">
                                <svg className="w-3 h-3 mr-1 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                </svg>
                                Narration
                              </label>
                              <textarea
                                value={item.narration || ''}
                                onChange={(e) => handleItemChange(sectionIndex, itemIndex, 'narration', e.target.value)}
                                placeholder="Enter item narration or description..."
                                rows={2}
                                className="w-full px-3 py-2.5 text-sm border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500 bg-white/90 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md hover:border-green-300 resize-none"
                              />
                            </div>
                          </div>

                          {/* Stylish Item Controls */}
                          <div className="flex justify-end mt-4">
                            <div className={dc.itemControls}>
                              <button
                                type="button"
                                onClick={() => moveItemUp(sectionIndex, itemIndex)}
                                disabled={itemIndex === 0}
                                className={dc.itemMoveBtn}
                                title="Move Up"
                              >
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
                                </svg>
                              </button>
                              <button
                                type="button"
                                onClick={() => moveItemDown(sectionIndex, itemIndex)}
                                disabled={itemIndex === section.items.length - 1}
                                className={dc.itemMoveBtn}
                                title="Move Down"
                              >
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
                                </svg>
                              </button>
                              <div className={dc.itemDivider}></div>
                              <button
                                type="button"
                                onClick={() => replicateItem(sectionIndex, itemIndex)}
                                className={isDarkMode ? 'p-2.5 text-orange-400 hover:bg-gray-500 rounded-lg transition-all duration-200 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-orange-300' : 'p-2.5 text-orange-600 hover:bg-orange-50 rounded-lg transition-all duration-200 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-orange-300'}
                                title="Replicate Item"
                              >
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2" />
                                </svg>
                              </button>
                              <button
                                type="button"
                                onClick={() => copyItem(sectionIndex, itemIndex)}
                                className={dc.itemCopyBtn}
                                title="Copy Item"
                              >
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                                </svg>
                              </button>
                              {form.sections.length > 1 && (
                                <button
                                  type="button"
                                  onClick={() => setTransferItemModal({ open: true, sectionIndex, itemIndex })}
                                  className={isDarkMode ? 'p-2.5 text-cyan-400 hover:bg-gray-500 rounded-lg transition-all duration-200 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-cyan-300' : 'p-2.5 text-cyan-600 hover:bg-cyan-50 rounded-lg transition-all duration-200 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-cyan-300'}
                                  title="Transfer to another section"
                                >
                                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
                                  </svg>
                                </button>
                              )}
                              <div className={dc.itemDivider}></div>
                              <button
                                type="button"
                                onClick={() => deleteItem(sectionIndex, itemIndex)}
                                className={dc.itemDeleteBtn}
                                title="Delete Item"
                              >
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                </svg>
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>

                    {/* Section Footer: Add Item + Subtotal */}
                    <div className="px-6 pb-6">
                      <div className="flex items-center gap-2">
                        <button
                          type="button"
                          onClick={() => addItem(sectionIndex)}
                          className={dc.sectionAddItemBar}
                          title="Add Item (Alt+A adds to last section)"
                        >
                          <svg className="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M12 4v16m8-8H4" />
                          </svg>
                          <span>Add Item</span>
                        </button>
                        {copiedItem && (
                          <button
                            type="button"
                            onClick={() => pasteItem(sectionIndex)}
                            className={dc.sectionPasteItemBar}
                            title="Paste copied item"
                          >
                            <svg className="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
                            </svg>
                            <span>Paste Copied Item</span>
                          </button>
                        )}
                      </div>

                      {/* Section Subtotal */}
                      <div className={dc.sectionSubTotal}>
                        <div className="flex items-center justify-between gap-4">
                          <div className="flex items-center gap-3 min-w-0">
                            <div className="flex items-center justify-center w-9 h-9 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-lg shadow-md flex-shrink-0">
                              <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                              </svg>
                            </div>
                            <div className="min-w-0">
                              <div className={dc.sectionSubTotalText}>Section Subtotal</div>
                              <div className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                {section.items.length} {section.items.length === 1 ? 'item' : 'items'} in this section
                              </div>
                            </div>
                          </div>
                          <div className={dc.sectionSubTotalValueBox}>
                            <span className={`text-xl font-bold ${isDarkMode ? 'text-blue-300' : 'text-blue-600'}`}>
                              ₹{addCommas(section.subTotal)}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}

                {/* Stylish Add Section Button */}
                <div className="text-center py-8 mb-8">
                  <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                    <button
                      type="button"
                      onClick={addSection}
                      className="group relative inline-flex items-center justify-center px-8 py-4 bg-gradient-to-r from-green-500 via-green-600 to-emerald-600 text-white font-semibold rounded-2xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 overflow-hidden"
                    >
                      <div className="absolute inset-0 bg-gradient-to-r from-green-400 to-emerald-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                      <svg className="w-5 h-5 mr-2 relative z-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                      </svg>
                      <span className="relative z-10">Add New Section</span>
                      <div className="absolute top-0 left-0 w-full h-full bg-white/20 transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700"></div>
                    </button>
                    {copiedSection && (
                      <button
                        type="button"
                        onClick={pasteSection}
                        className="group relative inline-flex items-center justify-center px-8 py-4 bg-gradient-to-r from-teal-500 via-teal-600 to-cyan-600 text-white font-semibold rounded-2xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 overflow-hidden"
                      >
                        <div className="absolute inset-0 bg-gradient-to-r from-teal-400 to-cyan-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                        <svg className="w-5 h-5 mr-2 relative z-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
                        </svg>
                        <span className="relative z-10">Paste Copied Section</span>
                        <div className="absolute top-0 left-0 w-full h-full bg-white/20 transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700"></div>
                      </button>
                    )}
                  </div>
                </div>
              </div>

              {/* Stylish Additional Charges Section */}
              <div className={dc.chargesCard}>
                {/* Decorative Background Elements */}
                <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-blue-400/10 to-indigo-400/10 rounded-full -translate-y-12 translate-x-12"></div>
                <div className="absolute bottom-0 left-0 w-20 h-20 bg-gradient-to-tr from-emerald-400/10 to-blue-400/10 rounded-full translate-y-10 -translate-x-10"></div>
                
                <div className="relative p-6">
                  <div className="flex items-center space-x-3 mb-6">
                    <div className="flex items-center justify-center w-10 h-10 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-xl shadow-md">
                      <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                      </svg>
                    </div>
                    <h3 className={dc.chargesTitle}>Additional Charges</h3>
                  </div>
                  
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center">
                        <svg className="w-4 h-4 mr-2 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
                        </svg>
                        Cartage
                      </label>
                      <input
                        type="number"
                        value={form.cartage}
                        onChange={(e) => {
                          const newForm = { ...form, cartage: parseFloat(e.target.value) || 0 };
                          setForm(newForm);
                          calculateTotalAmount(newForm);
                        }}
                        className="w-full p-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white/90 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md hover:border-blue-300"
                        placeholder="0.00"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center">
                        <svg className="w-4 h-4 mr-2 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
                        </svg>
                        Labour
                      </label>
                      <input
                        type="number"
                        value={form.labour}
                        onChange={(e) => {
                          const newForm = { ...form, labour: parseFloat(e.target.value) || 0 };
                          setForm(newForm);
                          calculateTotalAmount(newForm);
                        }}
                        className="w-full p-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500 bg-white/90 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md hover:border-green-300"
                        placeholder="0.00"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center">
                        <svg className="w-4 h-4 mr-2 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                        </svg>
                        Packing & Forwarding
                      </label>
                      <input
                        type="number"
                        value={form.packingAndForwarding}
                        onChange={(e) => {
                          const newForm = { ...form, packingAndForwarding: parseFloat(e.target.value) || 0 };
                          setForm(newForm);
                          calculateTotalAmount(newForm);
                        }}
                        className="w-full p-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500 bg-white/90 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md hover:border-purple-300"
                        placeholder="0.00"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center">
                        <svg className="w-4 h-4 mr-2 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                        </svg>
                        Round Off
                      </label>
                      <input
                        type="number"
                        value={form.roundOff}
                        onChange={(e) => {
                          const newForm = { ...form, roundOff: parseFloat(e.target.value) || 0 };
                          setForm(newForm);
                          calculateTotalAmount(newForm);
                        }}
                        className="w-full p-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 bg-white/90 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md hover:border-orange-300"
                        placeholder="0.00"
                      />
                    </div>
                  </div>
                  {/* Stylish Brand Discounts Section - Only show when Brand-wise pricing is selected */}
                  {form.pricingType === 'Brand-wise' && (
                    <div className="mt-8 pt-6 border-t border-gray-200/50">
                      <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-purple-50/50 via-indigo-50/30 to-blue-50/40 border border-purple-200/50 shadow-lg backdrop-blur-sm p-6">
                        {/* Decorative Background Elements */}
                        <div className="absolute top-0 right-0 w-16 h-16 bg-gradient-to-br from-purple-400/10 to-indigo-400/10 rounded-full -translate-y-8 translate-x-8"></div>
                        <div className="absolute bottom-0 left-0 w-12 h-12 bg-gradient-to-tr from-blue-400/10 to-purple-400/10 rounded-full translate-y-6 -translate-x-6"></div>
                        
                        <div className="relative">
                          <div className="flex items-center justify-between mb-6">
                            <div className="flex items-center space-x-3">
                              <div className="flex items-center justify-center w-10 h-10 bg-gradient-to-r from-purple-500 to-indigo-600 rounded-xl shadow-md">
                                <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                                </svg>
                              </div>
                              <div>
                                <h3 className="text-lg font-bold text-gray-800">Brand Discounts</h3>
                                <p className="text-sm text-gray-600">Manage brand-wise discount percentages</p>
                              </div>
                            </div>
                            
                            <button
                              type="button"
                              onClick={() => setBrandDiscountModal(true)}
                              className="group relative inline-flex items-center justify-center px-6 py-3 bg-gradient-to-r from-purple-500 via-indigo-600 to-blue-600 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 overflow-hidden"
                            >
                              <div className="absolute inset-0 bg-gradient-to-r from-purple-400 to-blue-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                              <svg className="w-4 h-4 mr-2 relative z-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                              </svg>
                              <span className="relative z-10">Manage Brand Discounts</span>
                              <div className="absolute top-0 left-0 w-full h-full bg-white/20 transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700"></div>
                            </button>
                          </div>
                          
                          {brandSummary.length > 0 ? (
                            <div className="space-y-4">
                              <div className="flex items-center space-x-2 mb-3">
                                <div className="flex items-center justify-center w-6 h-6 bg-gradient-to-r from-green-500 to-emerald-600 rounded-lg shadow-sm">
                                  <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                  </svg>
                                </div>
                                <span className="text-sm font-semibold text-gray-700">Applied Brand Discounts:</span>
                              </div>
                              
                              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                {brandSummary.map((brand, index) => (
                                  <div key={brand.brandId} className="relative overflow-hidden rounded-xl bg-gradient-to-r from-white via-gray-50/50 to-indigo-50/40 border border-gray-200/50 p-4 shadow-sm hover:shadow-md transition-all duration-200 backdrop-blur-sm">
                                    {/* Brand card decorative element */}
                                    <div className="absolute top-0 right-0 w-8 h-8 bg-gradient-to-br from-indigo-400/20 to-purple-400/20 rounded-full -translate-y-4 translate-x-4"></div>
                                    
                                    <div className="relative flex items-center justify-between">
                                      <div className="flex items-center space-x-3">
                                        <div className="flex items-center justify-center w-8 h-8 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-lg shadow-sm">
                                          <span className="text-white font-bold text-xs">{index + 1}</span>
                                        </div>
                                        <div>
                                          <h4 className="font-semibold text-gray-800 text-sm">{brand.brandName}</h4>
                                          <p className="text-xs text-gray-600">{brand.items.length} items</p>
                                        </div>
                                      </div>
                                      
                                      <div className="text-right">
                                        <div className="flex items-center space-x-2">
                                          <span className="inline-flex items-center px-2 py-1 bg-gradient-to-r from-orange-100 to-red-100 border border-orange-200/50 rounded-lg text-xs font-semibold text-orange-700">
                                            {brand.discountPercentage}%
                                          </span>
                                          <span className="inline-flex items-center px-2 py-1 bg-gradient-to-r from-green-100 to-emerald-100 border border-green-200/50 rounded-lg text-xs font-semibold text-green-700">
                                            ₹{addCommas(brand.discountAmount)} off
                                          </span>
                                        </div>
                                        <p className="text-xs text-gray-600 mt-1">Total: ₹{addCommas(brand.totalValue)}</p>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                              
                              {/* Summary Stats */}
                              <div className="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-4">
                                <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200/50 rounded-xl p-4 backdrop-blur-sm">
                                  <div className="flex items-center space-x-2">
                                    <svg className="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                                    </svg>
                                    <span className="text-sm font-medium text-gray-700">Total Brands</span>
                                  </div>
                                  <p className="text-lg font-bold text-blue-700 mt-1">{brandSummary.length}</p>
                                </div>
                                
                                <div className="bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200/50 rounded-xl p-4 backdrop-blur-sm">
                                  <div className="flex items-center space-x-2">
                                    <svg className="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                                    </svg>
                                    <span className="text-sm font-medium text-gray-700">Total Savings</span>
                                  </div>
                                  <p className="text-lg font-bold text-green-700 mt-1">
                                    ₹{addCommas(brandSummary.reduce((sum, brand) => sum + brand.discountAmount, 0))}
                                  </p>
                                </div>
                                
                                <div className="bg-gradient-to-r from-purple-50 to-pink-50 border border-purple-200/50 rounded-xl p-4 backdrop-blur-sm">
                                  <div className="flex items-center space-x-2">
                                    <svg className="w-4 h-4 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                                    </svg>
                                    <span className="text-sm font-medium text-gray-700">Avg. Discount</span>
                                  </div>
                                  <p className="text-lg font-bold text-purple-700 mt-1">
                                    {brandSummary.length > 0 ? 
                                      (brandSummary.reduce((sum, brand) => sum + brand.discountPercentage, 0) / brandSummary.length).toFixed(1) 
                                      : 0}%
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div className="text-center py-8">
                              <div className="flex flex-col items-center space-y-3">
                                <div className="flex items-center justify-center w-16 h-16 bg-gradient-to-r from-gray-100 to-gray-200 rounded-full">
                                  <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                                  </svg>
                                </div>
                                <div className="text-center">
                                  <h4 className="text-lg font-semibold text-gray-600 mb-1">No Brand Items Yet</h4>
                                  <p className="text-gray-500 text-sm max-w-xs">Add items with brands to your quotation sections to manage brand-wise discounts.</p>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Site Address Selection */}
                  <div className="mt-8 pt-6 border-t border-gray-200/50">
                    <label className="block text-sm font-semibold text-gray-700 mb-3 flex items-center">
                      <svg className="w-4 h-4 mr-2 text-indigo-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                      </svg>
                      Site Address
                    </label>
                    <textarea
                      value={form.siteAddress}
                      onChange={(e) => setForm({ ...form, siteAddress: e.target.value })}
                      rows="2"
                      className="w-full p-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white/90 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md hover:border-indigo-300 resize-none"
                      placeholder="Enter the site address for this quotation (optional)"
                    />
                  </div>

                  {/* Stylish Remarks Section */}
                  <div className="mt-8 pt-6 border-t border-gray-200/50">
                    <label className="block text-sm font-semibold text-gray-700 mb-3 flex items-center">
                      <svg className="w-4 h-4 mr-2 text-indigo-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                      </svg>
                      Remarks
                    </label>
                    <textarea
                      value={form.remarks}
                      onChange={(e) => setForm({ ...form, remarks: e.target.value })}
                      rows="3"
                      className="w-full p-4 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white/90 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md hover:border-indigo-300 resize-none"
                      placeholder="Enter any additional remarks or special instructions..."
                    />
                  </div>

                  {/* Recommended Items (separate estimate, not part of quotation totals) */}
                  {(() => {
                    const recs = (form.recommendations || []).map((rec) =>
                      typeof rec === 'string' ? { details: rec } : rec
                    );
                    const round2 = (n) => Math.round((Number(n) || 0) * 100) / 100;
                    const recTotals = recs.reduce((acc, rec) => {
                      const price = Number(rec.estimatedPrice) || 0;
                      const disc = Math.max(0, Math.min(100, Number(rec.estimatedDiscount) || 0));
                      const discAmt = round2(price * disc / 100);
                      acc.price = round2(acc.price + price);
                      acc.discount = round2(acc.discount + discAmt);
                      acc.final = round2(acc.final + (price - discAmt));
                      return acc;
                    }, { price: 0, discount: 0, final: 0 });

                    const updateRec = (idx, field, value) => {
                      const next = recs.map((r) => ({ ...r }));
                      next[idx] = { ...next[idx], [field]: value };
                      setForm({ ...form, recommendations: next });
                    };

                    return (
                      <div className="mt-8 pt-6 border-t border-gray-200/50">
                        <label className="block text-sm font-semibold text-gray-700 mb-1 flex items-center">
                          <svg className={dc.recIcon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
                          </svg>
                          Recommended Items
                        </label>
                        <p className={dc.recHint}>
                          Estimated suggestions only — calculated separately and not included in the quotation total.
                        </p>
                        <div className="space-y-3">
                          {recs.map((rec, recIndex) => {
                            const price = Number(rec.estimatedPrice) || 0;
                            const disc = Math.max(0, Math.min(100, Number(rec.estimatedDiscount) || 0));
                            const discAmt = Math.round(price * disc) / 100;
                            const finalPrice = Math.round((price - discAmt) * 100) / 100;
                            return (
                              <div key={recIndex} className={dc.recCard}>
                                <div className="flex items-center space-x-2 mb-2">
                                  <input
                                    type="text"
                                    value={rec.details || ''}
                                    onChange={(e) => updateRec(recIndex, 'details', e.target.value)}
                                    className={dc.recDetailsInput}
                                    placeholder={`Recommendation details ${recIndex + 1}`}
                                  />
                                  <button
                                    type="button"
                                    onClick={() => setForm({ ...form, recommendations: recs.filter((_, i) => i !== recIndex) })}
                                    className={dc.recRemoveBtn}
                                    title="Remove"
                                  >
                                    <FaTimes />
                                  </button>
                                </div>
                                <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
                                  <div>
                                    <label className={dc.recFieldLabel}>Est. Price (₹)</label>
                                    <input
                                      type="number"
                                      min="0"
                                      value={rec.estimatedPrice ?? 0}
                                      onChange={(e) => updateRec(recIndex, 'estimatedPrice', e.target.value)}
                                      className={dc.recInput}
                                    />
                                  </div>
                                  <div>
                                    <label className={dc.recFieldLabel}>Est. Discount (%)</label>
                                    <input
                                      type="number"
                                      min="0"
                                      max="100"
                                      value={rec.estimatedDiscount ?? 0}
                                      onChange={(e) => updateRec(recIndex, 'estimatedDiscount', e.target.value)}
                                      className={dc.recInput}
                                    />
                                  </div>
                                  <div>
                                    <label className={dc.recFieldLabel}>Discount Amt (₹)</label>
                                    <div className={dc.recDiscountValue}>₹{addCommas(discAmt)}</div>
                                  </div>
                                  <div>
                                    <label className={dc.recFieldLabel}>Est. Final (₹)</label>
                                    <div className={dc.recFinalValue}>₹{addCommas(finalPrice)}</div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                          <button
                            type="button"
                            onClick={() => setForm({ ...form, recommendations: [...recs, { details: '', estimatedPrice: 0, estimatedDiscount: 0 }] })}
                            className={dc.recAddBtn}
                          >
                            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                            </svg>
                            Add Recommended Item
                          </button>
                        </div>

                        {recs.length > 0 && (
                          <div className={dc.recTotalBar}>
                            <span>Recommended Total: <strong>₹{addCommas(recTotals.price)}</strong></span>
                            <span className={dc.recDiscountText}>Discount: <strong>-₹{addCommas(recTotals.discount)}</strong></span>
                            <span className={dc.recFinalText}>Estimated Final: <strong>₹{addCommas(recTotals.final)}</strong></span>
                          </div>
                        )}
                      </div>
                    );
                  })()}
                </div>
              </div>

              {/* Stylish Validation Summary */}
              {(() => {
                const incompleteItems = [];
                form.sections.forEach((section, sectionIndex) => {
                  section.items.forEach((item, itemIndex) => {
                    const issues = [];
                    if (!item.item) issues.push('Item not selected');
                    if (!item.offerType) issues.push('Offer type not selected');
                    if (item.quantity <= 0) issues.push('Invalid quantity');
                    
                    if (issues.length > 0) {
                      incompleteItems.push({
                        section: sectionIndex + 1,
                        item: itemIndex + 1,
                        sectionName: section.name || `Section ${sectionIndex + 1}`,
                        issues
                      });
                    }
                  });
                });

                if (incompleteItems.length > 0) {
                  return (
                    <div className={dc.validationCard}>
                      {/* Decorative Background Elements */}
                      <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-br from-amber-400/10 to-orange-400/10 rounded-full -translate-y-10 translate-x-10"></div>
                      <div className="absolute bottom-0 left-0 w-16 h-16 bg-gradient-to-tr from-red-400/10 to-amber-400/10 rounded-full translate-y-8 -translate-x-8"></div>
                      
                      <div className="relative p-6">
                        <div className="flex items-center space-x-3 mb-4">
                          <div className="flex items-center justify-center w-10 h-10 bg-gradient-to-r from-amber-500 to-orange-600 rounded-xl shadow-md">
                            <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.664-.833-2.464 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z" />
                            </svg>
                          </div>
                          <span className={`font-bold text-lg ${isDarkMode ? 'text-amber-200' : 'text-amber-800'}`}>Please complete the following items:</span>
                        </div>
                        <div className={dc.validationCardInner}>
                          {incompleteItems.map((incomplete, index) => (
                            <div key={index} className={dc.validationItem}>
                              <div className="flex items-center justify-center w-6 h-6 bg-gradient-to-r from-amber-500 to-orange-600 text-white text-xs font-bold rounded-full shadow-sm mt-0.5">
                                {index + 1}
                              </div>
                              <div className="flex-1">
                                <div className={`font-semibold mb-1 ${isDarkMode ? 'text-amber-200' : 'text-amber-800'}`}>{incomplete.sectionName} - Item {incomplete.item}</div>
                                <div className={`text-sm flex flex-wrap gap-1 ${isDarkMode ? 'text-amber-300' : 'text-amber-700'}`}>
                                  {incomplete.issues.map((issue, issueIndex) => (
                                    <span key={issueIndex} className={`inline-flex items-center px-2 py-1 rounded-md text-xs font-medium ${isDarkMode ? 'bg-amber-900/50 text-amber-200 border border-amber-700/60' : 'bg-amber-200/60 text-amber-800'}`}>
                                      {issue}
                                    </span>
                                  ))}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  );
                }
                return null;
              })()}

              {/* Stylish Action Buttons and Total */}
              <div className={dc.actionButtonsCard}>
                {/* Decorative Background Elements */}
                <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-blue-400/5 to-indigo-400/5 rounded-full -translate-y-16 translate-x-16"></div>
                <div className="absolute bottom-0 left-0 w-24 h-24 bg-gradient-to-tr from-green-400/5 to-blue-400/5 rounded-full translate-y-12 -translate-x-12"></div>
                
                <div className="relative flex flex-col sm:flex-row sm:justify-between sm:items-center p-6 space-y-6 sm:space-y-0">
                  {/* Action Buttons */}
                  <div className="flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-4">
                    <button 
                      onClick={handleSubmitQuotation}
                      disabled={loading || !isFormReady()}
                      className={`group relative inline-flex items-center justify-center px-8 py-4 font-semibold rounded-2xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 overflow-hidden ${
                        loading || !isFormReady() 
                          ? 'bg-gray-400 cursor-not-allowed opacity-50 text-gray-300' 
                          : 'bg-gradient-to-r from-blue-500 via-blue-600 to-indigo-600 text-white hover:from-blue-600 hover:to-indigo-700'
                      }`}
                      title={!isFormReady() ? 'Please complete all required fields' : ''}
                    >
                      {!loading && !isFormReady() && (
                        <div className="absolute inset-0 bg-gradient-to-r from-red-400/20 to-orange-400/20 opacity-100"></div>
                      )}
                      {loading || isFormReady() ? (
                        <div className="absolute inset-0 bg-gradient-to-r from-blue-400 to-indigo-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                      ) : null}
                      <svg className="w-5 h-5 mr-2 relative z-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={edit ? "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" : "M12 6v6m0 0v6m0-6h6m-6 0H6"} />
                      </svg>
                      <span className="relative z-10">{edit ? 'Update Quotation' : 'Create Quotation'}</span>
                      {(loading || isFormReady()) && (
                        <div className="absolute top-0 left-0 w-full h-full bg-white/20 transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700"></div>
                      )}
                    </button>
                    
                    <button 
                      onClick={resetForm}
                      disabled={loading}
                      className={dc.resetBtn}
                    >
                      <div className="absolute inset-0 bg-white/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                      <svg className="w-5 h-5 mr-2 relative z-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                      </svg>
                      <span className="relative z-10">Reset</span>
                      <div className="absolute top-0 left-0 w-full h-full bg-white/30 transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700"></div>
                    </button>
                  </div>
                  
                  {/* Stylish Total Amount Display */}
                  <div className="relative group">
                    <div className="absolute inset-0 bg-gradient-to-r from-emerald-400/20 to-blue-400/20 rounded-2xl blur-xl group-hover:blur-2xl transition-all duration-300"></div>
                    <div className={dc.totalAmountCard}>
                      <div className="flex items-center space-x-4">
                        <div className="flex items-center justify-center w-12 h-12 bg-gradient-to-r from-emerald-500 to-blue-600 rounded-xl shadow-md">
                          <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                          </svg>
                        </div>
                        <div className="text-left">
                          <p className={dc.totalAmountLabel}>Total Amount</p>
                          <div className="text-3xl font-bold bg-gradient-to-r from-emerald-600 via-blue-600 to-indigo-600 bg-clip-text text-transparent">
                            ₹{addCommas(form.totalAmount)}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Quotations List Tab */}
        {tabValue === 1 && (
          <div>
            {/* Enhanced Header Section */}
            <div className={dc.listTabCard}>
              <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center mb-6">
                <div>
                  <h2 className={dc.listTabHeading}>Quotations Management</h2>
                  <p className={dc.listTabSubtext}>
                    Total: <span className="font-semibold text-blue-600">{totalQuotations}</span> quotations
                    {getFilteredCount() !== totalQuotations && (
                      <span className="ml-2 text-sm text-gray-500">
                        (Showing {getFilteredCount()} filtered)
                      </span>
                    )}
                  </p>
                </div>
                
                {/* Quick Stats */}
                <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-3 mt-4 lg:mt-0">
                  <div className={`rounded-lg p-3 text-center ${isDarkMode ? 'bg-gray-700 border border-gray-600' : 'bg-green-50 border border-green-100'}`}>
                    <div className={`text-lg font-bold ${isDarkMode ? 'text-green-300' : 'text-green-700'}`}>{listStats.completed}</div>
                    <div className={`text-xs ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>Completed</div>
                  </div>
                  <div className={`rounded-lg p-3 text-center ${isDarkMode ? 'bg-gray-700 border border-gray-600' : 'bg-yellow-50 border border-yellow-100'}`}>
                    <div className={`text-lg font-bold ${isDarkMode ? 'text-yellow-300' : 'text-yellow-700'}`}>{listStats.partial}</div>
                    <div className={`text-xs ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>Partial</div>
                  </div>
                  <div className={`rounded-lg p-3 text-center ${isDarkMode ? 'bg-gray-700 border border-gray-600' : 'bg-blue-50 border border-blue-100'}`}>
                    <div className={`text-lg font-bold ${isDarkMode ? 'text-blue-300' : 'text-blue-700'}`}>{listStats.pending}</div>
                    <div className={`text-xs ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>Pending</div>
                  </div>
                  <div className={`rounded-lg p-3 text-center ${isDarkMode ? 'bg-gray-700 border border-gray-600' : 'bg-red-50 border border-red-100'}`}>
                    <div className={`text-lg font-bold ${isDarkMode ? 'text-red-300' : 'text-red-700'}`}>{listStats.rejected}</div>
                    <div className={`text-xs ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>Rejected</div>
                  </div>
                  <div className={`rounded-lg p-3 text-center ${isDarkMode ? 'bg-gray-700 border border-gray-600' : 'bg-indigo-50 border border-indigo-100'}`}>
                    <div className={`text-sm font-bold ${isDarkMode ? 'text-indigo-300' : 'text-indigo-700'}`}>₹{addCommas(listStats.totalAmount)}</div>
                    <div className={`text-xs ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>Total Value</div>
                  </div>
                  <div className={`rounded-lg p-3 text-center ${isDarkMode ? 'bg-gray-700 border border-gray-600' : 'bg-purple-50 border border-purple-100'}`}>
                    <div className={`text-sm font-bold ${isDarkMode ? 'text-purple-300' : 'text-purple-700'}`}>₹{addCommas(listStats.avgAmount)}</div>
                    <div className={`text-xs ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>Avg. Value</div>
                  </div>
                </div>
              </div>

              {/* Enhanced Filters Section */}
              <div className={`${dc.filterBox} overflow-hidden`}>
                {/* Filter header banner */}
                <div className={`-mx-4 -mt-4 mb-4 px-4 py-3 bg-gradient-to-r ${isDarkMode ? 'from-indigo-900/60 via-blue-900/40 to-purple-900/50 border-b border-indigo-800/50' : 'from-indigo-500 via-blue-500 to-purple-600'} flex flex-col lg:flex-row lg:items-center lg:justify-between rounded-t-lg`}>
                  <div className="flex items-center space-x-2">
                    <div className={`w-8 h-8 rounded-lg flex items-center justify-center shadow-sm ${isDarkMode ? 'bg-indigo-800/60 text-indigo-200' : 'bg-white/20 text-white'}`}>
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
                      </svg>
                    </div>
                    <div>
                      <h3 className={`text-base font-bold ${isDarkMode ? 'text-indigo-200' : 'text-white'}`}>Advanced Filters</h3>
                      {activeFilters.length > 0 && (
                        <p className={`text-xs ${isDarkMode ? 'text-indigo-300' : 'text-indigo-100'}`}>
                          {activeFilters.length} active filter{activeFilters.length > 1 ? 's' : ''}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="flex flex-wrap items-center gap-2 mt-2 lg:mt-0">
                    <button
                      onClick={resetFilters}
                      className={`px-3 py-1.5 text-sm rounded-lg transition-colors flex items-center gap-1.5 ${
                        isDarkMode
                          ? 'bg-gray-700 text-gray-200 hover:bg-gray-600 border border-gray-600'
                          : 'bg-white/20 text-white hover:bg-white/30 backdrop-blur-sm border border-white/30'
                      }`}
                    >
                      <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                      </svg>
                      Reset Filters
                    </button>
                    <button
                      onClick={exportAllQuotationsToExcel}
                      disabled={loading}
                      className="px-3 py-1.5 text-sm rounded-lg bg-green-600 text-white hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center gap-1.5 shadow-sm"
                    >
                      <FaFileDownload className="text-xs" />
                      Export to Excel
                    </button>
                    <div className="flex items-center space-x-2">
                      <span className={`text-sm ${isDarkMode ? 'text-gray-300' : 'text-white'}`}>View:</span>
                      <div className="flex rounded-lg overflow-hidden bg-black/10">
                        <button
                          onClick={() => handleFilterChange('viewMode', 'grid')}
                          className={`px-3 py-1.5 text-sm transition-colors ${
                            filters.viewMode === 'grid'
                              ? 'bg-white text-blue-600 font-semibold shadow-sm'
                              : isDarkMode ? 'text-gray-300 hover:bg-white/10' : 'text-white hover:bg-white/10'
                          }`}
                        >
                          Grid
                        </button>
                        <button
                          onClick={() => handleFilterChange('viewMode', 'list')}
                          className={`px-3 py-1.5 text-sm transition-colors ${
                            filters.viewMode === 'list'
                              ? 'bg-white text-blue-600 font-semibold shadow-sm'
                              : isDarkMode ? 'text-gray-300 hover:bg-white/10' : 'text-white hover:bg-white/10'
                          }`}
                        >
                          List
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Active filter chips */}
                {activeFilters.length > 0 && (
                  <div className="flex flex-wrap items-center gap-2 mb-4">
                    <span className={`text-xs font-semibold uppercase tracking-wide ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>Active:</span>
                    {activeFilters.map((chip) => (
                      <span
                        key={chip.key}
                        className={`inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium rounded-full border transition-colors ${
                          isDarkMode
                            ? 'bg-indigo-900/40 border-indigo-700/50 text-indigo-200'
                            : 'bg-indigo-50 border-indigo-200 text-indigo-700'
                        }`}
                      >
                        {chip.label}
                        <button
                          onClick={() => removeFilter(chip.key)}
                          className="hover:text-red-500 transition-colors"
                          title={`Remove ${chip.label}`}
                        >
                          <FaTimes size={10} />
                        </button>
                      </span>
                    ))}
                  </div>
                )}

                {/* Filter Controls */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4 mb-4">
                  {/* Search */}
                  <div className="xl:col-span-2">
                    <label className={`block text-sm font-medium mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Search</label>
                    <div className="relative">
                      <input
                        type="text"
                        placeholder="Search by ID, recipient name, or remarks..."
                        value={filters.searchTerm}
                        onChange={(e) => handleFilterChange('searchTerm', e.target.value)}
                        className={dc.filterInput}
                      />
                      <svg className="absolute left-3 top-3 w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                      </svg>
                    </div>
                  </div>

                  {/* Status Filter */}
                  <div>
                    <label className={`block text-sm font-medium mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Status</label>
                    <Select
                      value={filters.status ? { value: filters.status, label: filters.status } : null}
                      onChange={(selectedOption) => handleFilterChange('status', selectedOption?.value || '')}
                      options={[
                        { value: '', label: 'All Status' },
                        { value: 'PENDING', label: 'Pending' },
                        { value: 'PARTIAL-COMPLETE', label: 'Partial Complete' },
                        { value: 'PARTIALLY-CLOSED', label: 'Partially Closed' },
                        { value: 'APPROVED', label: 'Approved' },
                        { value: 'REJECTED', label: 'Rejected' }
                      ]}
                      className="react-select-container"
                      classNamePrefix="react-select"
                      placeholder="All Status"
                      isSearchable={false}
                      isClearable={true}
                      styles={customSelectStyles}
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                    />
                  </div>

                  {/* Recipient Type Filter */}
                  <div>
                    <label className={`block text-sm font-medium mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Recipient Type</label>
                    <Select
                      value={filters.recipientType ? { value: filters.recipientType, label: filters.recipientType } : null}
                      onChange={(selectedOption) => handleFilterChange('recipientType', selectedOption?.value || '')}
                      options={[
                        { value: '', label: 'All Types' },
                        { value: 'Customer', label: 'Customer' },
                        { value: 'Dealer', label: 'Dealer' },
                        { value: 'Reference', label: 'Reference' }
                      ]}
                      className="react-select-container"
                      classNamePrefix="react-select"
                      placeholder="All Types"
                      isSearchable={false}
                      isClearable={true}
                      styles={customSelectStyles}
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                    />
                  </div>

                  {/* Salesperson Filter */}
                  <div>
                    <label className={`block text-sm font-medium mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Salesperson</label>
                    <Select
                      value={filters.salesmanId ? employees.find(emp => emp._id === filters.salesmanId) ? { value: filters.salesmanId, label: employees.find(emp => emp._id === filters.salesmanId).name } : null : null}
                      onChange={(selectedOption) => handleFilterChange('salesmanId', selectedOption?.value || '')}
                      options={[
                        { value: '', label: 'All Salesperson' },
                        ...employees.map(emp => ({
                          value: emp._id,
                          label: emp.name
                        }))
                      ]}
                      className="react-select-container"
                      classNamePrefix="react-select"
                      placeholder="All Salesperson"
                      isSearchable={true}
                      isClearable={true}
                      styles={customSelectStyles}
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                    />
                  </div>

                  {/* Created By Filter */}
                  <div>
                    <label className={`block text-sm font-medium mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Created By</label>
                    <Select
                      value={filters.createdById ? employees.find(emp => emp._id === filters.createdById) ? { value: filters.createdById, label: employees.find(emp => emp._id === filters.createdById).name } : null : null}
                      onChange={(selectedOption) => handleFilterChange('createdById', selectedOption?.value || '')}
                      options={[
                        { value: '', label: 'My Quotations' },
                        ...employees.map(emp => ({
                          value: emp._id,
                          label: emp.name
                        }))
                      ]}
                      className="react-select-container"
                      classNamePrefix="react-select"
                      placeholder="My Quotations"
                      isSearchable={true}
                      isClearable={true}
                      styles={customSelectStyles}
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                  {/* Date Range */}
                  <div>
                    <label className={`block text-sm font-medium mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Start Date</label>
                    <input
                      type="date"
                      value={filters.startDate ? filters.startDate.toISOString().split('T')[0] : ''}
                      onChange={(e) => handleFilterChange('startDate', e.target.value ? new Date(e.target.value) : null)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                  </div>

                  <div>
                    <label className={`block text-sm font-medium mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>End Date</label>
                    <input
                      type="date"
                      value={filters.endDate ? filters.endDate.toISOString().split('T')[0] : ''}
                      onChange={(e) => handleFilterChange('endDate', e.target.value ? new Date(e.target.value) : null)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                  </div>

                  {/* Amount Range */}
                  <div>
                    <label className={`block text-sm font-medium mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Min Amount (₹)</label>
                    <input
                      type="number"
                      placeholder="Min amount"
                      value={filters.amountRange.min}
                      onChange={(e) => handleFilterChange('amountRange', { ...filters.amountRange, min: e.target.value })}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                  </div>

                  <div>
                    <label className={`block text-sm font-medium mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Max Amount (₹)</label>
                    <input
                      type="number"
                      placeholder="Max amount"
                      value={filters.amountRange.max}
                      onChange={(e) => handleFilterChange('amountRange', { ...filters.amountRange, max: e.target.value })}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                  </div>
                </div>

                {/* Sort Controls */}
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mt-4 pt-4 border-t border-gray-200">
                  <div className="flex flex-col sm:flex-row sm:items-center space-y-2 sm:space-y-0 sm:space-x-4">
                    <div className="flex items-center space-x-2">
                      <label className="text-sm font-medium text-gray-700">Sort by:</label>
                      <select
                        value={filters.sortBy}
                        onChange={(e) => handleFilterChange('sortBy', e.target.value)}
                        className="px-3 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                      >
                        <option value="createdAt">Created Date</option>
                        <option value="updatedAt">Updated Date</option>
                        <option value="totalAmount">Total Amount</option>
                        <option value="id">Quotation ID</option>
                        <option value="status">Status</option>
                      </select>
                    </div>
                    <div className="flex items-center space-x-2">
                      <label className="text-sm font-medium text-gray-700">Order:</label>
                      <select
                        value={filters.sortOrder}
                        onChange={(e) => handleFilterChange('sortOrder', e.target.value)}
                        className="px-3 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                      >
                        <option value="desc">Newest First</option>
                        <option value="asc">Oldest First</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Enhanced Quotations Display */}
            {loading ? (
              <div className="grid gap-4">
                {Array.from({ length: 3 }, (_, index) => (
                  <div key={index} className="bg-white border border-gray-200 rounded-lg p-6 animate-pulse">
                    <div className="flex justify-between items-start mb-4">
                      <div className="space-y-2">
                        <div className="h-6 bg-gray-300 rounded w-32"></div>
                        <div className="h-4 bg-gray-300 rounded w-48"></div>
                        <div className="h-4 bg-gray-300 rounded w-36"></div>
                      </div>
                      <div className="h-6 bg-gray-300 rounded w-20"></div>
                    </div>
                    <div className="grid grid-cols-3 gap-4">
                      <div className="h-4 bg-gray-300 rounded"></div>
                      <div className="h-4 bg-gray-300 rounded"></div>
                      <div className="h-4 bg-gray-300 rounded"></div>
                    </div>
                  </div>
                ))}
              </div>
            ) : quotations.length > 0 ? (
              <div className={`${filters.viewMode === 'grid' ? 'grid gap-6' : 'space-y-4'}`}>
                {quotations.map((quotation) => (
                  <div 
                    key={quotation._id} 
                    className={`quotation-card bg-white border border-gray-200 rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 view-transition ${
                      filters.viewMode === 'grid' ? 'p-6' : 'p-4'
                    }`}
                  >
                    {filters.viewMode === 'grid' ? (
                      // Grid View - Enhanced Card Layout
                      <>
                        {/* Header Section */}
                        <div className="flex flex-col lg:flex-row lg:justify-between lg:items-start mb-6">
                          <div className="flex-1">
                            <div className="flex items-center space-x-3 mb-2">
                              <h3 className="text-xl font-bold text-gray-800">{quotation.id}</h3>
                              <span className={`status-badge px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wide ${getStatusColorClass(quotation.status)}`}>
                                {quotation.status}
                              </span>
                              {quotation.versions && quotation.versions.length > 1 && (
                                <span className="px-2 py-1 bg-blue-50 text-blue-700 text-xs font-medium rounded-full">
                                  v{quotation.versions.length}
                                </span>
                              )}
                              <span className="px-2 py-1 bg-indigo-50 text-indigo-700 text-xs font-medium rounded-full flex items-center cursor-pointer hover:bg-indigo-100 transition-colors" 
                                    onClick={() => handleViewQuotation(quotation)}
                                    title="Click for detailed view">
                                <FaEye className="mr-1" size={10} />
                                View Details
                              </span>
                            </div>
                            
                            <div className="space-y-2">
                              <div className="flex items-center text-gray-700">
                                <svg className="w-4 h-4 mr-2 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                </svg>
                                <span className="font-medium">
                                  {quotation.recipient?.name || quotation.recipient?.businessName || 'Unknown Recipient'}
                                </span>
                                <span className="ml-2 px-2 py-1 bg-gray-100 text-gray-600 text-xs rounded">
                                  {quotation.recipientType}
                                </span>
                              </div>
                              
                              {quotation.recipient?.station?.name && (
                                <div className="flex items-center text-gray-600">
                                  <svg className="w-4 h-4 mr-2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                  </svg>
                                  <span className="text-sm">{quotation.recipient.station.name}</span>
                                </div>
                              )}
                              
                              {quotation.salesmen && quotation.salesmen.length > 0 && (
                                <div className="flex items-center text-gray-600">
                                  <svg className="w-4 h-4 mr-2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                  </svg>
                                  <span className="text-sm">
                                    {quotation.salesmen.map(s => s.name).join(', ')}
                                  </span>
                                </div>
                              )}

                              {(quotation.createdBy?.name || quotation.createdBy) && (
                                <div className="flex items-center text-gray-600">
                                  <svg className="w-4 h-4 mr-2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                  </svg>
                                  <span className="text-sm">
                                    <span className="text-gray-400">Created by:</span>{' '}
                                    <span className="font-medium">{typeof quotation.createdBy === 'object' ? quotation.createdBy.name || quotation.createdBy._id : quotation.createdBy}</span>
                                  </span>
                                </div>
                              )}
                            </div>
                          </div>
                          
                          {/* Actions */}
                          <div className="flex items-center space-x-2 mt-4 lg:mt-0">
                            <button
                              onClick={() => openEditQuotation(quotation)}
                              className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
                              title="Edit Quotation"
                            >
                              <FaEdit size={16} />
                            </button>
                            <button
                              onClick={() => handlePrintQuotation(quotation)}
                              className="p-2 text-green-600 hover:bg-green-50 rounded-lg transition-colors"
                              title="Print Quotation"
                            >
                              <FaPrint size={16} />
                            </button>
                            <button
                              onClick={() => handleWhatsAppSend(quotation)}
                              className="p-2 text-green-500 hover:bg-green-50 rounded-lg transition-colors"
                              title="Send via WhatsApp"
                            >
                              <FaWhatsapp size={16} />
                            </button>
                            <button
                              onClick={() => handlePriceChangeCheck(quotation._id)}
                              className="p-2 text-purple-600 hover:bg-purple-50 rounded-lg transition-colors"
                              title="Check Price Changes"
                            >
                              <FaSync size={16} />
                            </button>
                            {quotation.versions && quotation.versions.length > 1 && (
                              <button
                                onClick={() => handleViewVersions(quotation)}
                                className="p-2 text-indigo-600 hover:bg-indigo-50 rounded-lg transition-colors"
                                title="View All Versions"
                              >
                                <FaArrowDown size={16} />
                              </button>
                            )}
                            <button
                              onClick={() => handleViewQuotation(quotation)}
                              className="p-2 text-indigo-600 hover:bg-indigo-50 rounded-lg transition-colors"
                              title="View Detailed Information"
                            >
                              <FaEye size={16} />
                            </button>
                          </div>
                        </div>

                        {/* Quotation Details Grid */}
                        <div className="grid grid-cols-2 lg:grid-cols-5 gap-4 mb-6">
                          <div className="bg-gray-50 rounded-lg p-3">
                            <div className="text-xs text-gray-500 uppercase tracking-wide mb-1">Sections</div>
                            <div className="text-lg font-semibold text-gray-800">
                              {quotation.sections?.length || 0}
                            </div>
                          </div>
                          
                          <div className="bg-gray-50 rounded-lg p-3">
                            <div className="text-xs text-gray-500 uppercase tracking-wide mb-1">Total Items</div>
                            <div className="text-lg font-semibold text-gray-800">
                              {quotation.sections?.reduce((acc, section) => acc + (section.items?.length || 0), 0) || 0}
                            </div>
                          </div>
                          
                          <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-lg p-3">
                            <div className="text-xs text-gray-500 uppercase tracking-wide mb-1">Total Amount</div>
                            <div className="text-lg font-bold text-green-600">
                              ₹{addCommas(quotation.totalAmount)}
                            </div>
                          </div>
                          
                          <div className="bg-gray-50 rounded-lg p-3">
                            <div className="text-xs text-gray-500 uppercase tracking-wide mb-1">Versions</div>
                            <div className="text-lg font-semibold text-gray-800">
                              {quotation.versions?.length || 1}
                            </div>
                          </div>
                          
                          <div className="bg-gray-50 rounded-lg p-3">
                            <div className="text-xs text-gray-500 uppercase tracking-wide mb-1">Reminders</div>
                            {quotationStatuses[quotation._id] ? (
                              <div className="flex flex-col space-y-1">
                                <div className="text-sm font-semibold text-gray-800">
                                  {quotationStatuses[quotation._id].completed}/{quotationStatuses[quotation._id].total}
                                </div>
                                <div className="flex space-x-1">
                                  <span className="px-2 py-1 bg-green-100 text-green-700 text-xs rounded">
                                    ✓ {quotationStatuses[quotation._id].completed}
                                  </span>
                                  <span className="px-2 py-1 bg-yellow-100 text-yellow-700 text-xs rounded">
                                    ⏳ {quotationStatuses[quotation._id].pending}
                                  </span>
                                </div>
                              </div>
                            ) : (
                              <div className="text-sm text-gray-500">Loading...</div>
                            )}
                          </div>
                        </div>

                        {/* Footer Information */}
                        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center pt-4 border-t border-gray-100">
                          <div className="flex flex-col sm:flex-row sm:items-center text-sm text-gray-600 space-y-1 sm:space-y-0 sm:space-x-4">
                            <div className="flex items-center">
                              <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                              </svg>
                              Created: {formatDate(quotation.createdAt)}
                            </div>
                            {quotation.updatedAt !== quotation.createdAt && (
                              <div className="flex items-center">
                                <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                                </svg>
                                Updated: {formatDate(quotation.updatedAt)}
                              </div>
                            )}
                            {quotation.createdBy?.name && (
                              <div className="flex items-center">
                                <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                </svg>
                                By: {quotation.createdBy.name}
                              </div>
                            )}
                          </div>
                          
                          {quotation.remarks && (
                            <div className="mt-2 sm:mt-0">
                              <span className="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded">
                                {quotation.remarks.length > 30 
                                  ? `${quotation.remarks.substring(0, 30)}...` 
                                  : quotation.remarks
                                }
                              </span>
                            </div>
                          )}
                        </div>

                        {/* Version Warning for Large Documents */}
                        {quotation.versions && quotation.versions.length > 10 && (
                          <div className="mt-3 p-3 bg-orange-50 border border-orange-200 rounded-lg">
                            <div className="flex items-center">
                              <svg className="w-5 h-5 text-orange-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
                              </svg>
                              <span className="text-sm text-orange-700 font-medium">
                                High version count detected - consider cleanup for better performance
                              </span>
                            </div>
                          </div>
                        )}
                      </>
                    ) : (
                      // List View - Compact Layout
                      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between space-y-3 lg:space-y-0">
                        <div className="flex-1">
                          <div className="flex items-center space-x-3">
                            <h3 className="text-lg font-bold text-gray-800">{quotation.id}</h3>
                            <span className={`px-2 py-1 rounded-full text-xs font-semibold ${getStatusColorClass(quotation.status)}`}>
                              {quotation.status}
                            </span>
                            {quotation.versions && quotation.versions.length > 1 && (
                              <span className="px-2 py-1 bg-blue-50 text-blue-700 text-xs font-medium rounded">
                                v{quotation.versions.length}
                              </span>
                            )}
                          </div>
                          <div className="flex items-center text-gray-600 mt-1">
                            <span className="font-medium">
                              {quotation.recipient?.name || quotation.recipient?.businessName || 'Unknown'}
                            </span>
                            <span className="mx-2">•</span>
                            <span>₹{addCommas(quotation.totalAmount)}</span>
                            <span className="mx-2">•</span>
                            <span>{quotation.sections?.length || 0} sections</span>
                            <span className="mx-2">•</span>
                            <span>{formatDate(quotation.createdAt)}</span>
                            {quotation.createdBy?.name && (
                              <>
                                <span className="mx-2">•</span>
                                <span>By: {quotation.createdBy.name}</span>
                              </>
                            )}
                          </div>
                        </div>
                        
                        <div className="flex items-center space-x-1">
                          <button
                            onClick={() => handleViewQuotation(quotation)}
                            className="p-2 text-indigo-600 hover:bg-indigo-50 rounded transition-colors"
                            title="View Detailed Information"
                          >
                            <FaEye size={14} />
                          </button>
                          <button
                            onClick={() => openEditQuotation(quotation)}
                            className="p-2 text-blue-600 hover:bg-blue-50 rounded transition-colors"
                            title="Edit"
                          >
                            <FaEdit size={14} />
                          </button>
                          <button
                            onClick={() => handlePrintQuotation(quotation)}
                            className="p-2 text-green-600 hover:bg-green-50 rounded transition-colors"
                            title="Print"
                          >
                            <FaPrint size={14} />
                          </button>
                          <button
                            onClick={() => handlePriceChangeCheck(quotation._id)}
                            className="p-2 text-purple-600 hover:bg-purple-50 rounded transition-colors"
                            title="Check Price Changes"
                          >
                            <FaSync size={14} />
                          </button>
                          {quotation.versions && quotation.versions.length > 1 && (
                            <button
                              onClick={() => handleViewVersions(quotation)}
                              className="p-2 text-indigo-600 hover:bg-indigo-50 rounded transition-colors"
                              title="View Versions"
                            >
                              <FaArrowDown size={14} />
                            </button>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-12">
                <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                <h3 className="mt-4 text-lg font-medium text-gray-900">No quotations found</h3>
                <p className="mt-2 text-gray-500">
                  {Object.values(filters).some(f => f && f !== 'grid' && f !== 'createdAt' && f !== 'desc') 
                    ? 'Try adjusting your filters to see more results.' 
                    : 'Get started by creating your first quotation.'
                  }
                </p>
                {Object.values(filters).some(f => f && f !== 'grid' && f !== 'createdAt' && f !== 'desc') && (
                  <button
                    onClick={resetFilters}
                    className="mt-4 px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors"
                  >
                    Clear Filters
                  </button>
                )}
              </div>
            )}

            {/* Pagination */}
            {quotationTotalPages > 1 && (
              <div className="flex flex-col sm:flex-row justify-center items-center mt-6 space-y-2 sm:space-y-0 sm:space-x-2">
                <button
                  onClick={() => handleQuotationPageChange(Math.max(1, quotationPage))}
                  disabled={quotationPage === 0}
                  className="w-full sm:w-auto px-3 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:opacity-50 text-sm"
                >
                  Previous
                </button>
                <div className="flex flex-wrap justify-center space-x-1">
                  {Array.from({ length: Math.min(quotationTotalPages, 5) }, (_, index) => {
                    const pageNum = quotationPage + index - 2;
                    if (pageNum < 0 || pageNum >= quotationTotalPages) return null;
                    return (
                      <button
                        key={pageNum}
                        onClick={() => handleQuotationPageChange(pageNum + 1)}
                        className={`px-3 py-2 rounded text-sm ${
                          pageNum === quotationPage
                            ? 'bg-blue-500 text-white'
                            : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                        }`}
                      >
                        {pageNum + 1}
                      </button>
                    );
                  })}
                </div>
                <button
                  onClick={() => handleQuotationPageChange(Math.min(quotationTotalPages, quotationPage + 2))}
                  disabled={quotationPage === quotationTotalPages - 1}
                  className="w-full sm:w-auto px-3 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:opacity-50 text-sm"
                >
                  Next
                </button>
              </div>
            )}
          </div>
        )}
      </div>

      </div>

      {/* Transfer Item Modal */}
      {transferItemModal.open && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50 p-4"
             onClick={() => setTransferItemModal({ open: false, sectionIndex: null, itemIndex: null })}>
          <div className={`rounded-xl shadow-2xl p-6 w-full max-w-sm ${isDarkMode ? 'bg-gray-800' : 'bg-white'}`}
               onClick={e => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-4">
              <h3 className={`text-lg font-bold flex items-center gap-2 ${isDarkMode ? 'text-gray-100' : 'text-gray-800'}`}>
                <svg className="w-5 h-5 text-cyan-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
                </svg>
                Transfer Item
              </h3>
              <button onClick={() => setTransferItemModal({ open: false, sectionIndex: null, itemIndex: null })}
                      className={`p-1 rounded-lg ${isDarkMode ? 'hover:bg-gray-700 text-gray-400' : 'hover:bg-gray-100 text-gray-500'}`}>
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <p className={`text-sm mb-4 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
              Move item {(transferItemModal.itemIndex ?? 0) + 1} from Section {(transferItemModal.sectionIndex ?? 0) + 1} to:
            </p>
            <div className="space-y-2">
              {form.sections.map((sec, idx) => (
                idx !== transferItemModal.sectionIndex && (
                  <button
                    key={idx}
                    type="button"
                    onClick={() => transferItem(transferItemModal.sectionIndex, transferItemModal.itemIndex, idx)}
                    className={`w-full text-left px-4 py-3 rounded-lg border transition-all duration-200 flex items-center justify-between ${
                      isDarkMode
                        ? 'border-gray-600 hover:bg-cyan-900/30 hover:border-cyan-500 text-gray-200'
                        : 'border-gray-200 hover:bg-cyan-50 hover:border-cyan-400 text-gray-700'
                    }`}
                  >
                    <div className="flex items-center gap-3">
                      <div className="flex items-center justify-center w-7 h-7 bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg shadow-sm">
                        <span className="text-white font-bold text-xs">{idx + 1}</span>
                      </div>
                      <span className="font-medium text-sm">{sec.name || `Section ${idx + 1}`}</span>
                    </div>
                    <span className={`text-xs ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>{sec.items.length} items</span>
                  </button>
                )
              ))}
            </div>
          </div>
        </div>
      )}

      <ItemSelectionModal
        isOpen={modalVisible.open}
        onClose={() => setModalVisible({ open: false, func: null })}
        onSelect={(item) => {
          if (modalVisible.func) modalVisible.func(item);
          setModalVisible({ open: false, func: null });
        }}
        onItemUpdated={applyUpdatedItem}
        isDarkMode={isDarkMode}
        user={user}
      />

      {/* Offer Type Modal - Ultra Compact */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-2"
        style={{ visibility: modalVisibleForOfferType.open ? 'visible' : 'hidden', zIndex: 9999 }}
        onClick={(e) => {
          // Close modal when clicking on overlay
          if (e.target === e.currentTarget) {
            setModalVisibleForOfferType({ open: false, func: null });
            setSelectedOfferTypeValue(null);
          }
        }}
      >
        <div
          className="qm-modal rounded-lg shadow-xl w-full max-w-xs mx-auto p-3"
          style={{ maxHeight: '85vh', overflow: 'visible', position: 'relative', zIndex: 10000, backgroundColor: isDarkMode ? '#1f2937' : '#ffffff', color: isDarkMode ? '#f3f4f6' : undefined }}
          onClick={(e) => e.stopPropagation()} // Prevent clicks inside modal from closing it
        >
          <div className="flex justify-between items-center mb-2">
            <div>
              <h3 className="text-sm font-semibold" style={{ color: isDarkMode ? '#f3f4f6' : '#1f2937' }}>Select Offer Type</h3>
              <p className="text-xs" style={{ color: isDarkMode ? '#9ca3af' : '#4b5563' }}>↑↓ Navigate • Enter Select • Esc Close</p>
            </div>
            <button
              className="p-2 -m-1 rounded-full transition-all duration-150"
              style={{ color: isDarkMode ? '#9ca3af' : '#6b7280', backgroundColor: 'transparent', WebkitTapHighlightColor: 'transparent', minWidth: '32px', minHeight: '32px', touchAction: 'manipulation' }}
              onMouseEnter={e => e.currentTarget.style.backgroundColor = isDarkMode ? '#374151' : '#f3f4f6'}
              onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setModalVisibleForOfferType({ open: false, func: null });
                setSelectedOfferTypeValue(null);
              }}
              onTouchEnd={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setModalVisibleForOfferType({ open: false, func: null });
                setSelectedOfferTypeValue(null);
              }}
              aria-label="Close"
            >
              <FaTimes size={14} />
            </button>
          </div>
          <div className="mb-2" style={{ position: 'relative', zIndex: 10001 }}>
            <Select
              ref={offerTypeSelectRef}
              value={selectedOfferTypeValue}
              onChange={(selectedOption) => {
                console.log('Offer type selected:', selectedOption);
                setSelectedOfferTypeValue(selectedOption);
                
                // Force the menu to close after selection
                if (offerTypeSelectRef.current && offerTypeSelectRef.current.blur) {
                  setTimeout(() => {
                    offerTypeSelectRef.current.blur();
                  }, 50);
                }
              }}
              options={offerType ? offerType.map((oType, index) => ({
                value: oType,
                label: oType.toUpperCase()
              })) : []}
              className="react-select-container"
              classNamePrefix="react-select"
              placeholder="Choose offer type"
              isSearchable={false}
              autoFocus={true}
              openMenuOnFocus={true}
              closeMenuOnSelect={true}
              blurInputOnSelect={true}
              styles={{
                ...customSelectStyles,
                control: (provided, state) => ({
                  ...provided,
                  minHeight: '44px',
                  fontSize: '14px',
                  zIndex: 10001,
                  border: state.isFocused ? `2px solid ${isDarkMode ? '#60a5fa' : '#3b82f6'}` : `1px solid ${isDarkMode ? '#4b5563' : '#d1d5db'}`,
                  borderRadius: '0.5rem',
                  boxShadow: state.isFocused ? `0 0 0 1px ${isDarkMode ? '#60a5fa' : '#3b82f6'}` : 'none',
                  backgroundColor: isDarkMode ? '#374151' : 'white',
                  touchAction: 'manipulation',
                  WebkitTapHighlightColor: 'transparent'
                }),
                menu: (provided) => ({
                  ...provided,
                  zIndex: 10002,
                  position: 'absolute',
                  top: '100%',
                  left: 0,
                  right: 0,
                  backgroundColor: isDarkMode ? '#1f2937' : 'white',
                  border: `1px solid ${isDarkMode ? '#374151' : '#e5e7eb'}`,
                  borderRadius: '0.5rem',
                  boxShadow: '0 10px 15px -3px rgba(0,0,0,0.3), 0 4px 6px -2px rgba(0,0,0,0.15)',
                  maxHeight: '200px',
                  overflow: 'auto',
                  touchAction: 'manipulation',
                  WebkitOverflowScrolling: 'touch'
                }),
                menuList: (provided) => ({
                  ...provided,
                  padding: '4px',
                  maxHeight: '200px',
                  backgroundColor: isDarkMode ? '#1f2937' : 'white',
                }),
                singleValue: (provided) => ({
                  ...provided,
                  textTransform: 'uppercase',
                  fontWeight: '600',
                  fontSize: '14px',
                  color: isDarkMode ? '#f3f4f6' : '#374151',
                }),
                option: (provided, state) => ({
                  ...provided,
                  textTransform: 'uppercase',
                  backgroundColor: state.isSelected ? '#3b82f6' : state.isFocused ? (isDarkMode ? '#374151' : '#e5f3ff') : (isDarkMode ? '#1f2937' : 'white'),
                  color: state.isSelected ? 'white' : (isDarkMode ? '#d1d5db' : '#374151'),
                  fontSize: '14px',
                  padding: '12px 16px',
                  cursor: 'pointer',
                  minHeight: '44px',
                  display: 'flex',
                  alignItems: 'center',
                  touchAction: 'manipulation',
                  WebkitTapHighlightColor: 'transparent',
                }),
                valueContainer: (provided) => ({
                  ...provided,
                  padding: '8px 12px',
                }),
                indicatorsContainer: (provided) => ({
                  ...provided,
                  padding: '8px',
                }),
                placeholder: (provided) => ({
                  ...provided,
                  color: isDarkMode ? '#6b7280' : '#9ca3af',
                  fontSize: '14px',
                }),
                input: (provided) => ({
                  ...provided,
                  color: isDarkMode ? '#f3f4f6' : '#374151',
                }),
              }}
            />
          </div>
          <div className="flex gap-2 mt-3">
            <button
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                console.log('Select button clicked:', { selectedOfferTypeValue, modalVisibleForOfferType });
                if (selectedOfferTypeValue) {
                  console.log('Calling modalVisibleForOfferType.func with:', selectedOfferTypeValue.value);
                  modalVisibleForOfferType.func(selectedOfferTypeValue.value);
                  setModalVisibleForOfferType({ open: false, func: null });
                  setSelectedOfferTypeValue(null);
                } else {
                  console.log('No offer type selected, showing warning');
                  Swal.fire({
                    title: 'Selection Required',
                    text: 'Please select an offer type before continuing.',
                    icon: 'warning',
                    confirmButtonColor: '#3b82f6'
                  });
                }
              }}
              onTouchEnd={(e) => {
                e.preventDefault();
                e.stopPropagation();
                console.log('Select button touch end:', { selectedOfferTypeValue, modalVisibleForOfferType });
                if (selectedOfferTypeValue) {
                  console.log('Touch: Calling modalVisibleForOfferType.func with:', selectedOfferTypeValue.value);
                  modalVisibleForOfferType.func(selectedOfferTypeValue.value);
                  setModalVisibleForOfferType({ open: false, func: null });
                  setSelectedOfferTypeValue(null);
                } else {
                  console.log('Touch: No offer type selected, showing warning');
                  Swal.fire({
                    title: 'Selection Required',
                    text: 'Please select an offer type before continuing.',
                    icon: 'warning',
                    confirmButtonColor: '#3b82f6'
                  });
                }
              }}
              className={`flex-1 bg-blue-500 text-white py-3 px-4 rounded-md hover:bg-blue-600 active:bg-blue-700 disabled:opacity-50 disabled:bg-gray-400 text-sm font-medium transition-all duration-150 min-h-[44px] flex items-center justify-center ${!selectedOfferTypeValue ? 'cursor-not-allowed' : 'cursor-pointer'}`}
              disabled={!selectedOfferTypeValue}
              style={{ 
                WebkitTapHighlightColor: 'transparent',
                touchAction: 'manipulation'
              }}
            >
              Select
            </button>
            <button
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setModalVisibleForOfferType({ open: false, func: null });
                setSelectedOfferTypeValue(null);
              }}
              onTouchEnd={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setModalVisibleForOfferType({ open: false, func: null });
                setSelectedOfferTypeValue(null);
              }}
              className="flex-1 py-3 px-4 rounded-md text-sm font-medium transition-all duration-150 min-h-[44px] flex items-center justify-center"
              style={{ 
                WebkitTapHighlightColor: 'transparent',
                touchAction: 'manipulation',
                backgroundColor: isDarkMode ? '#374151' : '#d1d5db',
                color: isDarkMode ? '#d1d5db' : '#374151',
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>

      {/* Status Change Modal */}
      {statusDialog && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="qm-modal bg-white rounded-lg shadow-xl max-w-md w-full">
            <div className="flex justify-between items-center px-6 py-4 border-b">
              <h3 className="text-lg font-semibold text-gray-800">Change Status</h3>
              <button
                onClick={() => setStatusDialog(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                <FaTimes size={18} />
              </button>
            </div>
            
            <div className="p-6">
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Select Status
                </label>
                <Select
                  value={{ value: selectedStatus, label: selectedStatus }}
                  onChange={(selectedOption) => setSelectedStatus(selectedOption.value)}
                  options={[
                    { value: 'PENDING', label: 'Pending' },
                    { value: 'APPROVED', label: 'Approved' },
                    { value: 'REJECTED', label: 'Rejected' }
                  ]}
                  className="react-select-container"
                  classNamePrefix="react-select"
                  placeholder="Select Status"
                  isSearchable={false}
                  styles={customSelectStyles}
                />
              </div>
              
              <div className="flex space-x-3">
                <button
                  onClick={async () => {
                    try {
                      await axios.put(
                        `${process.env.REACT_APP_API_BASE_URL}/quotation-new/status/${selectedQuotationId}`,
                        { status: selectedStatus }
                      );
                      Swal.fire('Success', 'Status updated successfully', 'success');
                      setStatusDialog(false);
                      fetchQuotations();
                    } catch (error) {
                      console.error('Error updating status:', error);
                      Swal.fire('Error', 'Failed to update status', 'error');
                    }
                  }}
                  className="flex-1 bg-blue-500 text-white py-2 rounded-lg hover:bg-blue-600"
                >
                  Update
                </button>
                <button
                  onClick={() => setStatusDialog(false)}
                  className="flex-1 bg-gray-300 text-gray-700 py-2 rounded-lg hover:bg-gray-400"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Multi-Version View Dialog */}
      {versionsDialog.open && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="qm-modal bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[80vh] overflow-y-auto">
            <div className="flex justify-between items-center px-6 py-4 border-b sticky top-0 bg-white">
              <div className="flex items-center gap-4">
                <h3 className="text-lg font-semibold text-gray-800">All Versions - {versionsDialog.quotation?.id}</h3>
                {sizeInfo && (
                  <div className={`text-sm px-2 py-1 rounded ${
                    sizeInfo.documentSize.isNearLimit ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'
                  }`}>
                    Size: {sizeInfo.documentSize.mb} MB
                  </div>
                )}
              </div>
              <div className="flex items-center gap-2">
                {!versionManagementMode ? (
                  <button
                    onClick={() => setVersionManagementMode(true)}
                    className="px-3 py-1 text-sm bg-orange-500 text-white rounded hover:bg-orange-600"
                    title="Manage versions to reduce document size"
                  >
                    Manage Versions
                  </button>
                ) : (
                  <div className="flex items-center gap-2">
                    <span className="text-sm text-gray-600">{selectedVersions.length} selected</span>
                    <button
                      onClick={deleteSelectedVersions}
                      disabled={selectedVersions.length === 0}
                      className="px-3 py-1 text-sm bg-red-500 text-white rounded hover:bg-red-600 disabled:opacity-50"
                    >
                      Delete Selected
                    </button>
                    <button
                      onClick={() => {
                        setVersionManagementMode(false);
                        setSelectedVersions([]);
                      }}
                      className="px-3 py-1 text-sm bg-gray-500 text-white rounded hover:bg-gray-600"
                    >
                      Cancel
                    </button>
                  </div>
                )}
                <button
                  onClick={() => setVersionsDialog({ open: false, quotation: null })}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <FaTimes size={18} />
                </button>
              </div>
            </div>
            
            <div className="p-6">
              {/* Size Information Panel */}
              {sizeInfo && (
                <div className={`mb-6 p-4 rounded-lg border ${
                  sizeInfo.documentSize.isNearLimit ? 'bg-red-50 border-red-200' : 'bg-blue-50 border-blue-200'
                }`}>
                  <h4 className="font-semibold text-gray-800 mb-2">Document Size Information</h4>
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                    <div>
                      <span className="text-gray-600">Total Size:</span>
                      <div className="font-medium">{sizeInfo.documentSize.mb} MB</div>
                    </div>
                    <div>
                      <span className="text-gray-600">Versions:</span>
                      <div className="font-medium">{sizeInfo.totalVersions}</div>
                    </div>
                    <div>
                      <span className="text-gray-600">Versions Size:</span>
                      <div className="font-medium">{sizeInfo.versionsSize.mb} MB</div>
                    </div>
                    <div>
                      <span className="text-gray-600">Status:</span>
                      <div className={`font-medium ${
                        sizeInfo.documentSize.isNearLimit ? 'text-red-600' : 'text-green-600'
                      }`}>
                        {sizeInfo.documentSize.isNearLimit ? 'Near Limit' : 'Good'}
                      </div>
                    </div>
                  </div>
                  {sizeInfo.recommendations.shouldCleanup && (
                    <div className="mt-3 p-3 bg-yellow-50 border border-yellow-200 rounded">
                      <p className="text-sm text-yellow-800">
                        <strong>Recommendation:</strong> Consider deleting older versions to reduce document size.
                        {sizeInfo.recommendations.suggestedDeletions.length > 0 && (
                          <span> Suggested versions to delete: {sizeInfo.recommendations.suggestedDeletions.join(', ')}</span>
                        )}
                      </p>
                    </div>
                  )}
                </div>
              )}

              <div className="space-y-4">
                {/* Current Version */}
                <div className="p-4 border-2 border-blue-200 rounded-lg bg-blue-50">
                  <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-3">
                    <div>
                      <h4 className="text-md font-semibold text-blue-800">
                        Current Version {versionsDialog.quotation?.versions?.length || 1}
                      </h4>
                      <p className="text-sm text-gray-600">
                        Created: {new Date(versionsDialog.quotation?.updatedAt).toLocaleString()}
                      </p>
                    </div>
                    <div className="mt-2 sm:mt-0 flex flex-wrap gap-2">
                      <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColorClass(versionsDialog.quotation?.status)}`}>
                        {versionsDialog.quotation?.status}
                      </span>
                      <button
                        onClick={() => handlePrintQuotation(versionsDialog.quotation)}
                        className="px-3 py-1 text-xs bg-green-500 text-white rounded hover:bg-green-600"
                      >
                        Print
                      </button>
                    </div>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-sm">
                    <div>
                      <span className="font-medium text-gray-700">Sections:</span>
                      <span className="ml-1">{versionsDialog.quotation?.sections?.length || 0}</span>
                    </div>
                    <div>
                      <span className="font-medium text-gray-700">Total Items:</span>
                      <span className="ml-1">
                        {versionsDialog.quotation?.sections?.reduce((acc, section) => acc + (section.items?.length || 0), 0) || 0}
                      </span>
                    </div>
                    <div>
                      <span className="font-medium text-gray-700">Amount:</span>
                      <span className="ml-1 font-medium">₹{addCommas(versionsDialog.quotation?.totalAmount)}</span>
                    </div>
                  </div>
                  {versionsDialog.quotation?.remarks && (
                    <div className="mt-2 pt-2 border-t border-blue-200">
                      <span className="text-sm font-medium text-gray-700">Remarks: </span>
                      <span className="text-sm text-gray-600">{versionsDialog.quotation.remarks}</span>
                    </div>
                  )}
                </div>

                {/* Previous Versions */}
                {versionsDialog.quotation?.versions?.slice().reverse().map((version, index) => {
                  const versionNumber = versionsDialog.quotation.versions.length - index;
                  const versionSizeInfo = sizeInfo?.versionSizes?.find(v => v.versionNumber === versionNumber);
                  const isSelected = selectedVersions.includes(versionNumber);
                  const canDelete = versionNumber !== 1; // Cannot delete version 1
                  
                  return (
                    <div key={version._id} className={`p-4 border rounded-lg ${
                      isSelected ? 'bg-red-50 border-red-300' : 'bg-gray-50 border-gray-200'
                    }`}>
                      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-3">
                        <div className="flex items-start gap-3">
                          {versionManagementMode && canDelete && (
                            <input
                              type="checkbox"
                              checked={isSelected}
                              onChange={() => handleVersionSelection(versionNumber)}
                              className="mt-1"
                            />
                          )}
                          <div>
                            <h4 className="text-md font-medium text-gray-800">
                              Version {versionNumber}
                              {versionSizeInfo && (
                                <span className="ml-2 text-xs text-gray-500">
                                  ({versionSizeInfo.sizeMB} MB)
                                </span>
                              )}
                            </h4>
                            <p className="text-sm text-gray-600">
                              Created: {new Date(version.createdAt).toLocaleString()}
                            </p>
                            {version.reason && (
                              <p className="text-sm text-gray-500">Reason: {version.reason}</p>
                            )}
                            {versionNumber === 1 && (
                              <p className="text-xs text-blue-600">Original version (cannot be deleted)</p>
                            )}
                          </div>
                        </div>
                        <div className="mt-2 sm:mt-0 flex gap-2">
                          <span className="px-3 py-1 text-xs bg-gray-200 text-gray-700 rounded">
                            Version {versionNumber}
                          </span>
                          <button
                            onClick={() => handlePrintVersion(versionsDialog.quotation._id, versionNumber)}
                            className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600"
                            title="Print this version"
                          >
                            Print
                          </button>
                        </div>
                      </div>
                      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-sm">
                        <div>
                          <span className="font-medium text-gray-700">Sections:</span>
                          <span className="ml-1">{version.quotationData?.sections?.length || 0}</span>
                        </div>
                        <div>
                          <span className="font-medium text-gray-700">Total Items:</span>
                          <span className="ml-1">
                            {version.quotationData?.sections?.reduce((acc, section) => acc + (section.items?.length || 0), 0) || 0}
                          </span>
                        </div>
                        <div>
                          <span className="font-medium text-gray-700">Amount:</span>
                          <span className="ml-1 font-medium">₹{addCommas(version.quotationData?.totalAmount || 0)}</span>
                        </div>
                      </div>
                      {version.quotationData?.remarks && (
                        <div className="mt-2 pt-2 border-t border-gray-200">
                          <span className="text-sm font-medium text-gray-700">Remarks: </span>
                          <span className="text-sm text-gray-600">{version.quotationData.remarks}</span>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Enhanced Reminders Dialog */}
      {remindersDialog.open && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="qm-modal bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[70vh] overflow-y-auto">
            <div className="flex justify-between items-center px-6 py-4 border-b sticky top-0 bg-white">
              <h3 className="text-lg font-semibold text-gray-800">Reminders - {remindersDialog.quotation?.id}</h3>
              <button
                onClick={() => setRemindersDialog({ open: false, quotation: null })}
                className="text-gray-500 hover:text-gray-700"
              >
                <FaTimes size={18} />
              </button>
            </div>
            
            <div className="p-6">
              {reminders.length > 0 ? (
                <div className="space-y-4">
                  {reminders.map((reminder) => (
                    <div key={reminder._id} className="p-4 border rounded-lg bg-gray-50">
                      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start mb-3">
                        <div className="flex-1">
                          <h4 className="text-md font-medium text-gray-800">{reminder.title || reminder.message}</h4>
                          {reminder.description && (
                            <p className="text-sm text-gray-600 mt-1">{reminder.description}</p>
                          )}
                          <div className="flex flex-wrap gap-3 mt-2 text-sm text-gray-500">
                            <span>Due: {new Date(reminder.dueDate || reminder.date).toLocaleDateString()}</span>
                            {(reminder.priority || reminder.details?.priority) && (
                              <span>Priority: {reminder.priority || reminder.details?.priority}</span>
                            )}
                            {reminder.completedAt && (
                              <span>Completed: {new Date(reminder.completedAt).toLocaleDateString()}</span>
                            )}
                          </div>
                        </div>
                        <div className="mt-2 sm:mt-0 sm:ml-4 flex flex-col space-y-2">
                          <span className={`px-2 py-1 rounded-full text-xs font-medium text-center ${
                            reminder.status === 'COMPLETED' ? 'bg-green-100 text-green-800' :
                            reminder.status === 'CANCELLED' ? 'bg-red-100 text-red-800' :
                            'bg-yellow-100 text-yellow-800'
                          }`}>
                            {reminder.status}
                          </span>
                          {reminder.status === 'PENDING' && (
                            <div className="flex flex-col space-y-1">
                              <button
                                onClick={() => {
                                  const version = prompt('Enter version number for completion:');
                                  if (version) {
                                    updateReminderStatus(reminder._id, 'COMPLETED', version);
                                  }
                                }}
                                className="px-2 py-1 text-xs bg-green-500 text-white rounded hover:bg-green-600"
                              >
                                Mark Complete
                              </button>
                              <button
                                onClick={() => updateReminderStatus(reminder._id, 'CANCELLED')}
                                className="px-2 py-1 text-xs bg-red-500 text-white rounded hover:bg-red-600"
                              >
                                Cancel
                              </button>
                              <button
                                onClick={() => handleReFollowUp(reminder)}
                                className="px-2 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600"
                              >
                                Re-follow Up
                              </button>
                            </div>
                          )}
                          {Array.isArray(reminder.details?.items) && reminder.details.items.length > 0 && (
                            <button
                              onClick={() =>
                                Swal.fire({
                                  title: 'Items',
                                  html:
                                    '<div class="text-left">' +
                                    reminder.details.items
                                      .map(
                                        (i) =>
                                          `<div class="flex justify-between py-1 border-b"><span>${i.name || i.key}</span><span>${i.status}</span></div>`,
                                      )
                                      .join('') +
                                    '</div>',
                                })
                              }
                              className="px-2 py-1 text-xs bg-gray-500 text-white rounded hover:bg-gray-600"
                            >
                              Items
                            </button>
                          )}
                        </div>
                      </div>
                      {(reminder.remarks || reminder.notes) && (
                        <div className="mt-2 pt-2 border-t border-gray-200">
                          <span className="text-sm font-medium text-gray-700">Notes: </span>
                          <span className="text-sm text-gray-600">{reminder.remarks || reminder.notes}</span>
                        </div>
                      )}
                      {reminder.completedVersion && (
                        <div className="mt-1">
                          <span className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded">
                            Completed in Version {reminder.completedVersion}
                          </span>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-8 text-gray-500">
                  No reminders found for this quotation
                </div>
              )}
            </div>
          </div>
        </div>
      )}
        </div>

      {/* Re-Follow-Up Dialog */}
      {reFollowUpDialog.open && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="qm-modal bg-white rounded-lg shadow-xl max-w-md w-full">
            <div className="flex justify-between items-center px-6 py-4 border-b">
              <h3 className="text-lg font-semibold text-gray-800">Create Follow-Up Reminder</h3>
              <button
                onClick={() => {
                  setReFollowUpDialog({ open: false, reminder: null });
                  setReFollowUpData({ followUpDate: '', priority: 'MEDIUM', notes: '' });
                }}
                className="text-gray-500 hover:text-gray-700"
              >
                <FaTimes size={18} />
              </button>
            </div>
            
            <div className="p-6">
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Follow-up Date *
                </label>
                <input
                  type="date"
                  required
                  className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  onChange={(e) => setReFollowUpData({ ...reFollowUpData, followUpDate: e.target.value })}
                />
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Priority
                </label>
                <Select
                  value={reFollowUpData.priority ? { value: reFollowUpData.priority, label: reFollowUpData.priority } : null}
                  onChange={(selectedOption) => setReFollowUpData({ ...reFollowUpData, priority: selectedOption?.value || 'MEDIUM' })}
                  options={[
                    { value: 'LOW', label: 'Low' },
                    { value: 'MEDIUM', label: 'Medium' },
                    { value: 'HIGH', label: 'High' }
                  ]}
                  className="react-select-container"
                  classNamePrefix="react-select"
                  placeholder="Select Priority"
                  defaultValue={{ value: 'MEDIUM', label: 'Medium' }}
                  isSearchable={false}
                  styles={customSelectStyles}
                />
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Completion Notes *
                </label>
                <textarea
                  required
                  className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  rows="3"
                  onChange={(e) => setReFollowUpData({ ...reFollowUpData, notes: e.target.value })}
                  placeholder="Enter completion notes for the current reminder..."
                ></textarea>
              </div>
              <div className="flex space-x-3">
                <button
                  onClick={() => {
                    if (reFollowUpData.followUpDate && reFollowUpData.notes) {
                      submitReFollowUp(reFollowUpData);
                    } else {
                      Swal.fire('Error', 'Please fill all required fields', 'error');
                    }
                  }}
                  className="flex-1 bg-blue-500 text-white py-2 rounded-lg hover:bg-blue-600"
                >
                  Create Follow-Up
                </button>
                <button
                  onClick={() => {
                    setReFollowUpDialog({ open: false, reminder: null });
                    setReFollowUpData({ followUpDate: '', priority: 'MEDIUM', notes: '' });
                  }}
                  className="flex-1 bg-gray-300 text-gray-700 py-2 rounded-lg hover:bg-gray-400"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>

      )}

      {/* Size Warning Dialog */}
      {sizeWarningDialog.open && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="qm-modal bg-white rounded-lg shadow-xl max-w-md w-full">
            <div className="flex justify-between items-center px-6 py-4 border-b">
              <h3 className="text-lg font-semibold text-red-600">Document Size Limit Exceeded</h3>
              <button
                onClick={() => setSizeWarningDialog({ open: false, quotation: null })}
                className="text-gray-500 hover:text-gray-700"
              >
                <FaTimes size={18} />
              </button>
            </div>
            
            <div className="p-6">
              <div className="mb-4">
                <div className="flex items-center mb-2">
                  <div className="w-8 h-8 bg-red-100 rounded-full flex items-center justify-center mr-3">
                    <svg className="w-5 h-5 text-red-600" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-medium text-gray-900">MongoDB Size Limit Reached</h4>
                    <p className="text-sm text-gray-600">The quotation document has exceeded the 16MB limit</p>
                  </div>
                </div>
                
                <div className="bg-gray-50 p-3 rounded-lg">
                  <p className="text-sm text-gray-700 mb-2">
                    <strong>Quotation:</strong> {sizeWarningDialog.quotation?.id}
                  </p>
                  <p className="text-sm text-gray-700">
                    This typically happens when there are too many versions stored. You can resolve this by deleting older versions that are no longer needed.
                  </p>
                </div>
              </div>
              
              <div className="flex gap-3">
                <button
                  onClick={() => {
                    setSizeWarningDialog({ open: false, quotation: null });
                    if (sizeWarningDialog.quotation) {
                      handleViewVersions(sizeWarningDialog.quotation);
                      setVersionManagementMode(true);
                    }
                  }}
                  className="flex-1 bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 font-medium"
                >
                  Manage Versions
                </button>
                <button
                  onClick={() => setSizeWarningDialog({ open: false, quotation: null })}
                  className="flex-1 bg-gray-300 text-gray-700 py-2 px-4 rounded-md hover:bg-gray-400 font-medium"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Recipient Selection Modal */}
      <MasterSelection
        isOpen={showRecipientModal}
        onClose={() => setShowRecipientModal(false)}
        onSelect={handleRecipientSelect}
        allowedTypes={['Customer', 'Dealer', 'Reference']}
        defaultType={form.recipientType}
        title="Select Recipient"
      />
    </div>
  );
};

export default QuotationNewManagement;